export const fr = {
  common: {
    appName: "AI Commerce OS",
    tagline: "Votre établissement, disponible 24h/24, 7j/7",
    login: "Connexion",
    register: "Démarrer",
    logout: "Déconnexion",
    dashboard: "Tableau de bord",
    backHome: "Retour à l'accueil",
    save: "Enregistrer",
    cancel: "Annuler",
    delete: "Supprimer",
    edit: "Modifier",
    copy: "Copier",
    refresh: "Actualiser",
    confirm: "Confirmer",
    loading: "Chargement…",
    error: "Erreur",
    success: "Succès",
    email: "E-mail",
    password: "Mot de passe",
    name: "Nom",
    optional: "(optionnel)",
    required: "Obligatoire",
    activate: "Activer",
    deactivate: "Désactiver",
    active: "Actif",
    inactive: "Inactif",
    yes: "Oui",
    no: "Non",
    search: "Rechercher",
    learnMore: "En savoir plus",
    perMonth: "/ mois",
    totalMonth: "Total / mois",
  },
  nav: {
    overview: "Vue d'ensemble",
    conversations: "Conversations",
    bookings: "Réservations",
    resources: "Ressources",
    services: "Prestations",
    kiosk: "Mode kiosque",
    blacklist: "Listes clients",
    orders: "Commandes",
    clients: "Clients",
    analytics: "Analytics",
    settings: "Paramètres",
    publicPage: "Page publique",
    team: "Équipe",
    audit: "Journal d'audit",
    modules: "Module et Voix",
    tenants: "Établissements",
    verticals: "Verticales",
    platform: "Plateforme",
    pricing: "Tarifs",
  },
  kiosk: {
    title: "Réservations du jour",
    fullscreenAria: "Plein écran",
    exitAria: "Quitter le mode kiosque",
    upcoming: "À venir",
    finished: "Terminées",
    covers: "Couverts (à venir)",
    resources: "Ressources",
    empty: "Aucune réservation",
    emptyHint: "Profitez du calme ☕",
    inProgress: "● En cours",
    loading: "Chargement…",
    footer: "Auto-rafraîchissement toutes les 30 secondes · Échap pour quitter",
    today: "Aujourd'hui",
    coversShort: "COUVERT",
    coversShortPlural: "COUVERTS",
  },
  landing: {
    heroTitle: "Un établissement disponible 24/7 — sans embaucher.",
    heroSubtitle:
      "AI Commerce OS répond à vos appels, traite vos réservations, prend vos commandes et encaisse vos paiements. Vous gardez le contrôle, l'IA gère le reste.",
    heroCta: "Démarrer mon essai",
    heroCtaSecondary: "Voir une démo",
    heroBullet1: "Sans engagement",
    heroBullet2: "Configuration en 1 heure",
    heroBullet3: "Hébergement européen",
    moduleSectionLabel: "9 modules. Une plateforme.",
    moduleSectionTitle: "Activez exactement ce qu'il vous faut.",
    moduleSectionBody:
      "Chaque métier a ses besoins. Chaque module est indépendant. Activez-les un par un, la facturation s'adapte en temps réel.",
    verticalsLabel: "Conçue pour votre métier",
    verticalsTitle: "Restaurant, hôtel, médecin, salon — un seul socle.",
    pricingLabel: "Tarification claire",
    pricingTitle: "Vous ne payez que ce que vous activez.",
    pricingBaseLabel: "Base — toujours incluse",
    pricingBaseDescription: "Fondations + page publique + équipe.",
    ctaFinalTitle: "Prêt à reprendre le contrôle ?",
    ctaFinalBody:
      "Configurez votre établissement en moins d'une heure. Aucun engagement.",
    footerRights: "Tous droits réservés.",
    liveCallsBadge: "+312 appels traités cette semaine",
    modulesSelected: "{count} module{s} sélectionné{s}.",
    heroLiveCallTitle: "Appel en cours — Le Bistrot du Coin",
    heroLiveCallSub: "Réservation 4 pers. · 20h30 · confirmée par l'IA",
    heroLiveCallBadge: "Live",
  },
  auth: {
    loginTitle: "Connexion",
    loginSubtitle: "Accédez à votre tableau de bord.",
    loginButton: "Se connecter",
    registerTitle: "Créez votre établissement",
    registerSubtitle: "3 étapes. 5 minutes. Aucun engagement.",
    registerButton: "Créer mon compte",
    forgotPassword: "Mot de passe oublié ?",
    magicLink: "Recevoir un lien magique",
    noAccount: "Pas encore de compte ?",
    hasAccount: "Déjà inscrit ?",
    chooseVertical: "Choisissez votre métier",
    businessInfo: "Votre établissement",
    accountInfo: "Votre compte",
    businessName: "Nom de l'établissement",
    slug: "URL publique",
    slugHelp: "Disponible à l'adresse",
    contactEmail: "E-mail de contact",
    contactPhone: "Téléphone",
    country: "Pays",
    language: "Langue par défaut",
    ownerName: "Votre nom",
    next: "Étape suivante",
    previous: "Précédent",
    finish: "Créer mon établissement",
    forgotTitle: "Réinitialiser mon mot de passe",
    forgotBody: "Indiquez votre e-mail. Vous recevrez un lien de réinitialisation.",
    forgotButton: "Envoyer le lien",
    forgotSent: "Si un compte existe, un lien a été envoyé.",
    magicTitle: "Lien magique",
    magicBody: "Recevez un lien de connexion par e-mail.",
    magicButton: "Recevoir le lien",
    magicSent: "Vérifiez votre boîte mail (et la console serveur en dev).",
    resetTitle: "Nouveau mot de passe",
    resetButton: "Mettre à jour",
    confirmPasswordLabel: "Confirmer",
    showPasswordAria: "Afficher",
    mismatch: "Les deux mots de passe ne correspondent pas.",
    invalidToken: "Lien invalide ou expiré.",
    modulesCount: "{count} modules",
    medicalMode: "Mode médical",
    accountCreated: "Compte créé — vérifiez votre boîte mail.",
    establishmentCreated: "Établissement créé !",
    yourSlugPlaceholder: "votre-slug",
    slugAvailable: "✓ disponible",
    slugTaken: "✗ déjà pris",
    countryFrance: "France",
    countryBelgium: "Belgique",
    countrySwitzerland: "Suisse",
    countryLuxembourg: "Luxembourg",
    langFrench: "Français",
    langEnglish: "English",
    summary: "Récapitulatif",
    preactivatedModules: "Modules pré-activés : ",
    acceptTermsPrefix: "J'accepte les",
    termsLink: "Conditions Générales d'Utilisation",
    acceptPrivacyPrefix: "J'ai lu et j'accepte la",
    privacyLink: "Politique de confidentialité",
    loginSuccess: "Connexion réussie",
    emailNotConfirmed: "E-mail non confirmé — vérifiez votre boîte de réception.",
    demoAccountsTitle: "Comptes de démo — un par rôle",
    demoPasswordShared: "Mot de passe partagé : ",
    forgotDevModeLabel: "Mode développeur local (FORGOT_PASSWORD_DEV_LINK) — ",
  },
  moduleLocked: {
    body: "Ce module n'est pas encore activé pour votre établissement. Activez-le depuis les paramètres pour accéder à ses fonctionnalités.",
    cta: "Activer le module →",
  },
  welcomeModal: {
    overline: "Bienvenue sur AICommerceOS",
    title: "{count} étapes avant de passer en direct",
    body: "Votre établissement est créé, mais votre assistant IA n'est pas encore opérationnel. Voici ce qu'il reste à configurer :",
    requiredTag: "Requis",
    optionalTag: "Optionnel",
    exploreFirst: "Explorer d'abord",
    launchCta: "Lancer la configuration",
  },
  notFound: {
    seoTitle: "Page introuvable",
    overline: "Erreur 404",
    body: "Cette page n'existe pas ou plus. Vérifiez l'adresse ou revenez à l'accueil.",
    cta: "Retour à l'accueil",
  },
  dashboard: {
    welcome: "Bonjour",
    statusPending: "À publier",
    statusActive: "En ligne",
    statusSuspended: "Suspendu",
    publishCta: "Publier mon établissement",
    publishedToast: "Établissement publié !",
    publishFailedToast: "Échec de publication",
    overviewSubtitle: "Pilotage en temps réel de votre activité.",
    activeModules: "Modules actifs",
    monthlyTotal: "Coût mensuel",
    publicUrl: "URL publique",
    members: "Membres de l'équipe",
    moduleManager: "Gestion des modules",
    moduleManagerSub: "Activez ou désactivez chaque module. La facturation s'ajuste en temps réel.",
    publicPageTitle: "Page publique",
    publicPageSub: "Configurez les blocs visibles par vos clients.",
    blockType: {
      hero: "Bannière d'accueil",
      about: "À propos",
      services: "Services",
      hours: "Horaires",
      location: "Localisation",
      faq: "FAQ",
      testimonials: "Témoignages",
    },
    settingsTitle: "Paramètres",
    settingsSub: "Coordonnées, horaires, branding.",
    teamTitle: "Équipe",
    teamSub: "Gérez vos collaborateurs et leurs accès.",
    addMember: "Ajouter un membre",
    auditTitle: "Journal d'audit",
    auditSub: "Toutes les actions sont tracées (append-only).",
  },
  superAdmin: {
    title: "Console super admin",
    subtitle: "Pilotage de la plateforme AI Commerce OS.",
    tenants: "Établissements",
    verticals: "Verticales",
    platform: "Plateforme",
    audit: "Audit global",
    tenantsCount: "Tenants",
    activeCount: "Actifs",
    pendingCount: "En attente",
    suspendedCount: "Suspendus",
    usersCount: "Utilisateurs",
    auditCount: "Événements",
    navDashboard: "Tableau de bord",
    navTenantsAccess: "Tenants & accès",
    navRoles: "Rôles & permissions",
    navLeads: "Leads",
    navVerticalsAi: "Verticales & IA",
    navFlowEditorBeta: "Éditeur de flow (bêta)",
    navCommerceBilling: "Commerce & facturation",
    navB2bBilling: "Facturation B2B",
    navCommercePricing: "Documents commerciaux",
    navCostsMargins: "Coûts & marges",
    navPricing: "Tarification",
    navPlatform: "Plateforme",
    navTrialSignup: "Essai gratuit & inscription",
    navGdprLegal: "RGPD & Légal",
    navSystemHealth: "Santé système",
    navAiLatency: "Latence IA",
    navUnderstandingQuality: "Qualité compréhension WhatsApp",
    navVoiceObservability: "Fiabilité des appels vocaux",
    navKnowledgeBase: "Base de connaissance",
    closeMenu: "Fermer le menu",
    openMenu: "Ouvrir le menu",
  },
  adminOverview: {
    verticalsLabel: "Verticales",
    topVertical: "Top vertical",
    aiCostsTitle: "Coûts IA · {month}",
    grossMarginTitle: "Marge brute plateforme",
    seeDetail: "Voir le détail",
    aiCostLabel: "Coût IA",
    revenueLabel: "Revenu",
    marginLabel: "Marge",
    activeTenantsLabel: "Tenants actifs",
    withAiCostThisMonth: "avec coût IA > 0 ce mois",
    topTenantsByAiCost: "Top tenants par coût IA",
    costLabel: "Coût",
    verticalBreakdownTitle: "Répartition par verticale",
    noEstablishment: "Aucun établissement enregistré",
  },
  publicTenant: {
    orderOnline: "Commander en ligne",
    descriptionMenu: "Carte en ligne, commande, allergènes.",
    descriptionAvailable: "Disponible 24/7.",
    notFoundTitle: "Établissement introuvable",
    notFoundBody: "Ce profil n'existe pas ou n'est pas encore publié.",
    viewMenu: "Voir la carte",
    about: "À propos",
    services: "Services",
    toConfigure: "À configurer.",
    hours: "Horaires",
    closed: "Fermé",
    location: "Localisation",
    addressComingSoon: "Adresse à venir.",
    menuOf: "Carte de {name}",
  },
  adminRoles: {
    overline: "Plateforme",
    title: "Rôles & permissions",
    subtitle: "Les rôles système (verrouillés) couvrent les cas standards. Créez des rôles personnalisés pour vos besoins métier spécifiques.",
    newRole: "Nouveau rôle",
    editTitle: "Modifier {key}",
    createTitle: "Créer un nouveau rôle",
    keyLabel: "Clé (UPPER_SNAKE)",
    placeholderKey: "EX: BARISTA",
    scopeLabel: "Portée",
    scopeTenant: "Tenant (établissement)",
    scopePlatform: "Plateforme (super admin)",
    nameFrLabel: "Nom (français)",
    nameEnLabel: "Nom (anglais)",
    permissionsSelected: "{count} permission(s) sélectionnée(s)",
    deselectAll: "Tout retirer",
    selectAll: "Tout cocher",
    cancel: "Annuler",
    save: "Enregistrer",
    createRole: "Créer le rôle",
    permissionsCount: "{count} permission(s)",
    edit: "Modifier",
    deleteRoleAria: "Supprimer le rôle {key}",
    deleteRoleTitle: "Supprimer le rôle {key} ?",
    deleteRoleItem: "Les utilisateurs ayant ce rôle perdront les permissions associées.",
    delete: "Supprimer",
    toastRoleUpdated: "Rôle mis à jour",
    toastRoleCreated: "Rôle créé",
    toastRoleDeleted: "Rôle supprimé",
  },
  verticals: {
    RESTAURANT: "Restaurant",
    HOTEL: "Hôtel",
    DOCTOR: "Médecin",
    COIFFEUR: "Coiffeur",
    ESTHETIQUE: "Esthéticienne",
  },
  // 2026-07-25 — start of the full i18n pass (Itachi: "tout traduire").
  // Convention: one namespace per page, keyed by the page's own name
  // (lowercase). See memory hereai_i18n_full_pass_2026_07_25 for the
  // full plan/progress tracker across pages.
  orders: {
    moduleLabel: "Module M5",
    title: "Commandes",
    subtitle: "Toutes les commandes — manuelles, IA et site web.",
    kitchenView: "Vue Cuisine",
    refresh: "Actualiser",
    newOrder: "Nouvelle commande",
    searchLabel: "Recherche",
    searchPlaceholder: "N°, client, téléphone…",
    statusLabel: "Statut",
    allStatuses: "Tous statuts",
    channelLabel: "Canal",
    allChannels: "Tous canaux",
    typeLabel: "Type",
    allTypes: "Tous types",
    resetFilters: "Réinitialiser",
    colNumber: "N°",
    colType: "Type",
    colChannel: "Canal",
    colCustomer: "Client",
    colItems: "Articles",
    colTotal: "Total",
    colStatus: "Statut",
    colDate: "Date",
    emptyTitle: "Aucune commande",
    emptyNoOrders: "Les commandes prises par téléphone, en ligne ou saisies manuellement apparaîtront ici.",
    emptyFiltered: "Aucune commande ne correspond à ces filtres.",
    detailsTitle: "Détails",
    printTicketTitle: "Imprimer le ticket",
    dialogTitle: "Nouvelle commande",
    formType: "Type",
    formChannel: "Canal",
    formTableNumber: "Numéro de table",
    formDeliveryAddress: "Adresse de livraison",
    formCustomerName: "Nom du client",
    formPhone: "Téléphone",
    formItems: "Articles",
    formAddItem: "Ajouter",
    formNotePlaceholder: "Note (ex: sans oignon)",
    formNotes: "Notes",
    formTotal: "Total",
    formPaymentRequired: "Paiement requis (SMS Stripe)",
    formCancel: "Annuler",
    formSubmit: "Créer la commande",
    noItemsAvailable: "Aucun article disponible. Créez-en d'abord dans le Catalogue.",
    orderCreated: "Commande créée",
    orderCancelled: "Commande annulée",
    cancelOrderTitle: "Annuler la commande #{number} ?",
    cancelOrderWarning: "Le client ne sera pas notifié automatiquement — pensez à l'appeler si besoin.",
    cancelOrderConfirm: "Annuler la commande",
    status: {
      PENDING_PAYMENT: "En attente paiement",
      CONFIRMED: "À préparer",
      IN_PREPARATION: "En préparation",
      READY: "Prêt",
      COMPLETED: "Livré / Remis",
      CANCELLED: "Annulée",
    },
    type: {
      PICKUP: "Emporter",
      DELIVERY: "Livraison",
      DINE_IN: "Sur place",
    },
    channel: {
      AI: "🤖 IA",
      WIDGET: "🌐 Web",
      MANUAL: "✋ Manuel",
    },
  },
  resources: {
    overline: "Ressources",
    titleDefault: "Ressources réservables",
    titleDOCTOR: "Praticiens",
    titleHOTEL: "Chambres",
    titleCOIFFEUR: "Stylistes",
    titleESTHETIQUE: "Esthéticiennes / Cabines",
    subtitleRESTAURANT: "Tables et zones de votre établissement.",
    subtitleHOTEL: "Chambres disponibles à la réservation.",
    subtitleDOCTOR: "Praticiens du cabinet.",
    subtitleCOIFFEUR: "Stylistes et fauteuils.",
    subtitleESTHETIQUE: "Esthéticiennes et cabines.",
    addButton: "Ajouter",
    dialogTitleEdit: "Modifier la ressource",
    dialogTitleNew: "Nouvelle ressource",
    formName: "Nom",
    formType: "Type",
    formCapacity: "Capacité",
    formColor: "Couleur (calendrier)",
    formDescription: "Description (optionnel)",
    formIcalUrl: "URL iCal externe à importer (optionnel)",
    formIcalPlaceholder: "https://… (Doctolib, Outlook, Google Cal public, Calendly…)",
    formIcalHint: "Les créneaux de ce flux bloqueront automatiquement la ressource (synchro toutes les 5 min).",
    formActiveLabel: "Ressource active (disponible à la réservation)",
    formSubmit: "Enregistrer",
    formSaving: "...",
    colName: "Nom",
    colType: "Type",
    colCapacity: "Capacité",
    colStatus: "Statut",
    statusActive: "Actif",
    statusInactive: "Désactivé",
    syncAriaLabel: "Synchroniser le calendrier de {name}",
    editAriaLabel: "Modifier {name}",
    deleteAriaLabel: "Supprimer {name}",
    syncSuccessToast: "Synchronisation iCal — {count} créneaux importés",
    updateSuccessToast: "Ressource mise à jour",
    createSuccessToast: "Ressource créée",
    deleteSuccessToast: "Ressource supprimée",
    emptyTitle: "Aucune ressource",
    emptyDescription: "Tables, chambres, praticiens… créez la première ressource que vos clients pourront réserver.",
    emptyActionLabel: "Ajouter une ressource",
    deleteConfirmTitle: "Supprimer \"{name}\" ?",
    deleteConfirmWarning: "Les réservations déjà prises sur cette ressource ne sont pas annulées.",
    deleteConfirmLabel: "Supprimer",
    types: {
      table: "Table",
      room: "Chambre",
      practitioner: "Praticien",
      stylist: "Styliste",
      chair: "Fauteuil",
      esthetician: "Esthéticienne",
      cabin: "Cabine",
    },
  },
  blacklist: {
    overline: "Gestion des annulations",
    title: "Liste grise & liste noire",
    subtitle: "Clients en surveillance ou bloqués. Le matching se fait sur prénom + nom + date de naissance (fallback email/téléphone). Les seuils sont configurables dans {settingsPath}.",
    subtitleSettingsPath: "Paramètres → Politique d'annulation",
    addManually: "Ajouter manuellement",
    kpiTotal: "Total",
    kpiGrey: "Liste grise",
    kpiBlack: "Liste noire",
    searchLabel: "Recherche",
    searchPlaceholder: "Nom, email, téléphone…",
    statusLabel: "Statut",
    statusAll: "Tous",
    statusGrey: "Liste grise",
    statusBlack: "Liste noire",
    refresh: "Rafraîchir",
    colClient: "Client",
    colBirthDate: "Date de naissance",
    colContact: "Contact",
    colStatus: "Statut",
    colCancellations: "Annulations",
    colSource: "Source",
    statusGreyBadge: "Grise",
    statusBlackBadge: "Noire",
    noShowSuffix: "no-show",
    lastMinuteSuffix: "dernière minute",
    sourceManual: "Manuelle",
    sourceAuto: "Auto",
    editAriaLabel: "Modifier {name}",
    removeAriaLabel: "Retirer {name}",
    emptyTitle: "Aucun client en liste",
    emptyDescription: "Les annulations et no-shows futurs alimenteront automatiquement cette liste, ou ajoutez un client manuellement.",
    emptyActionLabel: "Ajouter un client",
    dialogTitleEdit: "Modifier l'entrée",
    dialogTitleNew: "Ajouter à la liste",
    formFirstName: "Prénom *",
    formLastName: "Nom *",
    formBirthDate: "Date de naissance (fortement recommandée)",
    formEmail: "Email",
    formPhone: "Téléphone",
    formStatus: "Statut *",
    formStatusGrey: "Liste grise (vigilance)",
    formStatusBlack: "Liste noire (blocage)",
    formStatusRemove: "Retirer de la liste",
    formReason: "Raison",
    formReasonPlaceholder: "ex: 3 no-shows successifs",
    formNotes: "Notes internes",
    formSubmit: "Enregistrer",
    formSaving: "...",
    updateSuccessToast: "Entrée mise à jour",
    createSuccessToast: "Entrée ajoutée",
    deleteSuccessToast: "Entrée retirée",
    deleteConfirmTitle: "Retirer \"{name}\" de la liste ?",
    deleteConfirmWarning: "Le client ne sera plus signalé au moment de la réservation.",
    deleteConfirmLabel: "Retirer",
  },
  catalog: {
    overlineM4M5: "Modules M4 + M5 — Commandes & Prestations",
    overlineM5: "Module M5 — Commandes",
    title: "Catalogue",
    subtitleM4: "Gérez votre carte : articles à commander et prestations à réserver, dans une même liste.",
    subtitleM5: "Gérez votre carte : catégories, articles, prix, photos, allergènes, temps de préparation.",
    importFromPhoto: "Importer depuis photo",
    newItem: "Nouvel article",
    newService: "Nouvelle prestation",
    newCategory: "Nouvelle catégorie",
    newMaterial: "Nouvelle matière",
    publicHintBold: "Cette carte est publiée sur votre vitrine.",
    publicHintRest: "Chaque article disponible apparaît sous la section « Notre carte » de votre page publique.",
    publicPageLink: "Page publique",
    viewOnline: "Voir en ligne",
    establishmentInfoTitle: "Horaires & régimes alimentaires",
    establishmentInfoSubtitle: "Affichés sur votre page publique et la boutique WhatsApp.",
    establishmentInfoExpand: "Déplier",
    establishmentInfoCollapse: "Replier",
    establishmentInfoSavedToast: "Informations enregistrées",
    hoursManagedInTelephony: "Vos horaires sont gérés depuis la téléphonie IA (plages multiples par jour).",
    hoursManagedInTelephonyLink: "Les modifier",
    dietaryLabelsTitle: "Régimes alimentaires",
    dietaryLabelsHint: "Affichés en badge sur votre page publique et dans la boutique WhatsApp pour informer vos clients à l'avance.",
    dietaryVegan: "Vegan",
    dietaryVegetarian: "Végétarien",
    dietaryHalal: "Halal",
    dietaryKosher: "Casher",
    deliveryProvidersTitle: "Livraison",
    deliveryProvidersHint: "Les services que vous utilisez réellement — l'assistant vocal et WhatsApp y répondent honnêtement quand un client demande si vous livrez.",
    deliveryProvidersEmpty: "Aucun service de livraison configuré pour le moment.",
    deliveryProviderLabelPlaceholder: "Nom (ex : Uber Eats)",
    deliveryProviderUrlPlaceholder: "Lien vers votre boutique (optionnel)",
    deliveryProviderRemove: "Retirer",
    deliveryProviderAdd: "Ajouter un service",
    tabOffers: "Offres ({count})",
    tabItems: "Articles ({count})",
    tabCategories: "Catégories ({count})",
    tabMaterials: "Matières ({count})",
    tabOptions: "Suppléments",
    tabMenus: "Menus / Formules",
    tabVoice: "Réécoute vocale",
    categoryLabel: "Catégorie",
    allCategories: "Toutes catégories",
    colType: "Type",
    colPhoto: "Photo",
    colItem: "Article",
    colCategory: "Catégorie",
    colPrice: "Prix",
    colDurationPrep: "Durée/Prépa",
    colPrep: "Prépa",
    colAllergens: "Allergènes",
    colAvailable: "Dispo",
    badgeService: "Prestation",
    badgeItem: "Article",
    itemsEmptyTitle: "Aucun article",
    itemsEmptyDescription: "Démarrez votre carte en ajoutant votre premier article.",
    colCategoryName: "Catégorie",
    colOrder: "Ordre",
    colActive: "Active",
    active: "Active",
    inactive: "Inactive",
    categoriesEmptyTitle: "Aucune catégorie",
    categoriesEmptyDescription: "Créez-en une pour organiser vos articles (entrées, plats, boissons…).",
    colRawMaterial: "Matière première",
    colUnit: "Unité",
    colCostPerUnit: "Coût / unité",
    colSupplier: "Fournisseur",
    materialsEmptyTitle: "Aucune matière première",
    materialsEmptyDescription: "Ajoutez vos ingrédients (steak, pain, lait…) pour calculer la marge brute.",
    matDialogEdit: "Modifier la matière",
    matDialogNew: "Nouvelle matière première",
    matFormName: "Nom",
    matFormNameError: "Le nom de la matière est obligatoire.",
    matFormUnit: "Unité",
    matFormUnitError: "L'unité est obligatoire.",
    matFormUnitHint: "Utilisée pour calculer le coût matière de vos articles (ex: g, kg, ml, pcs).",
    matFormCost: "Coût / unité (€)",
    matFormSupplier: "Fournisseur (optionnel)",
    matFormNotes: "Notes",
    itemDialogEdit: "Modifier l'article",
    itemDialogNew: "Nouvel article",
    itemFormName: "Nom",
    itemFormNameError: "Le nom de l'article est obligatoire.",
    itemFormCategory: "Catégorie",
    itemFormNoCategory: "— Aucune —",
    itemFormPrice: "Prix (€)",
    itemFormPrepTime: "Temps de préparation (min)",
    itemFormPhoto: "Photo (URL)",
    itemFormDescription: "Description",
    itemFormAllergens: "Allergènes",
    itemFormAllergensHint: "(obligation légale FR)",
    itemFormAvailable: "Disponible à la vente",
    serviceDialogEdit: "Modifier la prestation",
    serviceDialogNew: "Nouvelle prestation",
    serviceFormName: "Nom",
    serviceFormNameError: "Le nom de la prestation est obligatoire.",
    serviceFormDescription: "Description (optionnel)",
    serviceFormDuration: "Durée (minutes)",
    serviceFormPrice: "Prix (€)",
    serviceFormResourceType: "Type de ressource requise (optionnel)",
    serviceFormActive: "Active",
    catDialogEdit: "Modifier la catégorie",
    catDialogNew: "Nouvelle catégorie",
    catFormName: "Nom",
    catFormNameError: "Le nom de la catégorie est obligatoire.",
    catFormOrder: "Ordre d'affichage",
    catFormActive: "Active",
    cancel: "Annuler",
    save: "Enregistrer",
    create: "Créer",
    itemUpdatedToast: "Article modifié",
    itemCreatedToast: "Article créé",
    itemDeletedToast: "Article supprimé",
    serviceUpdatedToast: "Prestation modifiée",
    serviceCreatedToast: "Prestation créée",
    serviceDeletedToast: "Prestation supprimée",
    catUpdatedToast: "Catégorie modifiée",
    catCreatedToast: "Catégorie créée",
    catDeletedToast: "Catégorie supprimée",
    matUpdatedToast: "Matière modifiée",
    matCreatedToast: "Matière créée",
    matDeletedToast: "Matière supprimée",
    deleteItemTitle: "Supprimer \"{name}\" ?",
    deleteItemWarning: "L'article disparaît immédiatement de votre carte et de votre page publique.",
    deleteServiceTitle: "Supprimer \"{name}\" ?",
    deleteServiceWarning1: "La prestation disparaît immédiatement de votre carte et de votre page publique.",
    deleteServiceWarning2: "Les réservations déjà prises pour cette prestation ne sont pas annulées.",
    deleteCatTitle: "Supprimer \"{name}\" ?",
    deleteCatWarning: "Les articles de cette catégorie ne sont PAS supprimés — ils seront détachés (sans catégorie).",
    deleteMatTitle: "Supprimer \"{name}\" ?",
    deleteMatWarning: "Les articles utilisant cette matière première dans leur composition ne seront plus reliés à elle.",
    deleteConfirmLabel: "Supprimer",
  },
  alerts: {
    overline: "M2 · Surveillance IA",
    title: "Alertes mots-clés",
    subtitle: "Conversations dans lesquelles l'IA a détecté un mot-clé sensible (configuré par votre administrateur de plateforme).",
    refresh: "Rafraîchir",
    emptyTitle: "Aucune alerte pour le moment",
    emptyDescription: "Si l'IA détecte un mot-clé sensible dans une conversation, l'événement apparaîtra ici en temps réel.",
    client: "Client",
    ai: "IA",
    open: "Ouvrir",
  },
  kitchen: {
    overline: "Module M5",
    title: "Cuisine",
    subtitle: "Vue temps réel — ",
    connected: "● connecté",
    disconnected: "● déconnecté",
    soundTitle: "Son nouvelle commande",
    exitTv: "Quitter TV",
    tvMode: "Mode TV",
    colToPrepare: "À préparer",
    colInPrep: "En préparation",
    colReady: "Prêt",
    nextStart: "Commencer",
    nextMarkReady: "Marquer prêt",
    nextDeliver: "Livrer / Remettre",
    noOrders: "Aucune commande",
    typePickup: "EMPORTER",
    typeDelivery: "LIVRAISON",
    typeDineIn: "SUR PLACE",
    channelAi: "🤖 IA",
    channelWidget: "🌐 Web",
    channelManual: "✋ Dashboard",
    table: "Table {number}",
    minutesShort: "min",
  },
  conversations: {
    overline: "M2 · Téléphonie & SMS",
    title: "Conversations",
    subtitle: "Tous les appels et SMS reçus sur votre numéro dédié.",
    refresh: "Rafraîchir",
    phoneOverline: "Votre numéro dédié",
    phoneHint: "Communiquez ce numéro à vos clients. Les appels et SMS sont gérés par votre IVR automatique et archivés ci-dessous.",
    noPhone: "Aucun numéro provisionné pour votre établissement. Contactez l'administrateur de la plateforme.",
    filterAll: "Tous",
    filterCalls: "Appels",
    filterSms: "SMS",
    filterUnderstandingFailed: "Échecs de compréhension",
    filterAlerts: "Alertes IA",
    filterCallbacks: "Rappels à faire",
    understandingFailedLabel: "Compréhension échouée",
    understandingFailedCoachPlaceholder: "(compréhension échouée — l'IA n'a pas su traiter cette phrase et a escaladé la conversation)",
    colChannel: "Canal",
    colRemote: "Numéro distant",
    colStart: "Début",
    colStatus: "Statut",
    colDuration: "Durée",
    colOrder: "Commande",
    loading: "Chargement…",
    empty: "Aucune conversation pour le moment.",
    emptyDescription: "Les appels et SMS reçus sur votre numéro apparaîtront ici.",
    statusActive: "Actif",
    statusDone: "Terminé",
    channelVoice: "Appel",
    channelSms: "SMS",
    replayBtn: "Re-tester avec config actuelle",
    costTitle: "Coût IA (SUPER_ADMIN)",
    turnsLabel: "tour",
    sttLabel: "STT",
    llmLabel: "LLM",
    ttsLabel: "TTS",
    voiceLabel: "Voix Twilio",
    totalLabel: "Total",
    transcriptTitle: "Transcription IA",
    exchangesLabel: "échanges",
    orderTakenByAi: "Commande prise par l'IA",
    itemLabel: "article",
    pickupLabel: "retrait",
    client: "Client",
    ai: "IA",
    coachBtn: "Coacher",
    techEventsTitle: "Événements techniques",
    copyAll: "Copier tout",
    noEvents: "Aucun événement.",
    keyPressed: "Touche pressée",
    ruleTriggered: "Règle déclenchée",
    sensitiveKeywords: "Mots-clés sensibles détectés",
    listenRecording: "Écouter l'enregistrement",
    fromLabel: "De",
    rawDetail: "Détail brut",
    copy: "Copier",
    payloadCopied: "Payload copié",
    coachingSaved: "Coaching pris en compte dès le prochain appel similaire",
    eventsCopiedToast: "{n} événement(s) copié(s)",
    intentCorrectionBtn: "Expliquer l'intention",
    intentCorrectionHint: "Expliquer ce que le client voulait vraiment dire",
    intentCorrectionMissingFields: "Veuillez renseigner ce que le client a dit et ce qu'il voulait vraiment dire",
    intentCorrectionSaved: "Intention enregistrée et appliquée immédiatement",
    intentCorrectionDialogTitle: "Expliquer l'intention du client",
    intentCorrectionDialogSubtitle: "Expliquez ce que le client voulait vraiment dire, même si l'IA a mal compris ou mal entendu. Cette règle est appliquée immédiatement aux prochains appels.",
    intentCorrectionCustomerTextLabel: "Ce que le client a dit",
    intentCorrectionResolvedValueLabel: "Ce qu'il voulait vraiment dire",
    intentCorrectionResolvedValuePlaceholder: "Ex : « menu du midi » = menu numéro 2",
    intentCorrectionNoteLabel: "Note (optionnel)",
    intentCorrectionNotePlaceholder: "Contexte additionnel pour comprendre cette correction",
    intentCorrectionSubmitBtn: "Enregistrer",
    phraseOverrideBtn: "Changer cette phrase",
    phraseOverrideHint: "Remplacer la formulation de l'assistant pour cette phrase",
    phraseOverrideMissingText: "Veuillez saisir la nouvelle formulation",
    phraseOverrideSaved: "Nouvelle formulation enregistrée",
    phraseOverrideDialogTitle: "Changer cette phrase",
    phraseOverrideDialogSubtitle: "Proposez une meilleure formulation pour cette réponse de l'assistant. Elle sera ajoutée comme variante, propre à votre établissement, puis vous pourrez générer son audio immédiatement.",
    phraseOverrideOriginalLabel: "Formulation actuelle :",
    phraseOverrideNewTextLabel: "Nouvelle formulation",
    phraseOverridePhraseKeyLabel: "Clé de phrase (optionnel)",
    phraseOverridePhraseKeyPlaceholder: "Laisser vide pour détection automatique",
    phraseOverridePhraseKeyHint: "Si vide, la clé de phrase est retrouvée automatiquement à partir de cette bulle.",
    phraseOverrideSubmitBtn: "Enregistrer",
    phraseOverrideSavedAs: "Variante #{n} ajoutée pour « {key} »",
    phraseOverrideGenerateAudioLabel: "Générer l'audio de cette variante",
    phraseOverrideAudioGenerated: "Audio généré",
    phraseOverrideAudioGenError: "Erreur de génération audio",
    phraseOverrideDoneBtn: "Terminé",
  },
  legal: {
    docTerms: "CGU",
    docPrivacy: "Politique de confidentialité",
    docLegalNotice: "Mentions légales",
    docCookies: "Politique cookies",
    loading: "Chargement…",
    overline: "Conformité",
    title: "RGPD & mentions légales",
    subtitle: "Documents auto-générés à partir des informations de votre établissement.",
    medicalBadge: "Verticale médicale · {years} ans",
    tabDocs: "Documents",
    tabRights: "Droits clients",
    editRestricted: "Édition réservée au Super Admin de la plateforme. Contactez le support pour adapter ces textes à votre cas particulier.",
    viewPublic: "Voir la version publique →",
    exportTitle: "Export de données (Art. 15)",
    exportDesc: "Téléchargez l'ensemble des données détenues sur un client (réservations, commandes, conversations). Format JSON, horodaté et audité.",
    exportBtn: "Exporter les données d'un client",
    forgetTitle: "Droit à l'oubli (Art. 17)",
    forgetDesc: "Anonymise le client et toutes ses traces (réservations, commandes, conversations). Les enregistrements restent pour la comptabilité, mais les données identifiantes sont remplacées par un pseudonyme irréversible.",
    forgetBtn: "Anonymiser un client",
    errNoContact: "Renseignez au moins un email ou un téléphone",
    errConfirm: "Confirmez l'irréversibilité de l'opération",
    exportModalTitle: "Exporter les données d'un client",
    exportModalDesc: "Renseignez l'email ou le téléphone du client. Le fichier JSON sera téléchargé.",
    emailLabel: "Email",
    phoneLabel: "Téléphone",
    exportDone: "Export terminé",
    exportSummary: "{bookings} réservations · {orders} commandes · {conversations} conversations",
    close: "Fermer",
    download: "Télécharger",
    exportSuccessToast: "Export généré et téléchargé",
    forgetModalTitle: "Anonymisation d'un client",
    forgetModalDescPre: "Opération ",
    forgetModalDescBold: "irréversible",
    forgetModalDescPost: ". Les identifiants seront remplacés par un pseudonyme cryptographique. Les enregistrements comptables restent.",
    forgetWarning: "Une fois exécutée, l'opération est tracée dans l'audit log et ne peut être annulée.",
    forgetConfirmLabel: "Je confirme avoir reçu une demande RGPD valide",
    forgetDone: "Anonymisation terminée",
    pseudoLabel: "Pseudonyme",
    bookingsLabel: "Réservations",
    ordersLabel: "Commandes",
    conversationsLabel: "Conversations",
    anonymize: "Anonymiser",
    forgetSuccessToast: "Anonymisation effectuée",
  },
  orderDetail: {
    statusPendingPayment: "En attente paiement",
    statusConfirmed: "À préparer",
    statusInPrep: "En préparation",
    statusReady: "Prêt",
    statusCompleted: "Livré / Remis",
    statusCancelled: "Annulée",
    statusRefunded: "Remboursée",
    typePickup: "Emporter",
    typeDelivery: "Livraison",
    typeDineIn: "Sur place",
    channelAi: "🤖 IA téléphonique",
    channelWidget: "🌐 Site web",
    channelManual: "✋ Manuel",
    nextStartPrep: "Démarrer la préparation",
    nextMarkReady: "Marquer prêt",
    nextMarkDelivered: "Marquer livré",
    back: "Retour aux commandes",
    tableLabel: " · Table {number}",
    printTicket: "Ticket PDF",
    smsClient: "SMS client",
    smsNotify: "Prévenir client (SMS)",
    smsTitle: "SMS au {phone}",
    cancelBtn: "Annuler",
    refundBtn: "Rembourser",
    customerOverline: "Client",
    nameLabel: "Nom",
    phoneLabel: "Téléphone",
    emailLabel: "Email",
    pickupTimeLabel: "Heure souhaitée",
    addressLabel: "Adresse livraison",
    customerNotes: "Notes du client",
    itemsOverline: "Articles",
    totalLabel: "Total",
    costLabel: "Coût matières (BOM)",
    profitLabel: "Marge brute",
    prepTimeLabel: "Temps préparation estimé",
    paymentStatusLabel: "Statut paiement",
    paidLabel: "✓ Payé",
    pendingLabel: "En attente",
    convoOverline: "Conversation IA liée",
    convoChannelLabel: "Canal",
    convoPhoneWord: "Téléphone",
    convoNumberLabel: "Numéro",
    convoStartedLabel: "Démarrée",
    openInbox: "Ouvrir dans l'Inbox",
    noExchange: "Pas d'échange enregistré",
    guardrailTriggered: "garde-fou déclenché",
    timelineOverline: "Chronologie",
    noEvents: "Aucun événement.",
    idLabel: "Identifiant",
    loading: "Chargement…",
    notFound: "Commande introuvable.",
    statusUpdatedToast: "Statut mis à jour : {status}",
    smsSentToast: "SMS de notification envoyé",
    smsFailedToast: "Statut mis à jour, mais le SMS n'a pas pu être envoyé",
    orderCancelledToast: "Commande annulée",
    smsMockedToast: "SMS enregistré (mode mock — Twilio trial)",
    smsSentToClientToast: "SMS envoyé au {to}",
    cancelDialogTitle: "Annuler cette commande ?",
    cancelDialogItem: "Le client ne sera pas notifié automatiquement — pensez à l'appeler si besoin.",
    cancelConfirmLabel: "Annuler la commande",
    orderRefundedToast: "Commande remboursée",
    refundDialogTitle: "Rembourser cette commande ?",
    refundDialogItem: "Confirmez que le remboursement a bien été effectué auprès du client (hors système) avant de valider ici — cette action met à jour la comptabilité.",
    refundConfirmLabel: "Rembourser la commande",
  },
  billing: {
    periodDay: "Jour",
    periodWeek: "Semaine",
    periodMonth: "Mois",
    title: "Facturation",
    subtitle: "Conso en direct, modules activés, postes utilisateurs, et facture détaillée à la seconde. Pas d'abonnement, pas de palier — vous payez ce que vous consommez.",
    exportPdf: "Exporter PDF",
    statVoice: "Voix IA",
    statOrders: "Commandes IA",
    statOrdersSub: "prises par l'assistant",
    statConversations: "Conversations",
    statConversationsSub: "tous canaux",
    statSms: "SMS envoyés",
    statSmsSub: "dont liens de paiement",
    callWord: "appel",
    stackBreakdownTitle: "Détail par stack vocal",
    invoiceTitle: "Facture détaillée · {period}",
    totalLabel: "Total",
    modulesTitle: "Modules activés ({n})",
    modulesSubtotal: "Sous-total modules",
    seatsTitle: "Postes utilisateurs ({n})",
    perPerson: "/ pers.",
    seatsSubtotal: "Sous-total seats",
    voiceCallsTitle: "Appels IA ({n})",
    noCallsPeriod: "Aucun appel sur cette période.",
    perMinuteCts: "cts/min",
    voiceSubtotal: "Sous-total voix",
    whatsappTitle: "WhatsApp ({n} messages)",
    whatsappSent: "Envoyés",
    whatsappReceived: "Reçus",
    whatsappIncluded: "Inclus dans le forfait",
    whatsappOverage: "Dépassement ({n} × {price})",
    whatsappSubtotal: "Sous-total WhatsApp",
    whatsappNoCostDetail: "Le coût du dépassement n'est calculé que sur la facture mensuelle.",
    phoneNumberNote: "Numéro de téléphone",
    totalToPay: "Total à payer",
    alertsTitle: "Alertes de consommation",
    enabled: "Activées",
    disabled: "Désactivées",
    alertsDesc: "Recevez un email (et/ou un ping Slack) dès que votre conso voix dépasse un seuil sur le jour, la semaine ou le mois. Une seule alerte par période et par seuil — aucune autre.",
    thresholdDay: "Seuil jour (cts)",
    thresholdWeek: "Seuil semaine (cts)",
    thresholdMonth: "Seuil mois (cts)",
    thresholdPlaceholder: "ex: 1000 (= 10 €)",
    emailsLabel: "Emails à notifier (1 par ligne)",
    emailsPlaceholder: "billing@mon-restaurant.fr",
    slackLabel: "Webhook Slack (optionnel)",
    save: "Enregistrer",
    lastAlertsTitle: "Dernières alertes émises",
    thresholdWord: "seuil",
    savedToast: "Alertes de conso enregistrées",
  },
  notifications: {
    overline: "Notifications",
    title: "Centre de notifications",
    subtitle: "Historique sur 90 jours · {count} entrée(s) chargée(s) · {unread} non lue(s)",
    markAllRead: "Tout marquer lu",
    catAll: "Toutes",
    catBooking: "Réservations",
    catOrder: "Commandes",
    catCall: "Appels",
    catLead: "Leads",
    catBilling: "Facturation",
    catTeam: "Équipe",
    catSystem: "Système",
    catChurn: "Churn",
    catGdpr: "RGPD",
    searchPlaceholder: "Rechercher…",
    includeRead: "Inclure lues",
    emptyMessage: "Aucune notification correspondante.",
    openLink: "Ouvrir →",
    today: "Aujourd'hui",
    yesterday: "Hier",
    secondsAgo: "il y a {n}s",
    minutesAgo: "il y a {n} min",
    hoursAgo: "il y a {n} h",
    daysAgo: "il y a {n} j",
  },
  accounting: {
    overline: "Comptabilité M5",
    title: "Recettes & Bénéfices",
    subtitle: "Historique mois par mois. CA — coût matières — bénéfice brut — marge.",
    modeToday: "1 jour",
    modeWeek: "7 jours",
    mode30Days: "30 jours",
    modeByMonth: "Par mois",
    monthLabel: "Mois",
    exportCsv: "Export CSV",
    kpiGross: "CA TTC",
    kpiCost: "Coût matières",
    kpiProfit: "Bénéfice brut",
    kpiMargin: "Marge brute",
    chartTitle: "Recettes du mois — par jour",
    chartCa: "CA",
    chartProfit: "Bénéfice",
    loading: "Chargement…",
    noData: "Pas de données",
    colDate: "Date",
    colGross: "CA TTC",
    colCost: "Coût matières",
    colProfit: "Bénéfice",
    colOrders: "Cmds",
    colStatus: "Statut",
    closedBadge: "Clôturé",
    liveBadge: "Live",
    dailyPdfTitle: "Recettes du jour (PDF)",
    closeBtn: "Clôturer",
    closeDayToast: "Journée {date} clôturée",
    closeDialogTitle: "Clôturer définitivement la journée {date} ?",
    closeDialogItem: "Les chiffres de cette journée sont figés pour la comptabilité — plus aucune commande ne pourra les modifier.",
    closeConfirmLabel: "Clôturer",
    monthNames: [
      "Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
      "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre",
    ],
  },
  callbacks: {
    reasonOffTopic: "Hors-sujet (3+)",
    reasonOutOfTime: "Délai dépassé",
    reasonMaxTurns: "Trop de tours",
    reasonManual: "Manuel",
    overline: "Module M2 · Garde-fous IA",
    title: "Rappels à effectuer",
    subtitle: "Les conversations clôturées par l'IA (hors-sujet, durée dépassée, trop de tours) génèrent automatiquement un ticket de rappel. Votre équipe les traite ici.",
    refresh: "Actualiser",
    statPending: "À rappeler",
    statDone: "Rappelés",
    statTotal: "Total visibles",
    filterPending: "À rappeler",
    filterDone: "Rappelés",
    filterDismissed: "Écartés",
    filterAll: "Tous",
    empty: "Aucun rappel à afficher.",
    unknownNumber: "numéro inconnu",
    viewConversation: "Voir la conversation",
    markDone: "Rappelé",
    dismiss: "Écarter",
    loadError: "Erreur de chargement",
    genericError: "Erreur",
    markedDoneToast: "Marqué comme rappelé",
    dismissedToast: "Demande écartée",
    updatedToast: "Mis à jour",
  },
  analytics: {
    range7d: "7 jours",
    range30d: "30 jours",
    range90d: "90 jours",
    range365d: "1 an",
    loading: "Chargement…",
    overline: "Analytics",
    title: "Tableau de bord",
    periodLabel: "Période : {start} → {end}",
    revenueHeadlineLabel: "CA commandes généré",
    tabBusiness: "Business",
    tabOps: "Opérationnel",
    businessOverline: "Business",
    kpiBookings: "Réservations",
    kpiBookingsSub: "{n} confirmées",
    kpiOrders: "Commandes",
    kpiOrdersSub: "{amount} de CA",
    kpiAvgTicket: "Ticket moyen",
    kpiAvgTicketSub: "par commande",
    kpiCovers: "Couverts",
    kpiCoversSub: "personnes accueillies",
    kpiConversion: "Conversion widget",
    kpiConversionSub: "{n} lead(s)",
    dailyActivity: "Activité quotidienne · {range}",
    legendBookings: "Réservations",
    legendOrders: "Commandes",
    legendRevenue: "CA commandes",
    bookingsHealth: "Santé des réservations",
    noShowRate: "Taux de no-show",
    cancelRate: "Taux d'annulation",
    confirmRate: "Taux de confirmation",
    topServices: "Top services / créneaux",
    noBookingsPeriod: "Aucune réservation sur la période.",
    opsOverline: "Opérationnel",
    kpiConvos: "Conversations IA",
    kpiConvosSub: "{n}% résolues",
    kpiAvgDuration: "Durée moy. appel",
    kpiAvgDurationSub: "par conversation",
    kpiVoiceMin: "Minutes voix",
    kpiVoiceMinSub: "cumulées sur période",
    kpiSms: "SMS envoyés",
    kpiSmsSub: "rappels & confirmations",
  },
  helpForwarding: {
    overline: "Téléphonie M2",
    title: "Rediriger votre ligne fixe vers l'IA",
    subtitlePre: "Pour que vos clients soient pris en charge par votre IA, configurez un ",
    subtitleBold: "renvoi d'appel sur la ligne fixe du restaurant",
    subtitlePost: " (pas un mobile) vers le numéro ci-dessous. Suivez les 3 étapes.",
    twilioNumberOverline: "Numéro à renseigner comme destination du renvoi",
    copy: "Copier",
    numberCopiedToast: "Numéro copié",
    codeCopiedToast: "Copié",
    noTwilioNumber: "Aucun numéro provisionné. Contactez votre Super Admin.",
    // 2026-09-25 (Itachi) — page entièrement réorganisée en 3 étapes
    // guidées pour un utilisateur non technique. L'ancienne version
    // était écrite pour un renvoi depuis un MOBILE (codes USSD +
    // bouton "Appel ✆", app "SFR & Moi → Mon mobile...") alors que les
    // premiers clients (restaurants) redirigent leur LIGNE FIXE — un
    // renvoi de ligne fixe se configure différemment selon l'opérateur
    // (Free/Bouygues : uniquement depuis l'espace client en ligne, pas
    // de code sur le combiné). La méthode "espace client" devient donc
    // la méthode principale, fiable pour les 4 opérateurs ; le code à
    // composer reste proposé en option, avec réserve, pour Orange/SFR.
    step1Title: "Étape 1 — Quel est l'opérateur de votre ligne fixe ?",
    step1Hint: "Celui de la box ou de la ligne téléphonique du restaurant — pas forcément le même que votre mobile personnel.",
    operatorOtherLabel: "Autre opérateur",
    operatorOtherHint: "Contactez le support de votre opérateur et demandez un « renvoi d'appel inconditionnel / systématique » vers le numéro ci-dessus — la méthode exacte varie selon l'opérateur.",
    step2Title: "Étape 2 — Configurez le renvoi",
    step2Hint: "Méthode la plus fiable : l'espace client en ligne de {name}. Collez le numéro affiché en haut de cette page comme destination.",
    openSpaceBtn: "Ouvrir l'espace client {name}",
    step3Title: "Autre méthode (optionnelle) : code à composer",
    step3Hint: "Certains opérateurs permettent aussi d'activer le renvoi directement depuis le téléphone du restaurant. Cela peut varier selon votre box — si ça ne fonctionne pas, utilisez l'espace client de l'étape 2.",
    codeCancelLabel: "Pour annuler :",
    codeUnavailable: "{name} ne propose pas ce raccourci pour une ligne fixe/box — utilisez l'espace client à l'étape 2.",
    step4Title: "Étape 3 — Vérifiez que ça fonctionne",
    step4Desc: "Depuis un autre téléphone (votre mobile par exemple), appelez le numéro du restaurant. Si le renvoi est bien configuré, c'est votre IA qui doit répondre.",
    warningTitle: "À savoir",
    warnItem1: "Le renvoi « systématique / inconditionnel » envoie tous les appels à l'IA sans jamais faire sonner le téléphone du restaurant — c'est la configuration la plus simple pour démarrer.",
    warnItem2: "Si vous préférez que le téléphone du restaurant sonne d'abord et que l'IA ne prenne le relais qu'en l'absence de réponse, cette option (avec un délai réglable) est généralement proposée dans le même espace client, à l'étape 2.",
    warnItem3: "Un renvoi vers un numéro à l'étranger peut être facturé par votre opérateur — si le numéro fourni ci-dessus n'est pas un numéro français, demandez-en un à votre Super Admin.",
    warnItem4: "Pensez à désactiver le renvoi si vous changez d'opérateur ou de ligne, sous peine de ne plus recevoir aucun appel.",
  },
  whatsapp: {
    justNow: "à l'instant",
    minAgo: "{n} min",
    hAgo: "{n} h",
    loadingInbox: "Chargement de l'inbox WhatsApp…",
    moduleTitle: "WhatsApp Business",
    moduleDisabledTitle: "Module désactivé",
    moduleDisabledPre: "Activez le module ",
    moduleDisabledBold: "M10 WhatsApp Business",
    moduleDisabledMid: " depuis la page ",
    moduleDisabledLink: "Modules & Voice",
    moduleDisabledPost: " pour piloter votre inbox WhatsApp avec l'IA.",
    headerOverline: "WhatsApp Business · M10",
    headerTitle: "Inbox WhatsApp",
    headerSubtitle: "Votre IA répond automatiquement aux messages WhatsApp. Reprenez la main quand vous le souhaitez via le champ ci-dessous.",
    usageOverline: "Messages WhatsApp · {month}",
    tabInbox: "Inbox",
    tabSettings: "Réglages",
    conversationsTitle: "Conversations ({n})",
    noConversations: "Aucune conversation pour le moment.",
    directionIn: "Entrant",
    directionOut: "IA / Agent",
    humanRequested: "Humain demandé",
    aiPaused: "IA en pause",
    selectConversation: "Sélectionnez une conversation pour la consulter.",
    loading: "Chargement…",
    startedAt: "Démarrée {time}",
    aiActive: "IA active",
    reactivateAi: "Réactiver l'IA",
    takeOver: "Reprendre la main",
    escalatedToHuman: "Escaladé vers humain",
    aiPausedEvent: "IA mise en pause",
    aiReactivatedEvent: "IA réactivée",
    voiceLabel: "🎤 Vocal:",
    replyPlaceholderPaused: "Vous gérez ce thread — envoyez votre réponse au client…",
    replyPlaceholderActive: "L'IA gère ce thread. Envoyez un message manuel pour intervenir ponctuellement (l'IA reprend au tour suivant).",
    send: "Envoyer",
    sandboxOverline: "Mode Sandbox Twilio",
    sandboxTitle: "Tester sans approbation Meta",
    sandboxDescPre: "Numéro partagé ",
    sandboxDescMid: ". Le client envoie d'abord ",
    sandboxDescPost: " pour s'inscrire.",
    sandboxCodeLabel: "Code Sandbox",
    sandboxCodePlaceholder: "Ex : join orange-pizza",
    greetingLabel: "Message d'accueil IA",
    metaOverline: "Production — Numéro Meta-approuvé",
    metaTitle: "Activer votre propre numéro WhatsApp Business",
    metaDescPre: "Une fois validé par Meta (2-3 semaines), votre numéro pro envoie les messages avec le nom de votre établissement. Statut Twilio actuel : ",
    metaApproved: "✓ Approuvé Meta",
    metaRejected: "✗ Rejeté",
    metaPending: "⏳ Revue Meta en cours",
    metaNotStarted: "Non démarré",
    metaUpdated: "MAJ {time}",
    resubmit: "Re-soumettre",
    startOnboarding: "Démarrer l'onboarding Meta",
    refreshStatus: "Rafraîchir le statut",
    otpPlaceholder: "Code OTP reçu",
    validateOtp: "Valider OTP",
    testersOverline: "Numéros enrôlés (sandbox)",
    testersDesc: "Liste blanche des testeurs autorisés à chatter avec votre IA via le numéro partagé Twilio. Un numéro par ligne, format E.164.",
    toastMessageSent: "Message envoyé",
    toastAiPaused: "IA mise en pause — vous reprenez la main",
    toastAiReactivated: "IA réactivée",
    toastSettingsSaved: "Réglages enregistrés",
    toastMetaRequestSent: "Demande envoyée à Meta via Twilio. Statut visible ci-dessous.",
    toastTwilioStatus: "Statut Twilio : {status}",
    toastOtpSent: "OTP envoyé · statut : {status}",
    dialogTitle: "Soumettre votre numéro à Meta",
    dialogDesc: "Twilio enverra ces informations à Meta. La revue prend généralement 2-3 semaines. Vous pourrez suivre le statut depuis cette page.",
    fieldSenderId: "Numéro WhatsApp (E.164) *",
    fieldSenderIdHintPre: "Format international, ex. ",
    fieldSenderIdHintPost: ". Twilio préfixera automatiquement par ",
    fieldWabaId: "WABA ID *",
    fieldWabaIdHint: "WhatsApp Business Account ID — récupérable dans Meta Business Manager → Comptes → WhatsApp.",
    fieldDisplayName: "Nom d'affichage *",
    fieldDisplayNameHint: "Doit respecter les guidelines Meta (pas d'émojis, pas de mention de marques tierces).",
    fieldCategory: "Catégorie",
    fieldAbout: "À propos (statut WhatsApp)",
    fieldAboutPlaceholder: "Réservations & commandes par WhatsApp",
    fieldDescription: "Description business",
    fieldDescriptionPlaceholder: "Restaurant italien à Paris, ouvert du mardi au dimanche, livraison gratuite à partir de 25€.",
    fieldAddress: "Adresse",
    fieldAddressPlaceholder: "12 rue de Rivoli, 75001 Paris, France",
    fieldLogoUrl: "URL du logo (profil)",
    fieldWebsites: "Sites web (séparés par ,)",
    fieldEmails: "Emails (séparés par ,)",
    cancel: "Annuler",
    submitting: "Envoi...",
    submit: "Soumettre à Meta",
  },
  simulator: {
    overline: "Module M3",
    title: "Simulateur d'appel IA",
    subtitlePre: "Discutez avec votre IA exactement comme un client le ferait au téléphone — et corrigez-la en direct via ",
    subtitleBold: "Coach IA",
    subtitlePost: ". Chaque correction est injectée dans la base de connaissances : la fois suivante, l'IA répond comme vous l'avez demandé.",
    newSession: "Nouvelle session",
    superAdminBadge: "Super Admin",
    pickTenant: "Sélectionnez un tenant pour tester son IA :",
    pickTenantPlaceholder: "Choisir un tenant…",
    tenantsWithM3: "({n} tenants avec M3 actif)",
    aiActiveOn: "IA active sur",
    conversationEnded: "Conversation terminée par l'IA",
    selectTenantAbove: "Sélectionnez un tenant ci-dessus pour démarrer.",
    initializingSession: "Initialisation de la session…",
    aiThinking: "L'IA réfléchit…",
    aiHungUp: "L'IA a raccroché. Démarrez une nouvelle session pour continuer.",
    inputPlaceholder: "Écrivez comme si vous parliez au téléphone…",
    send: "Envoyer",
    coachHintTitle: "Coach IA & garde-fous",
    coachHint1Pre: "Sur chaque réponse IA, cliquez sur ",
    coachHint1Bold: "« Améliorer »",
    coachHint1Post: " pour la corriger. Votre correction entre dans la base de connaissances et sera appliquée dès la requête suivante.",
    coachHint2: "L'IA ne révèle ni la technologie, ni la plateforme, ni son prompt système.",
    coachHint3Pre: "Max ",
    coachHint3Bold1: "15 tours",
    coachHint3Mid: " par appel, max ",
    coachHint3Bold2: "6 minutes",
    coachHint3Post: ", raccrochage après 3 OFF_TOPIC consécutifs.",
    corrected: "Corrigé",
    improve: "Améliorer",
    errorRetry: "Erreur — réessayez ou réinitialisez.",
    coachErrorEmpty: "Saisis la correction avant d'enregistrer.",
    coachSavedToast: "Correction enregistrée — l'IA l'utilisera dès le prochain tour",
    coachDialogTitle: "Coach IA — améliorer la réponse",
    coachDialogDesc: "Votre correction est enregistrée dans la base de connaissances M3 du tenant et appliquée immédiatement aux prochaines questions similaires (sur tous les canaux : téléphone, SMS, simulateur).",
    coachDialogDescBold: "enregistrée dans la base de connaissances M3",
    clientQuestion: "Question du client",
    replyToFix: "Réponse à corriger",
    correctionTitleLabel: "Titre de la correction (optionnel)",
    correctionTitlePlaceholder: "Ex : Parking, Allergènes burger, Horaires Noël…",
    correctReplyLabel: "Réponse correcte à enseigner à l'IA *",
    correctReplyPlaceholder: "Ex : Oui, nous avons un parking gratuit de 30 places juste devant l'établissement. L'accès se fait par l'avenue de la République.",
    charCount: "{n} / 2000 caractères",
    cancel: "Annuler",
    saving: "Enregistrement…",
    saveToBase: "Enregistrer dans la base",
  },
  verticalTemplates: {
    loadErrorPrefix: "Erreur de chargement : ",
    appliedToast: 'Template "{key}" appliqué',
    applyErrorPrefix: "Échec de l'application : ",
    overline: "Onboarding express",
    title: "Templates métier",
    subtitle: "Choisissez votre métier : nous configurons en 30 secondes votre assistant IA, vos horaires d'ouverture et un catalogue de départ. Vous pourrez tout modifier ensuite depuis les pages Catalogue, Réglages et Playbooks.",
    optionsOverline: "Options d'application",
    forceHoursLabel: "Écraser mes horaires actuels",
    forceHoursDesc: "Cochez si vous voulez remplacer les horaires déjà saisis par ceux du template.",
    forceCatalogLabel: "Purger et reseeder mon catalogue",
    forceCatalogDesc: "Supprime toutes les catégories et tous les produits actuels avant d'insérer ceux du template.",
    loadingTemplates: "Chargement des templates…",
    close: "Fermer",
    applyThisTemplate: "Appliquer ce template",
    confirmApplyTitle: "Confirmer l'application",
    confirmApplyDescPre: "Vous êtes sur le point d'appliquer le template ",
    confirmItem1Bold: "vertical IA",
    confirmItem1Rest: " sera mis à jour (impacte les réponses de l'assistant).",
    confirmItem2Bold: "horaires",
    confirmItem2Overwrite: "seront ÉCRASÉS par ceux du template",
    confirmItem2Seed: "seront seeds uniquement si vides aujourd'hui",
    confirmItem3Bold: "catalogue",
    confirmItem3Purge: "sera PURGÉ puis re-seedé",
    confirmItem3Seed: "sera seedé uniquement s'il est vide aujourd'hui",
    cancel: "Annuler",
    applyNow: "Appliquer maintenant",
    statusCurrentVertical: "Vertical actuel :",
    templateWord: "template",
    catalogStats: "{cat} catégorie(s), {items} produit(s)",
    emptyCatalog: "catalogue vide",
    hoursDefined: "horaires définis",
    hoursNotDefined: "horaires non définis",
    noTemplateApplied: "Aucun template appliqué pour le moment.",
    noTemplateAppliedRest: " Sélectionnez le vôtre ci-dessous — vous gagnerez ~2 h de configuration.",
    m5InactiveWarning: "⚠ Module M5 (Catalogue) non actif : seul le vertical et les horaires seront appliqués.",
    resultTitle: 'Template « {name} » appliqué avec succès',
    appliedLabel: "Appliqué",
    skippedLabel: "Sauté",
    currentBadge: "Actuel",
    catShort: "cat.",
    productsWord: "produits",
    openDaysShort: "j/7 ouvert",
    preview: "Aperçu",
    apply: "Appliquer",
    personaOverline: "Persona IA",
    hoursOverline: "Horaires",
    closedLabel: "Fermé",
    catalogOverline: "Catalogue ({n} produits)",
    notificationsOverline: "Notifications recommandées",
    destructiveWarning: "⚠ Action destructive. Vos données actuelles seront effacées.",
    dayMon: "Lun",
    dayTue: "Mar",
    dayWed: "Mer",
    dayThu: "Jeu",
    dayFri: "Ven",
    daySat: "Sam",
    daySun: "Dim",
  },
  playbook: {
    triggerGreeting: "À l'accueil de l'appel",
    triggerItemAdded: "Après ajout d'un item au panier",
    triggerBookingRequest: "À une demande de RDV",
    triggerBeforeConfirm: "Avant la confirmation finale",
    triggerConfirm: "À la confirmation explicite",
    triggerObjection: "Si le client objecte",
    triggerGoodbye: "À la prise de congé",
    loading: "Chargement du playbook…",
    unavailable: "Playbook indisponible.",
    overline: "Configuration IA",
    title: "Playbook de l'agent",
    subtitle: "Couche 2 du système Dual-Level AI : personnalisez le comportement de votre agent au-dessus du Persona Verticale. Désactivez les étapes que vous ne voulez pas, ajoutez vos propres règles d'accueil ou de relance.",
    cancelChanges: "Annuler modifs",
    save: "Enregistrer",
    saving: "Enregistrement…",
    personaTitle: "Persona IA — verticale",
    personaDesc: "Comportement de base hérité de votre secteur (lecture seule).",
    verticalStepsTitle: "Étapes de la verticale ({n})",
    verticalStepsDesc: "Désactivez les étapes qui ne s'appliquent pas à votre enseigne.",
    noVerticalSteps: "Aucune étape configurée par défaut pour votre verticale.",
    disabledBadge: "désactivée",
    reactivate: "Réactiver",
    disable: "Désactiver",
    customStepsTitle: "Étapes personnalisées ({n})",
    customStepsDesc: "Ajoutez vos propres règles d'accueil, upsell, objections…",
    addStep: "Ajouter une étape",
    noCustomSteps: "Aucune étape personnalisée. Cliquez sur « Ajouter une étape » pour créer un script propre à votre enseigne.",
    customBadge: "Custom",
    delete: "Supprimer",
    titleLabel: "Titre",
    triggerLabel: "Déclencheur",
    instructionLabel: "Instruction donnée à l'agent",
    instructionPlaceholder: "Ex : « Demande systématiquement le nom et le prénom du client avant de finaliser la commande. »",
    effectivePreviewTitle: "Aperçu effectif ({n})",
    effectivePreviewDesc: "Ce que l'IA recevra après application de vos modifications.",
    effectiveNote: "Note : cet aperçu est figé. Cliquez sur « Enregistrer » puis rouvrez la page pour rafraîchir l'aperçu après vos modifications.",
    resetDialogTitle: "Annuler toutes vos modifications ?",
    resetItem1: "Toutes les étapes verticales seront réactivées.",
    resetItem2: "Vos étapes personnalisées seront supprimées.",
    resetConfirmLabel: "Réinitialiser",
    newStepDefaultLabel: "Nouvelle étape",
    tooShortToast: "Étape personnalisée n°{n} : l'instruction doit faire au moins 10 caractères.",
    savedToast: "Playbook enregistré — l'IA suit immédiatement vos règles",
  },
  setupWizard: {
    overline: "Configuration",
    titlePrefix: "Mettre en ligne ",
    subtitle: "Tout est modifiable plus tard depuis les Paramètres.",
    navIdentity: "Identité",
    navHours: "Horaires",
    navTelephony: "Téléphonie",
    navCatalog: "Catalogue",
    navTeam: "Équipe",
    navPublication: "Publication",
    optionalTag: "optionnel",
    hoursSavedToast: "Horaires enregistrés",
    identitySavedToast: "Identité enregistrée",
    invalidEmailToast: "Email invalide",
    inviteSentToast: "Invitation envoyée à {email}",
    publishedToast: "Établissement publié",
    planToastPre: 'Vous aviez sélectionné la formule "',
    planToastPost: '" — direction Facturation pour finaliser l\'abonnement.',
    billingAction: "Facturation",
    readyToPublish: "Tout est prêt pour publier.",
    missingStepsText: "Il reste {n} étape{plural} requise{plural} : {list}",
    updateBtn: "Mettre à jour",
    publishBtn: "Publier mon établissement",
    identityTitle: "Identité & coordonnées",
    identitySubtitle: "Utilisé sur votre page publique et dans les SMS automatiques envoyés à vos clients.",
    addressLabel: "Adresse postale",
    addressPlaceholder: "12 rue de la Pizza, 75011 Paris",
    phoneLabel: "Téléphone professionnel (qui sera renvoyé vers l'IA)",
    phonePlaceholder: "+33 1 23 45 67 89",
    logoLabel: "URL du logo (optionnel)",
    save: "Enregistrer",
    hoursTitle: "Horaires d'ouverture",
    hoursSubtitle: "L'IA refuse les rendez-vous hors plage et adapte ses réponses.",
    presetOffice: "Bureau · Lun-Ven 9h-18h",
    presetRestaurant: "Restaurant · Mar-Dim 11h30-22h30",
    preset247: "Ouvert 24/7",
    dayMonday: "Lundi",
    dayTuesday: "Mardi",
    dayWednesday: "Mercredi",
    dayThursday: "Jeudi",
    dayFriday: "Vendredi",
    daySaturday: "Samedi",
    daySunday: "Dimanche",
    telephonyTitle: "Téléphonie & renvoi d'appel",
    telephonySubtitle: "L'IA prend les appels quand vous ne décrochez pas (absence, ligne occupée, vacances). Vous gardez votre numéro pro.",
    m2InactivePre: "Le module ",
    m2InactiveBold: "M2 — Téléphonie IA",
    m2InactivePost: " n'est pas activé.",
    activateM2: "Activer M2",
    forwardingDone: "Le renvoi d'appel est déjà configuré.",
    forwardingCtaDesc: "Notre assistant vous guide en 5 étapes pour saisir le bon code GSM auprès de votre opérateur (Orange, SFR, Free, Bouygues…). Réversible via ",
    launchForwarding: "Lancer l'assistant de renvoi",
    catalogTitle: "Catalogue",
    catalogSubtitle: "Sans article ni prestation, l'assistant vocal n'a rien à proposer au téléphone — c'est la condition la plus importante avant de publier.",
    catalogDone: "Votre catalogue contient déjà au moins un article.",
    catalogEmpty: "Aucun article ou prestation pour le moment.",
    startFromTemplate: "Partir d'un modèle",
    manageCatalog: "Gérer mon catalogue",
    addManually: "Ajouter un article manuellement",
    teamTitle: "Équipe",
    teamSubtitle: "Optionnel — vous pouvez inviter un coéquipier maintenant ou plus tard depuis l'onglet Équipe.",
    invitePlaceholder: "manager@votreentreprise.fr",
    invite: "Inviter",
    defaultRole: "Rôle par défaut : MANAGER.",
    publicationTitle: "Publication",
    publicationSubtitle: "Récapitulatif de ce qui est requis avant de mettre votre établissement en ligne.",
    toComplete: "à compléter",
    missingPre: "Il manque : ",
  },
  bookings: {
    overline: "Réservations",
    title: "Calendrier des réservations",
    subtitle: "Glissez-déposez pour déplacer une réservation. Cliquez sur un créneau libre pour en créer une.",
    syncCalendars: "Sync calendriers",
    syncSuccessToast: "Google : {n} créneaux importés",
    googleNotConnectedToast: "Google Calendar non connecté — allez dans Paramètres pour vous connecter",
    syncErrorToast: "Sync Google : {msg}",
    kioskMode: "Mode kiosque",
    newBooking: "Nouvelle réservation",
    kpiTotal: "Total",
    kpiPending: "En attente",
    kpiConfirmed: "Confirmées",
    kpiCancelled: "Annulées",
    kpiNoShow: "No-show",
    filterResource: "Ressource",
    allResources: "Toutes les ressources",
    filterStatus: "Statut",
    allStatuses: "Tous statuts",
    statusPending: "En attente",
    statusConfirmed: "Confirmées",
    statusCancelled: "Annulées",
    statusNoShow: "No-show",
    statusCompleted: "Terminées",
    filterSource: "Source",
    allSources: "Toutes sources",
    sourceAi: "🤖 Via IA",
    sourceHuman: "Humain / Manuel",
    calToday: "Aujourd'hui",
    calMonth: "Mois",
    calWeek: "Semaine",
    calDay: "Jour",
    calList: "Liste",
    dialogTitleEdit: "Détails de la réservation",
    dialogTitleNew: "Nouvelle réservation",
    noResourcesHint: "Aucune ressource. Créez-en une dans la page Ressources.",
    emptyTitle: "Aucune réservation pour le moment",
    emptyDescription: "Cliquez sur un créneau du calendrier ou utilisez « Nouvelle réservation » pour créer la première.",
    emptyAction: "Nouvelle réservation",
    serviceLabel: "Prestation (optionnel)",
    serviceNone: "— Aucune —",
    clientNameLabel: "Nom complet du client",
    firstNameLabel: "Prénom (optionnel)",
    lastNameLabel: "Nom (optionnel)",
    birthDateLabel: "Date de naissance",
    emailLabel: "Email",
    phoneLabel: "Téléphone",
    startLabel: "Début",
    endLabel: "Fin (optionnel)",
    partyLabel: "Couverts",
    notesLabel: "Notes",
    confirmBtn: "Confirmer",
    cancelBtn: "Annuler",
    saveBtn: "Enregistrer",
    updatedToast: "Réservation mise à jour",
    createdToast: "Réservation créée",
    cancelledToast: "Réservation annulée",
    confirmedToast: "Réservation confirmée",
    movedToast: "Réservation déplacée",
    resizedToast: "Réservation redimensionnée",
    cancelDialogTitle: "Annuler cette réservation ?",
    cancelDialogItem: "Le client ne sera pas notifié automatiquement — pensez à l'appeler si besoin.",
    cancelDialogConfirm: "Annuler la réservation",
    resourceDoctor: "Médecin",
    resourceDoctorPlaceholder: "Sélectionner un praticien…",
    resourceHotel: "Chambre",
    resourceHotelPlaceholder: "Sélectionner une chambre…",
    resourceHairdresser: "Styliste",
    resourceHairdresserPlaceholder: "Sélectionner un styliste…",
    resourceBeauty: "Esthéticienne",
    resourceBeautyPlaceholder: "Sélectionner…",
    resourceDefault: "Ressource",
    resourceDefaultPlaceholder: "Sélectionner…",
  },
  team: {
    nameRequired: "Le nom est obligatoire.",
    emailRequired: "L'e-mail est obligatoire.",
    emailInvalid: "Adresse e-mail invalide.",
    passwordRequired: "Mot de passe obligatoire (8 caractères minimum) si vous n'envoyez pas d'invitation par e-mail.",
    fixErrorsToast: "Corrigez les champs en rouge avant d'enregistrer.",
    inviteSentToast: "Invitation envoyée par e-mail",
    memberAddedToast: "Membre ajouté",
    memberRemovedToast: "Membre supprimé",
    membersRemovedToast: "{n} membre(s) supprimé(s)",
    resendConfirm: "Renvoyer l'invitation à {email} ?",
    resendSuccessToast: "Invitation renvoyée par e-mail",
    seatCostTitle: "Coût des sièges",
    seatCostSubtitle: "{n} membre(s) actif(s) — facturation mensuelle estimée",
    perMonth: "/mois",
    selectedCount: "{n} membre(s) sélectionné(s)",
    clearSelection: "Annuler",
    deleteSelection: "Supprimer la sélection",
    roleLabel: "Rôle",
    roleHint: "Détermine les permissions ET le coût du siège (voir tarification ci-dessous).",
    emailHint: "L'invitation (ou les identifiants) sera envoyée à cette adresse.",
    sendInviteLabel: "Envoyer un e-mail d'invitation (recommandé)",
    selectAllAria: "Sélectionner tout",
    selectRowAria: "Sélectionner {name}",
    resendInviteTitle: "Renvoyer l'invitation",
    noMembers: "Aucun membre",
    emptyTitle: "Aucun membre dans l'équipe",
    emptyDescription: "Invitez un collègue pour lui donner accès au tableau de bord.",
    removeTitle: "Supprimer ce membre ?",
    removeItem1: "Il perdra immédiatement l'accès au tableau de bord.",
    removeItem2: "Son historique d'actions (journal d'audit) est conservé.",
    removeConfirmLabel: "Supprimer",
    bulkRemoveTitle: "Supprimer {n} membre(s) ?",
    bulkRemoveItem1: "Chaque membre sélectionné perd immédiatement l'accès au tableau de bord.",
    bulkRemoveItem2: "Leur historique d'actions (journal d'audit) est conservé.",
  },
  settings: {
    dayMonday: "Lundi", dayTuesday: "Mardi", dayWednesday: "Mercredi",
    dayThursday: "Jeudi", dayFriday: "Vendredi", daySaturday: "Samedi", daySunday: "Dimanche",
    businessNameRequired: "Le nom de l'établissement est obligatoire.",
    emailInvalid: "Adresse e-mail invalide.",
    fixErrorsToast: "Corrigez les champs en rouge avant d'enregistrer.",
    savedToast: "Paramètres enregistrés",
    readOnlyTitle: "Lecture seule — vous n'avez pas la permission settings.update / tenant.update",
    saveAllTitle: "Enregistre toutes les sections en une fois",
    readOnlyBannerTitle: "Mode lecture seule",
    readOnlyBannerBodyPre: "Vous pouvez consulter les paramètres mais pas les modifier. Demandez à votre OWNER d'activer la permission ",
    readOnlyBannerBodyPost: " sur votre rôle.",
    groupGeneral: "Informations générales",
    groupTelephonyAi: "Téléphonie & IA",
    groupBookings: "Réservations",
    draftSaveBadge: "Nécessite Enregistrer",
    brandingTitle: "Branding",
    brandingSubtitle: "Logo affiché sur votre page publique et vos e-mails. PNG, JPG, WEBP ou SVG, max 2 MB.",
    noLogo: "Aucun logo",
    uploadingLogo: "Envoi…",
    replaceLogo: "Remplacer le logo",
    uploadLogoBtn: "Importer un logo",
    remove: "Supprimer",
    identityTitle: "Identité",
    businessNameHint: "Affiché sur votre page publique, vos e-mails de confirmation et présenté par l'assistant IA au téléphone.",
    contactEmailHint: "Reçoit les notifications de compte (factures, alertes). Non affiché aux clients.",
    countryFrance: "France",
    countryBelgium: "Belgique",
    countrySwitzerland: "Suisse",
    countryLuxembourg: "Luxembourg",
    timezoneLabel: "Fuseau horaire",
    timezoneHint: "Utilisé pour calculer vos journées comptables et rapports (\"aujourd'hui\", clôture de journée) à la bonne heure locale.",
    timezoneParis: "Paris (France métropolitaine)",
    timezoneBrussels: "Bruxelles (Belgique)",
    timezoneZurich: "Zurich (Suisse)",
    timezoneLuxembourg: "Luxembourg",
    timezoneReunion: "La Réunion",
    timezoneGuadeloupe: "Guadeloupe",
    timezoneMartinique: "Martinique",
    addressLabel: "Adresse",
    addressHint: "Utilisée sur votre page publique et pour situer votre établissement auprès des clients.",
    hoursTitle: "Horaires d'ouverture",
    hoursSubtitle: "Utilisés par la page publique, le module de réservation et l'assistant IA.",
    closedLabel: "Fermé",
    telephonyTitle: "Téléphonie & numéros",
    telephonySubtitle: "Numéro Twilio, renvoi d'appel, message d'accueil et règles de prise en charge par l'IA.",
    m3Title: "Base de connaissances IA",
    m3Subtitle: "FAQ, menu, services et documents utilisés par l'IA pour répondre aux clients.",
    guardrailsTitle: "Garde-fous de l'IA",
    guardrailsSubtitle: "Durée max d'appel, gestion des sujets hors-sujet, étapes du playbook.",
    paymentPolicyTitle: "Politique de paiement",
    paymentPolicySubtitle: "Acompte obligatoire pour les nouveaux clients, validation pré-commande, etc.",
    guardrailsDurationLabel: "Durée maximale d'un appel",
    guardrailsDurationHint: "Au-delà de cette durée, l'IA conclut poliment et crée un rappel.",
    guardrailsDurationUnit: "secondes (30-900)",
    guardrailsSoftWarningLabel: "Avertir l'IA à partir de",
    guardrailsSoftWarningUnit: "secondes (l'IA est priée de conclure)",
    guardrailsMaxTurnsLabel: "Nombre max de tours client",
    guardrailsOffTopicLabel: "Détection des hors-sujets",
    guardrailsOffTopicHint: "Si le client parle de sujets sans rapport avec votre activité, l'IA propose un rappel par votre équipe puis raccroche.",
    guardrailsOffTopicEnable: "Activer la détection",
    guardrailsToleranceLabel: "Tolérance (hors-sujets consécutifs)",
    guardrailsAutoCallbackLabel: "Créer automatiquement un rappel",
    guardrailsAllowedTopicsLabel: "Sujets autorisés additionnels (un par ligne)",
    guardrailsAllowedTopicsPlaceholder: "Ex : Cartes cadeau\nÉvénement privé\nAnniversaire",
    guardrailsSaving: "Enregistrement…",
    guardrailsSaveBtn: "Enregistrer les garde-fous",
    guardrailsSavedToast: "Garde-fous IA enregistrés",
    guardrailsPlaybookOverlinePrefix: "Playbook métier — verticale",
    guardrailsVerticalUndefined: "non définie",
    guardrailsPlaybookTitle: "Étapes du dialogue IA",
    guardrailsPlaybookHint: "Ces étapes sont définies par votre verticale. Désactivez celles qui ne s'appliquent pas à votre établissement.",
    guardrailsSavePlaybookBtn: "Enregistrer le playbook",
    guardrailsPlaybookSavedToast: "Playbook mis à jour",
    paymentPolicyEnableLabel: "Activer le paiement avant validation",
    paymentPolicyModeLabel: "Mode",
    paymentPolicyModeFull: "Intégral",
    paymentPolicyModeFullHint: "100% du total",
    paymentPolicyModeDeposit: "Acompte",
    paymentPolicyModeDepositHint: "% configurable",
    paymentPolicyDepositPctLabel: "Pourcentage d'acompte :",
    paymentPolicyChannelsLabel: "Canaux d'envoi du lien",
    paymentPolicyChannelSms: "SMS Twilio",
    paymentPolicyChannelWhatsapp: "WhatsApp",
    paymentPolicyChannelActive: "actif",
    paymentPolicyExpiryLabel: "Délai d'expiration du lien (min)",
    paymentPolicyExpiryHint: "Au-delà de ce délai sans paiement, la commande est automatiquement annulée.",
    paymentPolicyStripeNotice: "Les paiements sont traités par Stripe sur le compte plateforme. Les reversements vers votre compte se font selon les modalités de votre contrat AI Commerce OS.",
    paymentPolicySaving: "Enregistrement…",
    paymentPolicySaveBtn: "Enregistrer",
    paymentPolicySavedToast: "Politique de paiement enregistrée",
    posIntegrationsTitle: "Caisses (POS)",
    posIntegrationsSubtitle: "Connectez votre caisse pour y transmettre automatiquement vos commandes.",
    posIntegrationsLoading: "Chargement…",
    posIntegrationsEmpty: "Aucune caisse compatible pour le moment.",
    posIntegrationsAvailableBadge: "Disponible",
    posIntegrationsComingSoonBadge: "Bientôt disponible",
    posIntegrationsActiveBadge: "Activée",
    posIntegrationsConfiguredBadge: "Configurée",
    posIntegrationsCapabilityOrderPush: "Envoi des commandes",
    posIntegrationsCapabilityPaymentPush: "Encaissement",
    posIntegrationsCapabilityCatalogSync: "Synchro catalogue",
    posIntegrationsCapabilityPullWebhook: "Réception de commandes",
    posIntegrationsConfigureBtn: "Configurer",
    posIntegrationsDeactivateBtn: "Désactiver",
    posIntegrationsCredentialsLabel: "Identifiants API",
    posIntegrationsCredentialsHint: "Fournis par votre caisse — jamais affichés une fois enregistrés.",
    posIntegrationsSaveBtn: "Enregistrer et activer",
    posIntegrationsSaving: "Enregistrement…",
    posIntegrationsSavedToast: "Intégration enregistrée",
    posIntegrationsDeactivatedToast: "Intégration désactivée",
    posIntegrationsCancelBtn: "Annuler",
    posIntegrationsUnavailableNotice: "Cette caisse est anticipée dans notre feuille de route mais son intégration n'est pas encore développée — contactez-nous si vous l'utilisez, pour prioriser son développement.",
    bookingTitle: "Paramètres des réservations",
    bookingSubtitle: "Adaptez le comportement des réservations à votre métier (mode de confirmation, délais, acompte…).",
    confirmationModeLabel: "Mode de confirmation",
    confirmationAuto: "Automatique (confirmée immédiatement)",
    confirmationManual: "Manuelle (en attente de validation)",
    confirmationHint: "AUTO : recommandé pour Restaurant / Coiffeur. MANUAL : recommandé pour Hôtel / Médecin.",
    slotStepLabel: "Pas de créneaux (minutes)",
    minLeadLabel: "Délai minimum avant réservation (minutes)",
    maxLeadLabel: "Délai max de prise (jours)",
    cancelWindowLabel: "Fenêtre d'annulation (heures)",
    autoAssignLabel: "Affecter automatiquement une ressource (Restaurant)",
    depositRequiredLabel: "Demander un acompte à la réservation",
    depositPctLabel: "Acompte — % du total",
    depositEurLabel: "Acompte — montant fixe (€)",
    shareTitle: "Partage public & QR Code",
    shareSubtitle: "Imprimez le QR code à l'accueil de votre établissement, glissez-le dans une vitrine ou intégrez-le à vos supports. Vos clients scannent et arrivent directement sur votre page de réservation.",
    testPage: "Tester la page",
    unavailable: "Indisponible",
    qrAlt: "QR code de réservation",
    publicLinkLabel: "Lien de réservation public",
    shareHint: "Partagez ce lien sur Google My Business, Instagram, votre site web ou par SMS.",
    downloadsLabel: "Téléchargements",
    downloadPngBtn: "QR PNG (HD)",
    downloadSvgBtn: "QR SVG (vectoriel)",
    downloadPdfBtn: "Affiche A4 (PDF)",
    posterHint: "L'affiche A4 inclut votre nom et un appel à scanner, prête à imprimer pour votre accueil.",
    ideasSummary: "Idées d'utilisation",
    idea1: "Imprimez l'affiche A4 et collez-la dans votre vitrine ou à la caisse.",
    idea2: "Ajoutez le QR code sur vos cartes de visite, menus ou factures.",
    idea3: "Postez le QR code sur Instagram / Facebook avec un appel à l'action.",
    idea4: "Ajoutez le lien à votre fiche Google Business pour booster les réservations.",
    idea5: "Envoyez le lien par SMS aux clients qui appellent en dehors des horaires.",
    icalTitle: "Synchronisation iCal",
    icalSubtitle: "Abonnez-vous à ce flux dans Google Agenda, Outlook ou Apple Calendar pour voir vos réservations en lecture seule sur votre calendrier personnel.",
    icalUrlLabel: "URL iCal (lecture seule)",
    icalHint: "Conservez cette URL privée — toute personne y ayant accès verra vos réservations. Régénérez le jeton pour casser les abonnements existants.",
    howToSubscribeSummary: "Comment s'abonner ?",
    icalGoogleHeader: "Google Agenda",
    icalGoogleStep1: "Ouvrez Google Agenda → barre latérale gauche → « Autres agendas » → « + » → « À partir de l'URL ».",
    icalGoogleStep2: "Collez l'URL ci-dessus et cliquez sur « Ajouter l'agenda ».",
    icalOutlookHeader: "Outlook",
    icalOutlookStep1: "Outlook web → Calendrier → « Ajouter un calendrier » → « S'abonner à partir du web ».",
    icalOutlookStep2: "Collez l'URL puis validez.",
    icalAppleHeader: "Apple Calendar (iPhone/Mac)",
    icalAppleStep1: "iPhone : Réglages → Calendrier → Comptes → Ajouter un compte → Autre → S'abonner à un calendrier. Collez l'URL.",
    icalAppleStep2: "Mac : Fichier → Nouvel abonnement Calendrier. Collez l'URL.",
    subsTitle: "Calendriers externes à importer",
    subsSubtitle: "Ajoutez autant d'URLs iCal (.ics) que vous voulez (Doctolib, Outlook, Calendly, agenda Google public…). Sync auto toutes les 5 min.",
    subResourceLabel: "Ressource",
    subAllResources: "Toutes les ressources",
    subLastSync: "Dernière synchro",
    subSlotsSuffix: "créneaux",
    subNone: "Aucun abonnement. Ajoutez-en un ci-dessous.",
    subNamePlaceholder: "Nom (ex: Doctolib Dr Dupont)",
    subUrlPlaceholder: "URL iCal (.ics)",
    subSyncBtn: "Synchroniser",
    subAddBtn: "Ajouter",
    googleTitle: "Google Calendar",
    googleSubtitle: "Synchronisation bidirectionnelle : vos réservations sont poussées dans Google Calendar et les événements de votre agenda Google bloquent les créneaux dans AI Commerce OS.",
    googleConnected: "Connecté",
    googleNotConnected: "Non connecté",
    googleAccountLabel: "Compte",
    googleCalendarLabel: "Agenda",
    googleLastPullLabel: "Dernier pull (Google → ACOS)",
    googleEventsReadSuffix: "événements lus",
    googleLastPushLabel: "Dernier push (ACOS → Google)",
    googleLastPushErrorLabel: "Dernière erreur push",
    googleConnectBtn: "Connecter",
    googlePullBtn: "Pull (busy → ACOS)",
    googlePushBtn: "Push (ACOS → Google)",
    googleDisconnectBtn: "Déconnecter",
    googleNotConfiguredWarning: "L'intégration Google Calendar n'est pas configurée côté serveur. Contactez l'administrateur.",
    policyTitle: "Politique d'annulation",
    policySubtitle: "Configurez les seuils qui font basculer un client en liste grise (vigilance) ou en liste noire (blocage). Matching prénom + nom + date de naissance, fallback email/téléphone.",
    policyEnableLabel: "Activer la gestion automatique des listes grise et noire",
    policyGreyThresholdLabel: "Seuil liste grise (nb annulations)",
    policyBlackThresholdLabel: "Seuil liste noire (nb annulations)",
    policyLookbackLabel: "Fenêtre de calcul (jours)",
    policyLastMinWindowLabel: "Fenêtre « dernière minute » (heures avant le RDV)",
    policyLastMinBlacklistLabel: "Annulation de dernière minute = blacklist immédiate",
    policyNoshowLabel: "No-show compte comme une annulation de dernière minute",
    subAddedToast: "Abonnement ajouté — synchronisation en cours…",
    subSyncedToast: "Synchronisé — {n} créneaux importés",
    subDeletedToast: "Abonnement supprimé",
    qrDownloadStartedToast: "Téléchargement démarré",
    posterDownloadedToast: "Affiche A4 téléchargée",
    linkCopiedToast: "Lien copié dans le presse-papier",
    copyFailedToast: "Impossible de copier",
    googleConnectedToast: "Google Calendar connecté",
    googleErrorToastPrefix: "Échec Google : ",
    unknownError: "erreur inconnue",
    googleDisconnectedToast: "Google Calendar déconnecté",
    googleSyncDoneToast: "Synchronisation terminée — {n} créneaux importés",
    policySavedToast: "Politique d'annulation enregistrée",
    icalUrlCopiedToast: "URL copiée dans le presse-papier",
    icalRotatedToast: "URL iCal régénérée",
    bookingSettingsSavedToast: "Paramètres de réservation enregistrés",
    logoUpdatedToast: "Logo mis à jour",
    logoRemovedToast: "Logo supprimé",
    googleBackfillToast: "Push terminé — {ok} OK, {failed} échec",
    deleteLogoTitle: "Supprimer le logo ?",
    deleteLogoItem: "Votre page publique et vos e-mails de confirmation n'afficheront plus de logo.",
    deleteSubTitle: "Supprimer cet abonnement ?",
    deleteSubItem: "Les créneaux déjà importés depuis ce calendrier externe resteront, mais ne seront plus synchronisés.",
    disconnectGoogleTitle: "Déconnecter Google Calendar ?",
    disconnectGoogleItem1: "Les événements déjà importés depuis Google seront supprimés de AI Commerce OS.",
    disconnectGoogleItem2: "Les réservations ne seront plus poussées vers votre agenda Google.",
    disconnectBtn: "Déconnecter",
    rotateIcalTitle: "Régénérer l'URL iCal ?",
    rotateIcalItem: "Tous les abonnements existants pointant vers l'ancienne URL (Google Agenda, Outlook, Apple Calendar…) cesseront de se synchroniser — il faudra les recréer avec la nouvelle URL.",
    rotateBtn: "Régénérer",
  },
  modules: {
    activatedToast: "Module {key} activé",
    deactivatedToast: "Module {key} désactivé",
    modulesTitle: "Modules",
    activeSuffix: "actifs",
    included: "inclus",
    personaTitle: "Persona IA — verticale",
    personaSubtitle: "Comportement de base de l'agent, hérité de votre secteur.",
    voiceTitle: "Voix de l'assistant IA",
    voiceSubtitle: "Choisissez la stack vocale. Facturation à la seconde d'après le tarif plateforme — voir Facturation.",
    billingSummaryTitle: "Modules · €/mois",
    billingSummaryHint: "Coût mensuel fixe des modules activés. Les seats utilisateurs et la conso voix (à la seconde) sont facturés en plus dans la page Facturation.",
    viewBillingLink: "Voir la facturation détaillée",
  },
  publicPageEditor: {
    blockHero: "Bandeau d'accueil",
    blockAbout: "À propos",
    blockServices: "Services / Prestations",
    blockHours: "Horaires d'ouverture",
    blockAvailability: "Prochains créneaux disponibles",
    blockLocation: "Adresse",
    blockFaq: "Questions fréquentes",
    noPermissionToast: "Vous n'avez pas la permission de modifier cette page.",
    readOnlyTitle: "Lecture seule — vous n'avez pas la permission de modifier",
    pageTitle: "Page publique",
    subtitlePre: "Tout-en-un pour configurer votre vitrine publique ",
    subtitlePost: " : identité visuelle, contenus marketing, carte/prestations. Aperçu live à droite.",
    openBtn: "Ouvrir",
    saveAllBtn: "Tout enregistrer",
    savingBtn: "Enregistrement…",
    savedToast: "Page publique enregistrée",
    readOnlyBannerTitle: "Mode lecture seule",
    readOnlyBannerP1: "Vous pouvez consulter la page publique mais pas la modifier. Demandez à votre OWNER d'activer les permissions ",
    readOnlyBannerP2: " ou ",
    readOnlyBannerP3: " sur votre rôle.",
    brandingTitle: "Identité visuelle",
    brandingCaption: "Logo + couleur d'accent appliqués au header, aux boutons et aux prix sur votre vitrine.",
    accentColorLabel: "Couleur d'accent",
    logoUrlLabel: "URL du logo",
    logoUrlHint: "Pour uploader, utilisez la page Paramètres → Branding.",
    taglineLabel: "Phrase d'accroche (tagline)",
    taglinePlaceholder: "Ex : Le goût du Sud-Ouest depuis 1998",
    catalogTitle: "Notre carte",
    catalogCaption: "La carte affichée sur votre vitrine se construit automatiquement depuis votre catalogue M5. Elle inclut prix, photos, ingrédients (BOM) et allergènes.",
    statCategories: "Catégories",
    statItems: "Articles",
    statAvailable: "Disponibles",
    statOutOfStock: "En rupture",
    previewCategoriesLabel: "Aperçu catégories",
    emptyCatalogWarning: "Votre catalogue est vide — la section « Notre carte » ne s'affichera pas sur la vitrine tant qu'aucun article n'y figure.",
    manageCatalogBtn: "Gérer la carte",
    servicesTitle: "Vos prestations / consultations",
    servicesCaption: "Les consultations affichées sur votre vitrine proviennent du module M4 Services.",
    statServicesTotal: "Prestations totales",
    statServicesActive: "Actives",
    manageServicesBtn: "Gérer les prestations",
    blocksTitle: "Sections marketing",
    blocksCaption: "Bandeau d'accueil, à propos, horaires, adresse, FAQ. Activez/désactivez chaque section et personnalisez son texte.",
    titleLabel: "Titre",
    subtitleLabel: "Sous-titre",
    bodyLabel: "Contenu",
    addressLabel: "Adresse",
    ctaLabelLabel: "Libellé bouton",
    slotsCountLabel: "Nombre de créneaux affichés",
    slotsHint: "Au clic sur un créneau, le visiteur est redirigé vers le formulaire de réservation avec la date et l'heure pré-remplies.",
    contactTitle: "Coordonnées",
    contactCaption: "Affichées dans le footer et sur la section contact. Modifiables depuis les Paramètres.",
    emailLabel: "Email",
    phoneLabel: "Téléphone",
    editInSettingsBtn: "Modifier dans Paramètres",
    notProvided: "Non renseigné",
    previewLive: "Aperçu live",
    previewAlt: "Aperçu de {name}",
    previewHint: "Sauvegardez puis cliquez sur ↻ pour voir vos changements.",
    loading: "Chargement…",
  },
  auditLog: {
    platform: "Plateforme",
    globalTitle: "Audit global",
    globalSub: "Tous les événements de la plateforme (cliquez pour voir le détail).",
    colDate: "Date",
    colAction: "Action",
    colTenant: "Tenant",
    colResource: "Ressource",
    colDetails: "Détails",
    noEvents: "Aucun événement",
  },
  adminHealth: {
    overline: "Surveillance backend",
    title: "Santé système",
    subtitle: "Statut live des dépendances externes + capture des exceptions backend (équivalent mini-Sentry).",
    errorsTitle: "Erreurs backend",
    errorsSubtitle: "Exceptions capturées par le middleware — groupées par fingerprint.",
    kpiOpenGroups: "Groupes ouverts",
    kpiSeen24h: "Vus dernières 24h",
    kpiSeen7d: "Vus 7 derniers jours",
    emptyTitle: "Aucune erreur ouverte",
    emptyDesc: "Le backend est en parfaite santé.",
    seenAt: "Vu {date}",
    metaTitle: "Métadonnées",
    rowFirst: "Premier",
    rowFingerprint: "Fingerprint",
    rowIp: "IP",
    rowUser: "User",
    rowTenant: "Tenant",
    topFrameTitle: "Top frame",
    tracebackTitle: "Traceback",
    markResolved: "Marquer résolu",
    resolvedToast: "Erreur archivée",
    confirmTitle: "Marquer cette erreur comme résolue ?",
    confirmItem: "Elle sera archivée et ne réapparaîtra plus dans la liste tant qu'elle ne se reproduit pas.",
    loading: "Chargement…",
  },
  adminLeads: {
    overline: "Plateforme",
    title: "Leads — calculateur de prix",
    subtitle: "Visiteurs ayant demandé leur devis personnalisé depuis la landing page. Email avec lien d'inscription pré-rempli envoyé automatiquement.",
    colDate: "Date",
    colEmail: "Email",
    colVertical: "Verticale",
    colModules: "Modules",
    colMonthly: "€ / mois",
    colStatus: "Statut",
    statusUpdatedToast: "Statut mis à jour",
    emptyTitle: "Aucun lead",
    emptyDesc: "Les demandes de devis envoyées depuis la page tarifs publique apparaîtront ici.",
    statusNew: "Nouveau",
    statusContacted: "Contacté",
    statusConverted: "Converti",
    statusDropped: "Abandonné",
  },
  adminDocuments: {
    toolboxOverline: "Boîte à outils",
    title: "Documents & ressources",
    subtitleP1: "Templates imprimables vierges + édition tarifaire + pages publiques. Pour les versions ",
    subtitleBold: "pré-remplies avec un client précis",
    subtitleP2: ", allez sur sa fiche tenant et utilisez les boutons « Imprimer » du menu Actions.",
    printableTemplatesOverline: "Templates imprimables (vierges)",
    onboardingPackTitle: "Pack onboarding",
    onboardingPackDesc: "Fiche client + checklist visite 6 phases + tableau des codes USSD. À imprimer avant chaque RDV prospect.",
    contractTitle: "Contrat de service",
    contractDesc: "Formules + options + CGV + signatures. Prix synchronisés avec la config tarifaire ci-dessous.",
    flyerTitle: "Brochure 3 volets",
    flyerDesc: "Plaquette commerciale A4 paysage, recto/verso, avec logo. À distribuer en prospection.",
    newBadge: "Nouveau",
    publicPagesOverline: "Pages publiques",
    pricingPageTitle: "Page tarifs publique",
    pricingPageDesc: "Vos prospects découvrent les 3 formules + options. Le bouton « Demander un devis » crée un lead automatiquement.",
    formulasBadge: "{n} formules",
    pricingConfigTitle: "Config tarifaire (JSON)",
    pricingConfigDesc: "Source de vérité des prix consommée par le contrat, la page publique et l'API.",
    openLabel: "Ouvrir",
    loadFailedToast: "Impossible de charger la tarification : ",
    savedToast: "Tarification enregistrée et publiée",
    saveFailedToast: "Échec de l'enregistrement : ",
    resetToast: "Tarification réinitialisée",
    resetFailedToast: "Échec du reset : ",
    editingOverline: "Édition de la tarification",
    loading: "Chargement…",
    editTitle: "Modifier les prix en direct",
    editSubtitleP1: "Les changements sont publiés ",
    editSubtitleB1: "immédiatement",
    editSubtitleP2: " sur la page publique ",
    editSubtitleP3: ", dans le contrat imprimable et dans l'API.",
    resetBtn: "Réinitialiser",
    savingBtn: "Enregistrement…",
    saveBtn: "Enregistrer",
    upToDateBtn: "À jour",
    dirtyBannerPre: "Modifications non publiées. Cliquez sur ",
    dirtyBannerBold: "Enregistrer",
    dirtyBannerPost: " pour appliquer.",
    currencyLabel: "Devise",
    vatLabel: "TVA",
    engagementLabel: "Engagement (mois)",
    formulasOverline: "Formules",
    addFormulaBtn: "Ajouter une formule",
    newFormulaName: "Nouvelle formule",
    voiceTiersOverline: "Niveaux de voix IA (add-ons)",
    addVoiceTierBtn: "Ajouter un niveau voix",
    newVoiceTierName: "Nouveau tier voix",
    voiceTiersHint: "Standard = Polly (inclus), Pro = Deepgram Aura 2 (1.99€/mo), Premium = ElevenLabs (50€ setup + 3€/mo). Cascade automatique : Premium ↘ Pro ↘ Standard en cas d'indisponibilité fournisseur.",
    optionsOverline: "Options à la carte",
    addOptionBtn: "Ajouter une option",
    newOptionLabel: "Nouvelle option",
    resetConfirmTitle: "Réinitialiser la tarification aux valeurs par défaut ?",
    resetConfirmItem: "L'override personnalisé sera supprimé — formules, options et tiers voix repassent au défaut du code.",
    keyLabel: "Clé",
    nameLabel: "Nom",
    priceMonthlyLabel: "€ HT / mois",
    badgeLabel: "Badge",
    badgePlaceholder: "ex: Recommandé",
    featuredLabel: "Mise en avant",
    removeFormulaAria: "Supprimer la formule {name}",
    modulesIncludedLabel: "Modules inclus (séparés par virgule)",
    modulesPlaceholder: "M1, M2, M3…",
    featuresLabel: "Fonctionnalités (1 par ligne)",
    labelLabel: "Libellé",
    priceOptionalLabel: "Prix € (vide = sur devis)",
    unitLabel: "Unité",
    unitPlaceholder: "/ mois",
    recurringLabel: "Récurrent",
    removeOptionAria: "Supprimer l'option {label}",
    providerLabel: "Provider",
    providerPlaceholder: "ex: deepgram_aura2",
    setupFeeLabel: "€ setup",
    monthlyLabel: "€ / mois",
    pricePerMinLabel: "Prix / min (facturation réelle)",
    pricePerMinPlaceholder: "Non défini pour ce tier",
    pricePerMinEditLink: "Modifier →",
    voiceIdLabel: "Voice ID par défaut",
    taglineLabel: "Tagline (1 ligne)",
    benefitsLabel: "Bénéfices (1 par ligne)",
    includedInSubLabel: "Inclus dans l'abonnement (pas d'add-on facturé)",
    removeBtn: "Supprimer",
  },
  adminBilling: {
    overline: "Plateforme",
    title: "Facturation B2B",
    subtitle: "Vue cross-tenant des abonnements, du markup IA, des factures et du cron mensuel.",
    generateNowBtn: "Générer maintenant",
    tabOverview: "Vue d'ensemble",
    tabLive: "Conso temps réel",
    tabPlans: "Plans & Markups",
    tabCosts: "Coûts & marges",
    tabInvoices: "Factures",
    tabCron: "Planificateur",
    tabVoicePricing: "Tarification voix",
    tabRevenue: "Revenus",
    pricingMovedPre: "La définition des tarifs (modules, voix, SMS/WhatsApp, marges, tarif contractuel) a déménagé — ",
    pricingMovedLink: "voir la page Tarification",
    loading: "Chargement…",
    invoicesGeneratedToast: "{count} factures générées pour {month}",
    generateConfirmTitle: "Générer les factures pour {month} ?",
    generateConfirmItem: "Toutes les factures du mois seront (re)générées pour TOUS les tenants actifs de la plateforme, pas seulement un seul.",
    totalBillableLabel: "Total facturable",
    tenantsCountSuffix: "tenant{plural} · mois {month}",
    refreshBtn: "Rafraîchir",
    colTenant: "Tenant",
    colVertical: "Verticale",
    colStatus: "Statut",
    colSubscription: "Abonnement",
    colTelephony: "Téléphonie",
    colAiMarkup: "Markup IA",
    colTotal: "Total",
    colInvoice: "Facture",
    detailLink: "Détail",
    noTenants: "Aucun tenant",
    telephonyPricesTitle: "Tarifs téléphonie variables",
    telephonyPricesSubtitle: "Coût refacturé au tenant pour chaque minute voix et chaque SMS consommé. Inclut le coût Twilio + votre marge.",
    voiceCentsLabel: "Voix (centimes / minute)",
    voiceCentsObsoleteNote: "N'affecte plus la facturation réelle — la voix est débitée du wallet prépayé par appel (voir Tarifs voix). Champ conservé pour l'historique uniquement.",
    smsCentsLabel: "SMS (centimes / message)",
    perMin: " / min",
    perSms: " / SMS",
    saveBtn: "Sauver",
    noChangesToast: "Aucun changement",
    telephonyUpdatedToast: "Tarifs téléphonie mis à jour",
    moduleCatalogTitle: "Catalogue modulaire",
    moduleCatalogSubtitle: "Tarif mensuel HT par palier. Les limites définissent le seuil au-delà duquel le palier supérieur s'impose.",
    moduleUpdatedToast: "{key} mis à jour",
    monthlyTierPriceLabel: "Tarif mensuel (centimes)",
    emptyCatalog: "Catalogue vide.",
    aiMarkupTitle: "Markup IA par verticale",
    aiMarkupSubtitle: "Surfacturation appliquée à la consommation IA. Par appel ou par minute.",
    colMode: "Mode",
    colAmountCents: "Montant (cents)",
    markupUpdatedToast: "Markup {vk} mis à jour",
    perCall: "Par appel",
    perMinuteOpt: "Par minute",
    colId: "ID",
    colMonth: "Mois",
    colIssued: "Émise",
    colLines: "Lignes",
    noInvoices: "Aucune facture pour {month}",
    invoiceTitlePrefix: "Facture ",
    invoiceTitleFallback: "Facture",
    tenantMonthCurrency: "Tenant {tenant} · Mois {month} ·",
    issuedOnLabel: "Émise le",
    monthBilledLabel: "Mois facturé",
    linesLabel: "Lignes",
    totalHtLabel: "Total HT",
    colType: "Type",
    colLabel: "Libellé",
    colQty: "Qté",
    colUnit: "Unitaire",
    colAmount: "Montant",
    kindSubscription: "Abonnement",
    kindAiMarkup: "Markup IA",
    consumptionSnapshotLabel: "Consommation du mois (snapshot)",
    closeBtn: "Fermer",
    cronTitle: "Planificateur mensuel",
    cronEnabledLabel: "Activé",
    cronEnabledHint: "Génère automatiquement les factures du mois précédent.",
    cronDayLabel: "Jour du mois (1–28)",
    cronHourLabel: "Heure UTC (0–23)",
    saveLabel: "Enregistrer",
    cronUpdatedToast: "Planificateur mis à jour",
    lastRunTitle: "Dernière exécution",
    neverRun: "Jamais exécuté",
    monthBilledInline: "Mois facturé : ",
    invoicesGeneratedInline: "Factures générées : ",
    cronHint: "Le scheduler vérifie chaque heure. Une seule exécution par mois est garantie (idempotent).",
    liveConsumptionTitle: "Consommation temps réel — {month}",
    tenantsAtRiskSuffix: "tenant{plural} en alerte",
    totalTenantsSuffix: "{count} tenants au total — triés par % voix décroissant",
    filterGte: "Filtrer ≥",
    all: "Tous",
    overageOption: "100% (dépassement)",
    colVoice: "Voix",
    colAiConv: "Conv. IA",
    colSms: "SMS",
    colAlerts: "Alertes",
    topUpSuffix: " top-up",
    noTenantsAtThreshold: "Aucun tenant au seuil sélectionné",
    howToReadTitle: "Comment lire ce tableau ?",
    howToReadBody: "Coût réel = ce que vous paient à Twilio / Anthropic. × Coefficient = votre marge multiplicative. Prix vendu = ce que paie le tenant au-delà du quota inclus. Modifiez le coût ou le coefficient pour ajuster le prix de vente.",
    colService: "Service",
    colRealCost: "Coût réel",
    colCoefficient: "Coefficient ×",
    colSellingPrice: "Prix vendu (calculé)",
    colGrossMargin: "Marge brute",
    voiceMinuteLabel: "Minute voix IA",
    voiceMinuteDesc: "Twilio inbound + ASR + Polly TTS",
    realVoiceReference: "Réel mesuré ({month}) : {value}/min",
    smsSentLabel: "SMS envoyé",
    smsSentDesc: "Twilio outbound FR",
    aiConvLabel: "Conversation IA",
    aiConvDesc: "Claude Sonnet 4.5 — ~3k tokens / conv.",
    currentLabel: "actuel : ",
    seePlansMarkups: "Voir « Plans & Markups » →",
    aiMarkupPerVertical: "Le markup IA est configuré par verticale dans l'onglet Plans & Markups.",
    coefficientsHint: "Les coefficients seront appliqués aux coûts pour calculer les prix de vente.",
    costsUpdatedToast: "Coûts & marges mis à jour",
  },
  adminPricing: {
    overline: "Tarification",
    title: "Définition des tarifs",
    subtitle: "Toute la définition de tarif en un seul endroit : modules, voix, SMS/WhatsApp, marges et tarif contractuel public. Le reporting (factures, cron, revenu) reste sur la page Facturation.",
    sectionModulesTitle: "Modules & marges par verticale",
    sectionModulesSubtitle: "Abonnement mensuel par module/palier et markup IA par verticale.",
    sectionTelephonyTitle: "Téléphonie — SMS & WhatsApp",
    sectionTelephonySubtitle: "Tarif facturé au tenant par SMS et par message WhatsApp (au-delà du forfait inclus).",
    sectionVoiceTitle: "Voix",
    sectionVoiceSubtitle: "Tarif par minute débité du wallet prépayé à chaque appel — seule source de vérité pour la facturation voix.",
    sectionCostsTitle: "Coûts réels fournisseurs & marge",
    sectionCostsSubtitle: "Coûts SMS/IA assumés et coefficient de marge appliqué pour calculer le prix de vente. Le coût réel voix se lit désormais dans la section Voix ci-dessus.",
    sectionContractTitle: "Tarif contractuel (devis)",
    sectionContractSubtitle: "Ce qui apparaît sur un devis prospect : formules, options, paliers voix publics avec frais de setup.",
    whatsappCentsLabel: "WhatsApp (centimes / message)",
    perMsg: " / message",
    voiceMovedNote: "La voix n'est plus pilotée ici — voir la section « Voix » plus bas sur cette page (tarif wallet, seule source de vérité).",
    voiceCostsMovedNote: "Le coût réel et la marge voix se lisent désormais dans la section « Voix » de cette page, pas ici.",
  },
  adminVoicePricing: {
    invalidDelayToast: "Délai invalide — entrez un nombre de secondes > 0",
    tuningSavedToast: "Réglage enregistré — s'applique au prochain appel Premium",
    stackUpdatedToast: "{stack} mis à jour",
    title: "Tarification voix",
    subtitlePre: "Tarif ",
    subtitleBold: "à la minute",
    subtitlePost: " facturé aux tenants pour chaque stack vocal. Comptage à la seconde côté serveur — affichage min:sec sur la facture. Modèle opérateur, pas de palier.",
    colStack: "Stack",
    colLabelFr: "Libellé (FR)",
    colEurMin: "€/min",
    colActive: "Actif",
    colActions: "Actions",
    saveBtn: "Enregistrer",
    modeOperatoireBold: "Mode opératoire : ",
    modeOperatoireRest: "les tarifs s'appliquent au prochain appel. Les appels déjà facturés conservent le tarif gelé au moment de l'enregistrement (la colonne per_minute_cents est figée dans chaque ligne de usage_voice_calls).",
    premiumTuningTitle: "Réglages avancés — Tier Premium",
    hesitationDelayLabel: "Délai d'hésitation avant relance du modèle (secondes)",
    defaultBtn: "Défaut ({s}s)",
    tuningHint: "Quand un appelant termine une phrase courte ou hésitante (« euh… »), moins de 2 mots), l'IA attend ce délai pour une suite avant de répondre sur ce qu'elle a déjà entendu. Combiné au temps d'attente de fin de phrase (~1,5 s) et au temps de traitement (Claude + synthèse vocale), un délai trop long ici produit des silences perçus de plusieurs secondes. Baissé de 5 s → 2,5 s par défaut ; ajustable ici sans redéploiement, effectif au prochain appel Premium.",
    bargeInDelayLabel: "Délai avant de couper l'IA quand le client l'interrompt (ms)",
    defaultBtnMs: "Défaut ({ms}ms)",
    invalidBargeInToast: "Délai invalide — entrez un nombre entre 150 et 2000 ms",
    bargeInHint: "Le temps que l'IA attend, après avoir détecté que le client commence à parler, avant de couper sa propre phrase et d'écouter — trop court, elle se coupe sur un simple bruit de fond ou une toux (relevé de 400 à 600ms pour cette raison) ; trop long, elle continue de parler par-dessus le client. Ajustable ici sans redéploiement, effectif au prochain appel Premium — à tester en conditions réelles (restaurant bruyant) avant de baisser durablement.",
  },
  adminRevenue: {
    loading: "Chargement…",
    overline: "Plateforme",
    title: "Revenus & croissance",
    subtitlePre: "Indicateurs temps réel · mois en cours ",
    kpiMrr: "MRR",
    kpiMrrSub: "Monthly Recurring Revenue",
    kpiArr: "ARR",
    kpiArrSub: "Annual Recurring Revenue",
    kpiPaying: "Abonnements payants",
    kpiPayingSub: "{n} tenants actifs",
    kpiChurn: "Churn 30j",
    kpiChurnSub: "{canceled} annulés · {pastDue} en échec",
    projectionTitle: "Projection 12 mois",
    projectionSubtitle: "Projection linéaire conservative basée sur le MRR actuel (zéro croissance, zéro churn supplémentaire).",
    mrrProjected: "MRR projeté",
    mrrByVertical: "MRR par verticale",
    payingOfTenants: "· {paying} payants / {tenants} tenants",
    churnBadge: "{n} churn",
    top10Title: "Top 10 tenants (ce mois)",
    colRank: "#",
    colTenant: "Tenant",
    colSubscription: "Abonnement",
    colVariable: "Variable",
    colTotal: "Total",
    noBillableTenants: "Aucun tenant facturable.",
    netMarginTitle: "Marge nette · {month}",
    pctOfRevenue: "{pct}% du CA",
    vsLastMonth: "{pct}% vs mois -1",
    revenueLabel: "Chiffre d'affaires",
    vendorCostsLabel: "Coûts vendeurs",
    costBreakdownTitle: "Coûts réels du mois · ventilation",
    aiMeasuredBadge: "IA · {n} tours mesurés",
    aiEstimatedBadge: "IA · estimation forfaitaire",
    costVoiceLabel: "Voix Twilio",
    costVoiceUnitReal: "{n} appels mesurés · {min} min réelles",
    voicePerMinuteCompareTitle: "Coût réel vs facturé / minute",
    voicePerMinuteRealLabel: "coût réel (Twilio)",
    voicePerMinuteBilledLabel: "facturé au client",
    costSmsLabel: "SMS Twilio",
    costSttLabel: "STT (Deepgram)",
    costSttUnit: "{n} tours · audio in",
    costLlmLabel: "LLM (Claude/GPT)",
    costLlmUnit: "tokens in + out",
    costTtsLabel: "TTS (ElevenLabs / Aura)",
    costTtsUnit: "caractères synthétisés",
    costAiEstLabel: "IA (estimation)",
    costRealtimeLabel: "Realtime (OpenAI speech-to-speech)",
    costRealtimeUnit: "{n} tours · tokens texte + audio",
    realtimeEstimatedFlag: "Tarif audio mini estimé",
    aiCostRealNote: "Coûts IA agrégés en direct depuis les événements ai.cost de chaque tour de conversation (Deepgram STT, Claude/GPT LLM, ElevenLabs/Aura TTS).",
    aiCostEstimatedNote: "Aucun événement ai.cost n'a été capté ce mois — calcul de repli sur estimation forfaitaire.",
    realtimeCostNote: "Coût Realtime agrégé en direct depuis les tokens réels de chaque tour (voice.turn.metrics).",
    realtimeAudioRateNote: " Le tarif audio du modèle mini n'est pas publié officiellement par OpenAI pour cette version exacte — une estimation prudente est utilisée en attendant confirmation sur facture réelle.",
    adjustCostsLink: "Ajuster les coûts ou marges.",
    profitTrendTitle: "Marge nette · 12 derniers mois",
    profitTrendSubtitle: "CA réel (factures) moins coûts vendeurs (Twilio + Claude) du mois.",
    monthTooltipPrefix: "Mois ",
    legendRevenue: "Chiffre d'affaires",
    legendMargin: "Marge nette",
    legendCosts: "Coûts vendeurs",
  },
  adminTenantBilling: {
    statusActive: "Actif",
    statusPastDue: "Impayé",
    statusCanceled: "Résilié",
    statusInactive: "Inactif",
    loading: "Chargement…",
    noData: "Aucune donnée.",
    backToTenant: "Retour tenant",
    detailedBillingOverline: "Facturation détaillée",
    subscriptionModuleTitle: "Abonnement modulaire",
    activeModulesSuffix: "{n} module(s) actif(s)",
    seatsTitle: "Sièges équipe",
    membersSuffix: "{n} membre(s)",
    variableTelephonyTitle: "Téléphonie variable",
    minSmsOutOfQuota: "{min} min · {sms} SMS hors quota",
    smsOutOfQuota: "{sms} SMS hors quota",
    walletBalanceTitle: "Solde wallet vocal",
    walletDebitedThisMonth: "{amount} débités ce mois",
    walletDebitedLabel: "Débité (wallet, réel)",
    walletBalanceSub: "Solde actuel : {balance}",
    voiceMinutesUsedSubWallet: "{used} min · facturation réelle à la seconde (wallet)",
    aiMarkupTitle: "Markup IA",
    convOutOfQuota: "{n} conv. hors quota × {amount}",
    totalToInvoiceTitle: "Total à facturer",
    monthHt: "Mois {month} · HT",
    telephonyDetailTitle: "Téléphonie variable",
    voiceMinutesUsedLabel: "Minutes vocales utilisées",
    voiceMinutesUsedSub: "{used} min sur {included} inclus",
    excessBilledLabel: "Excédent facturé",
    voiceExcessSub: "{n} min × {price} /min",
    smsSentLabel: "SMS envoyés",
    smsSentSub: "{sent} SMS sur {included} inclus",
    smsExcessSub: "{n} SMS × {price} /SMS",
    subtotalLabel: "Sous-total",
    aiMarkupDetailTitle: "Markup IA",
    aiConversationsLabel: "Conversations IA",
    aiConvSub: "{used} sur {included} incluses",
    aiExcessSub: "{n} conv. × {amount}",
    seatsBreakdownTitle: "Sièges équipe — coût par rôle",
    colRole: "Rôle",
    colSeats: "Sièges",
    colUnitPrice: "Prix unitaire",
    colSubtotal: "Sous-total",
    seatsSubtotalLabel: "Sous-total sièges",
    modulesDetailTitle: "Abonnement modulaire — détail par module",
    colModule: "Module",
    colTier: "Palier",
    colCountersLimits: "Compteurs / Limites",
    colPrice: "Prix",
    modulesSubtotalLabel: "Sous-total abonnement",
    usageSummaryTitle: "Consommation brute · {month}",
    aiConversationsChip: "Conversations IA",
    voiceMinutesChip: "Minutes voix",
    smsSentChip: "SMS envoyés",
    ordersChip: "Commandes",
    recentInvoicesTitle: "Factures récentes",
    colMonth: "Mois",
    colStatus: "Statut",
    colAmount: "Montant",
    viewBtn: "Voir",
  },
  services: {
    overline: "Prestations",
    title: "Catalogue des prestations",
    intro: "Définissez les services réservables (durée, prix, ressource requise). Ces prestations apparaissent aussi dans l'onglet « Offres » de votre {catalogLink}, aux côtés des articles à commander.",
    catalogLink: "Catalogue",
    add: "Ajouter",
    editTitle: "Modifier la prestation",
    createTitle: "Nouvelle prestation",
    name: "Nom",
    nameRequired: "Le nom de la prestation est obligatoire.",
    description: "Description (optionnel)",
    durationMinutes: "Durée (minutes)",
    price: "Prix (€)",
    resourceType: "Type de ressource requise (optionnel)",
    resourceTypePlaceholder: "ex: practitioner, stylist, cabin",
    active: "Prestation active",
    save: "Enregistrer",
    saving: "...",
    colName: "Nom",
    colDuration: "Durée",
    colPrice: "Prix",
    colResource: "Ressource",
    colStatus: "Statut",
    statusActive: "Actif",
    statusInactive: "Désactivé",
    empty: "Aucune prestation. Ajoutez-en une.",
    deleteConfirmTitle: "Supprimer \"{name}\" ?",
    deleteConfirmItem1: "La prestation disparaît immédiatement de votre carte et de votre page publique.",
    deleteConfirmItem2: "Les réservations déjà prises pour cette prestation ne sont pas annulées.",
    deleteConfirm: "Supprimer",
    toastUpdated: "Prestation mise à jour",
    toastCreated: "Prestation créée",
    toastDeleted: "Prestation supprimée",
  },
  inviteAccept: {
    invalidLink: "Lien d'invitation invalide.",
    overlineInvitation: "Invitation",
    linkUnavailable: "Lien indisponible",
    backToLogin: "← Retour à la connexion",
    loading: "Chargement…",
    overlineWelcome: "Bienvenue",
    passwordSaved: "Mot de passe enregistré ✓",
    redirecting: "Redirection vers la page de connexion…",
    overlineInvite: "Invitation à rejoindre",
    welcomeTo: "Bienvenue chez",
    activateAccount: "Activer votre compte",
    greeting: "Bonjour {name}, ",
    invitedAs: "vous avez été invité·e en tant que",
    invitedAsSuffix: ". Définissez votre mot de passe pour activer votre accès.",
    email: "Adresse e-mail",
    newPassword: "Nouveau mot de passe",
    showPassword: "Afficher le mot de passe",
    confirmPassword: "Confirmer le mot de passe",
    mismatch: "Les deux mots de passe ne correspondent pas.",
    saving: "Enregistrement…",
    activate: "Activer mon compte",
  },
  platformLegal: {
    backHome: "Retour à l'accueil",
    sidebarOverline: "Mentions de la plateforme",
    lastUpdated: "Dernière mise à jour : {date}",
    docs: {
      cgu: { title: "Conditions Générales d'Utilisation", overline: "CGU", seoDescription: "Conditions générales d'utilisation de la plateforme AI Commerce OS." },
      mentions: { title: "Mentions légales", overline: "Mentions", seoDescription: "Mentions légales de l'éditeur AI Commerce OS." },
      confidentialite: { title: "Politique de confidentialité", overline: "Confidentialité", seoDescription: "Politique de confidentialité et traitement des données — AI Commerce OS." },
      cookies: { title: "Politique de cookies", overline: "Cookies", seoDescription: "Politique cookies AI Commerce OS — conforme RGPD et directive ePrivacy." },
    },
    cgu: {
      intro: "Les présentes conditions générales d'utilisation (les « CGU ») régissent l'accès et l'usage de la plateforme {name} (la « Plateforme »), proposée par {publisher} ({legalForm}), destinée aux professionnels indépendants et entreprises souhaitant déployer un assistant intelligent pour la gestion de leurs appels, réservations et commandes.",
      h1: "1. Acceptation",
      p1: "Toute utilisation de la Plateforme implique l'acceptation pleine et entière des présentes CGU. Si vous n'acceptez pas ces conditions, vous devez renoncer à utiliser la Plateforme.",
      h2: "2. Description du service",
      p2: "{name} est un logiciel-service multi-tenant qui permet à un professionnel de :",
      p2_items: [
        "Recevoir et router des appels téléphoniques via un assistant vocal IA",
        "Gérer un catalogue, des réservations et des commandes",
        "Publier une page publique de présentation et de commande en ligne",
        "Suivre une comptabilité simplifiée et générer des rapports",
        "Activer/désactiver des modules fonctionnels selon ses besoins",
      ],
      h3: "3. Inscription et compte",
      p3: "L'inscription est réservée aux personnes majeures et juridiquement capables, agissant pour des besoins professionnels. L'utilisateur s'engage à fournir des informations exactes et à maintenir la confidentialité de ses identifiants. Toute activité réalisée depuis le compte est réputée effectuée par son titulaire.",
      h4: "4. Abonnement et facturation",
      p4a: "L'accès à la Plateforme est soumis à un abonnement mensuel composé d'un tarif de base par module (Base / Pro / Premium) et d'une surfacturation (« markup ») appliquée à la consommation IA selon la verticale métier. Les conditions tarifaires détaillées sont présentées dans l'espace « Abonnement » de l'utilisateur.",
      p4b: "L'abonnement est sans engagement et peut être résilié à tout moment. La résiliation prend effet à la fin du mois en cours. Les sommes déjà facturées ne sont pas remboursées au prorata.",
      h5: "5. Engagements de l'utilisateur",
      p5_items: [
        "Utiliser la Plateforme conformément à sa destination professionnelle",
        "Ne pas tenter de contourner les mesures de sécurité ou les quotas du plan souscrit",
        "Ne pas utiliser la Plateforme à des fins illicites, frauduleuses, diffamatoires ou portant atteinte aux droits de tiers",
        "Respecter les lois applicables en matière de protection des consommateurs et des données",
        "Assumer l'entière responsabilité des contenus diffusés (menus, descriptions, photos)",
      ],
      h6: "6. Disponibilité et maintenance",
      p6: "{name} s'efforce d'assurer la disponibilité de la Plateforme 24/7, sans toutefois garantir une disponibilité absolue. Des opérations de maintenance peuvent entraîner des interruptions, annoncées dans la mesure du possible par avance.",
      h7: "7. Propriété intellectuelle",
      p7: "La Plateforme, son code, son design, ses marques et tous les éléments qui la composent sont la propriété exclusive de {publisher} ou de ses concédants. L'abonnement confère un droit d'usage personnel, non exclusif et non transférable. Les contenus que vous publiez sur la Plateforme restent votre propriété ; vous nous concédez une licence non exclusive et révocable de stockage et d'affichage strictement nécessaire à la fourniture du service.",
      h8: "8. Responsabilité",
      p8: "{name} est tenu d'une obligation de moyens. Sa responsabilité ne saurait être engagée pour les dommages indirects, perte de chiffre d'affaires, perte de clientèle ou de réputation. En toute hypothèse, le montant total des indemnités dues par {name} ne pourra excéder le montant des sommes effectivement perçues au titre de l'abonnement au cours des 6 mois précédant le fait générateur.",
      h9: "9. Suspension et résiliation",
      p9: "En cas de manquement grave aux présentes CGU ou de non-paiement, {name} se réserve le droit de suspendre ou résilier le compte de plein droit, après mise en demeure restée infructueuse pendant 8 jours, sauf urgence.",
      h10: "10. Données personnelles",
      p10: "Le traitement des données personnelles est décrit dans la {link}.",
      p10_link: "politique de confidentialité",
      h11: "11. Évolution des CGU",
      p11: "Les CGU peuvent évoluer. Toute modification substantielle sera notifiée à l'utilisateur au moins 30 jours avant son entrée en vigueur. L'usage continu de la Plateforme après cette date vaut acceptation des nouvelles conditions.",
      h12: "12. Droit applicable et juridiction",
      p12: "Les présentes CGU sont régies par le droit français. À défaut de résolution amiable, tout litige sera soumis à la compétence exclusive des tribunaux du ressort du siège social de l'éditeur, sauf disposition légale impérative contraire.",
      h13: "13. Médiation de la consommation",
      p13: "Conformément aux articles L. 611-1 et suivants du Code de la consommation, lorsque l'utilisateur est consommateur, il peut recourir gratuitement à un médiateur de la consommation. La plateforme européenne de règlement en ligne des litiges est accessible à l'adresse {link}.",
    },
    mentions: {
      h1: "Éditeur",
      li1a: "Dénomination", li1a_val: " : {publisher} ({legalForm})",
      li1b: "Adresse", li1b_val: " : {address}",
      li1c: "Email", li1c_val: " : {email}",
      li1d: "Directeur de la publication", li1d_val: " : Le représentant légal en exercice",
      h2: "Hébergement",
      li2a: "Hébergeur", li2a_val: " : {host}",
      li2b: "Localisation", li2b_val: " : {hostAddress}",
      h3: "Propriété intellectuelle",
      p3: "L'ensemble du site, incluant sa structure, ses textes, illustrations, logos, marques, photographies et autres éléments, est la propriété exclusive de {publisher} ou de ses partenaires. Toute reproduction, représentation, modification, publication, adaptation totale ou partielle est interdite sans autorisation écrite préalable.",
      h4: "Liens hypertextes",
      p4: "Le site peut contenir des liens vers des sites tiers. {publisher} n'exerce aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu.",
      h5: "Crédits",
      p5: "Conception, développement et exploitation : {publisher}. Iconographie : {link}. Typographies open source.",
      h6: "Contact",
      p6: "Pour toute question relative au site ou aux services, écrivez à {email}.",
      h7: "Signalement de contenu illicite",
      p7: "Conformément à la loi n° 2004-575 du 21 juin 2004 pour la confiance dans l'économie numérique (LCEN), tout contenu manifestement illicite peut être signalé à {email}.",
    },
    confidentialite: {
      intro: "La présente politique de confidentialité explique comment {name} (« nous ») traite vos données à caractère personnel lors de l'utilisation de la Plateforme, conformément au Règlement (UE) 2016/679 (« RGPD ») et à la loi française « Informatique et Libertés » modifiée.",
      h1: "1. Responsable de traitement",
      p1: "{publisher} est responsable de traitement des données collectées via la Plateforme. Contact : {email}.",
      h2: "2. Données collectées",
      h2_1: "2.1 Comptes utilisateurs (professionnels)",
      h2_1_items: [
        "Email, nom, mot de passe (haché bcrypt — jamais stocké en clair)",
        "Informations de l'établissement (raison sociale, adresse, téléphone, verticale)",
        "Historique d'activité (connexions, actions auditées)",
      ],
      h2_2: "2.2 Données opérationnelles",
      h2_2_items: [
        "Réservations, commandes, conversations IA",
        "Statistiques de consommation (minutes voix, SMS, appels IA)",
        "Factures et historique de paiement",
      ],
      h2_3: "2.3 Cookies et données techniques",
      h2_3_items: [
        "Cookies de session strictement nécessaires (authentification)",
        "Cookies analytiques anonymisés (opt-in uniquement)",
        "Adresse IP (hachée pour audit) et user-agent",
      ],
      h3: "3. Finalités et bases légales",
      h3_items: [
        "Exécution du contrat (Art. 6.1.b RGPD) : fourniture du service, facturation, support",
        "Obligation légale (Art. 6.1.c) : conservation comptable (10 ans), lutte contre la fraude",
        "Intérêt légitime (Art. 6.1.f) : sécurité, prévention des abus, amélioration du produit (données agrégées)",
        "Consentement (Art. 6.1.a) : cookies non essentiels, communications marketing",
      ],
      h4: "4. Durée de conservation",
      h4_items: [
        "Données de compte : pendant toute la durée de l'abonnement, puis 3 ans après la dernière interaction (prospection)",
        "Données comptables : 10 ans (Code de commerce)",
        "Logs techniques : 12 mois",
        "Cookies : maximum 13 mois",
      ],
      h5: "5. Destinataires et sous-traitants",
      p5: "Vos données sont accessibles aux personnels habilités de {publisher} et à nos sous-traitants agissant sur instructions documentées (Art. 28 RGPD) :",
      h5_items: [
        "Hébergement : {host}",
        "Téléphonie & SMS : Twilio Inc. (transfert UE‑US encadré par les Clauses Contractuelles Types)",
        "IA conversationnelle : Anthropic / OpenAI (données pseudonymisées lorsque possible)",
        "Emails transactionnels : Brevo (UE)",
        "Paiement : Stripe Payments Europe Ltd",
      ],
      h6: "6. Transferts hors UE",
      p6: "Certains sous-traitants peuvent traiter des données hors de l'Union européenne. Ces transferts sont encadrés par des garanties appropriées (Clauses Contractuelles Types adoptées par la Commission européenne, et le cas échéant Data Privacy Framework).",
      h7: "7. Sécurité",
      h7_items: [
        "Chiffrement TLS 1.3 en transit, chiffrement au repos",
        "Mots de passe hachés (bcrypt)",
        "Contrôle d'accès basé sur les rôles (RBAC) granulaire",
        "Journalisation et audit log immuable",
        "Sauvegardes régulières et plan de reprise d'activité",
      ],
      h8: "8. Vos droits",
      p8intro: "Conformément aux articles 15 à 22 du RGPD, vous disposez des droits suivants :",
      h8_items: [
        "Accès aux données vous concernant",
        "Rectification des données inexactes",
        "Effacement (« droit à l'oubli ») dans les conditions de la loi",
        "Limitation du traitement",
        "Opposition pour motifs légitimes",
        "Portabilité de vos données dans un format structuré",
        "Définir des directives relatives au sort de vos données après votre décès",
      ],
      p8outro: "Pour exercer ces droits : {email}. Une réponse est apportée sous un mois.",
      h9: "9. Réclamation",
      p9: "Vous avez le droit d'introduire une réclamation auprès de l'autorité de contrôle, {link} (3 place de Fontenoy, TSA 80715, 75334 Paris Cedex 07).",
      p9_link: "la CNIL",
      h10: "10. Modifications",
      p10: "Cette politique peut être mise à jour. La version applicable est celle publiée à la date d'accès à la Plateforme. Toute modification substantielle vous sera notifiée.",
    },
    cookies: {
      intro: "La présente politique précise les conditions d'utilisation des cookies et traceurs sur la Plateforme {name}, conformément aux recommandations de la CNIL et à la Directive 2002/58/CE (« ePrivacy ») telle que modifiée.",
      h1: "1. Qu'est-ce qu'un cookie ?",
      p1: "Un cookie est un petit fichier déposé sur votre terminal lors de la visite d'un site. Il permet notamment de mémoriser des préférences, d'assurer le bon fonctionnement d'un service ou de mesurer l'audience.",
      h2: "2. Cookies utilisés",
      h2_1: "2.1 Cookies strictement nécessaires",
      p2_1: "Indispensables au fonctionnement de la Plateforme : authentification, session, préférence linguistique, protection CSRF. Ces cookies sont déposés sans recueil préalable du consentement, conformément à l'article 82 de la loi Informatique et Libertés.",
      h2_2: "2.2 Cookies de mesure d'audience anonymisés",
      p2_2: "Lorsque activés, ils nous aident à comprendre l'usage du service pour l'améliorer. Les identifiants sont hachés et la collecte est limitée à l'essentiel.",
      h2_3: "2.3 Cookies marketing",
      p2_3: "Non utilisés à ce jour. Toute future activation ferait l'objet d'un consentement explicite préalable via la bannière de consentement.",
      h3: "3. Gestion du consentement",
      p3a: "Lors de votre première visite, une bannière vous propose d'accepter, de refuser ou de personnaliser vos préférences. Vous pouvez à tout moment modifier votre choix en effaçant le cookie de consentement (clé",
      p3b: ") ou en nous contactant à {email}.",
      h4: "4. Durée de conservation",
      p4: "Les cookies sont conservés pour une durée maximale de 13 mois. Le consentement est lui aussi mémorisé pour 6 mois avant d'être à nouveau sollicité.",
      h5: "5. Cookies tiers",
      p5: "Certains services intégrés (Stripe pour le paiement, Twilio pour la téléphonie) peuvent déposer leurs propres cookies, soumis à leurs politiques respectives. Vous trouverez plus d'informations chez ces prestataires.",
      h6: "6. Vos droits",
      p6a: "Au-delà de la gestion via la bannière, vous pouvez configurer votre navigateur pour accepter ou refuser les cookies (voir",
      p6b: "). Le refus de certains cookies peut altérer le fonctionnement de la Plateforme.",
      p6link: "les fiches CNIL",
    },
  },
  publicLegal: {
    docTerms: "CGU",
    docPrivacy: "Politique de confidentialité",
    docLegalNotice: "Mentions légales",
    docCookies: "Politique de cookies",
    back: "Retour",
    loading: "Chargement…",
  },
  adminVerticalDetail: {
    loading: "Chargement…",
    notFound: "Verticale introuvable",
    allVerticals: "Toutes les verticales",
    medicalMode: "Mode médical",
    defaultModules: "Modules par défaut ({n})",
    defaultRules: "Règles métier par défaut",
    noRules: "Aucune règle définie.",
    ivrTemplate: "Template IVR",
    sensitiveKeywords: "Mots-clés sensibles (alertes IA)",
    adoption: "Adoption",
    tenantsInVertical: "Établissements de cette verticale",
    viewTenants: "Voir les établissements →",
  },
  adminAnalytics: {
    overline: "Analytics · Coûts IA",
    title: "Coût IA cumulé / tenant / mois",
    subtitle: "Coûts STT + LLM + TTS + Realtime (OpenAI) + Twilio (abonnement numéro 1,50€/mois + communications) — les phrases mises en cache ne sont pas refacturées. Survolez une ligne « Coût » pour le détail.",
    month: "Mois",
    reload: "Recharger",
    exportCsv: "Exporter CSV",
    exportToast: "Export CSV téléchargé (acos-costs-{month}.csv)",
    kpiPlatformCost: "Coût IA plateforme",
    kpiPlatformCostSub: "{n} tenants actifs ce mois",
    kpiPlatformRevenue: "Revenu plateforme",
    kpiPlatformRevenueSub: "{n} tenants · prix modules ⨯ abonnements",
    kpiMargin: "Marge brute",
    kpiTenants: "Tenants",
    kpiTenantsSub: "{n} avec coût > 0",
    voiceStackOverline: "Rentabilité par plan vocal",
    voiceStackTitle: "Quel plan pousser ?",
    voiceStackSub: "Coût provider réel, prix retail et marge par plan (30 derniers jours) — à croiser avec la latence pour choisir le(s) plan(s) le(s) plus rentable(s) et efficace(s).",
    voiceStackSeeLatency: "Voir la page latence",
    loadingStacks: "Chargement…",
    colTier: "Plan",
    colProviderCost: "Coût provider",
    colRetailPrice: "Prix retail",
    colLatency: "Latence",
    voiceStackHint: "« Mesuré » = calculé sur de vrais appels de la fenêtre ; « Estimation » = aucun appel réel, chiffre de repli affiché à la place.",
    moduleProjectionOverline: "Projection — Marge par module",
    moduleProjectionTitle: "Revenu vs. coût IA / module",
    moduleProjectionSub: "Le coût IA est attribué aux modules M2 et M3 (qui le génèrent). Les autres modules ne consomment pas d'IA.",
    colModule: "Module",
    colPricePerMonth: "Prix / mois",
    colTenants: "Tenants",
    colRevenue: "Revenu",
    colAiCost: "Coût IA",
    colMargin: "Marge",
    colMarginPct: "Marge %",
    tenantsDetailOverline: "Détail tenants",
    tenantsCount: "{n} établissements",
    colTenant: "Tenant",
    colModules: "Modules",
    colStatus: "Statut",
    colTurnsConv: "Tours / Conv.",
    noData: "Aucune donnée",
  },
  checkYourEmail: {
    missingEmail: "Adresse e-mail manquante.",
    linkResent: "Lien renvoyé.",
    home: "Accueil",
    overline: "Compte créé",
    title: "Vérifiez votre boîte e-mail",
    body1: "Un lien de confirmation vient d'être envoyé à {email}. Cliquez sur le bouton dans cet e-mail pour activer votre essai gratuit de 7 jours.",
    yourAddress: "votre adresse",
    body2: "Le lien est valable 48 heures. Pensez à vérifier vos spams et vos onglets « Promotions » / « Notifications ».",
    resent: "Lien renvoyé",
    resend: "Renvoyer le lien",
    goToLogin: "Aller à la connexion",
    nothingReceived: "Vous n'avez rien reçu ?",
    tip1: "Vérifiez le dossier spam / indésirables.",
    tip2: "L'adresse est exacte ? Sinon, recréez un compte.",
    tip3: "Cliquez sur « Renvoyer le lien » ci-dessus.",
    tip4: "Toujours rien après 5 min ?",
  },
  publicBooking: {
    tenantNotFound: "Établissement introuvable",
    bookingError: "Erreur lors de la réservation",
    confirmationOverline: "Confirmation",
    confirmedTitle: "Réservation confirmée",
    pendingTitle: "Demande reçue",
    confirmedBody: "Vous allez recevoir un email de confirmation.",
    pendingBody: "Votre demande est en attente de validation par l'établissement.",
    date: "Date :",
    time: "Heure :",
    venue: "Établissement :",
    manageBooking: "Gérer ma réservation",
    step: "Étape {n} / {total}",
    bookTitle: "Réserver",
    chooseWord: "Choisissez",
    chooseService: "Choisissez une prestation",
    noServiceAvailable: "Aucune prestation disponible.",
    choosePractitioner: "un praticien",
    chooseRoom: "une chambre",
    chooseResource: "une ressource",
    optionalSuffix: " (optionnel)",
    noPreference: "Sans préférence",
    dateLabel: "Date",
    partySize: "Nombre de couverts",
    partySizeHint: "Au-delà de 12 couverts, contactez-nous directement.",
    desiredDate: "Date souhaitée",
    availableSlots: "Créneaux disponibles le {date}",
    searching: "Recherche…",
    noSlots: "Aucun créneau disponible ce jour. Essayez une autre date.",
    firstName: "Prénom *",
    lastName: "Nom *",
    email: "Email *",
    phone: "Téléphone",
    birthDate: "Date de naissance",
    birthDateRequired: "*",
    birthDateOptional: "(optionnel)",
    notes: "Notes / motif (optionnel)",
    summary: "Récapitulatif",
    when: "Quand :",
    service: "Prestation :",
    resource: "Ressource :",
    partySizeSummary: "Couverts :",
    client: "Client :",
    emailSummary: "Email :",
    previous: "Précédent",
    next: "Suivant",
    confirmBooking: "Confirmer la réservation",
  },
  adminPricingPlans: {
    title: "Tarification & visibilité",
    intro: "Par défaut, tous les nouveaux clients voient uniquement les plans {premium} et {premiumPlus}. Les tiers internes (Pro / Standard) sont réservés aux tenants de test pour collecte de données et entraînement de modèles.",
    premium: "Premium",
    premiumPlus: "Premium+",
    globalCatalog: "Catalogue global",
    defaultVisibleTo: "Défaut visible aux nouveaux signups :",
    perMonthExclTax: "/mois HT",
    public: "Public",
    internal: "Interne",
    setup: "Setup :",
    included: "Inclus :",
    overage: "Overage :",
    stack: "Stack :",
    tenantOverride: "Override par tenant",
    tenantOverrideDesc: "Sélectionne un tenant et active les plans internes (Pro / Standard) à exposer.",
    searchPlaceholder: "Rechercher (nom / slug / email)",
    pickTenant: "Choisis un tenant à gauche pour gérer ses plans visibles.",
    loading: "Chargement…",
    activateTestMode: "Activer MODE TEST (tous les plans)",
    resetDefault: "Réinitialiser (défaut Premium)",
    visiblePlansUpdated: "Plans visibles mis à jour pour {name}",
    overrideCleared: "Override supprimé — retour aux défauts (Premium uniquement)",
    testModeGranted: "Tenant promu en MODE TEST — tous les plans (Pro + Standard) visibles",
  },
  adminCommerceConfig: {
    title: "Commerce & tarification",
    subtitle: "Configurez vos formules d'abonnement, vos tiers vocaux et vos modèles de documents — puis pilotez ce qui est visible publiquement.",
    tabConfig: "Configuration produit",
    tabPlans: "Plans & visibilité",
  },
  publicOrderReceipt: {
    loadError: "Impossible de charger la commande.",
    notFound: "Commande introuvable",
    orderNumber: "Commande #{number}",
    statusPaidTitle: "Paiement confirmé",
    statusPaidSub: "Votre commande est validée et envoyée en cuisine.",
    statusPendingTitle: "Paiement en cours de validation",
    statusPendingSub: "Nous attendons la confirmation Stripe. Cela ne devrait prendre que quelques secondes…",
    statusCancelledTitle: "Paiement annulé",
    statusCancelledSub: "Votre commande n'a pas été validée. Vous pouvez la repasser à tout moment.",
    statusUnknownTitle: "Statut inconnu",
    statusUnknownSub: "Nous n'avons pas pu trouver les détails de cette commande.",
    pickupAt: "Retrait à",
    summary: "Récapitulatif",
    menu: "Menu :",
    total: "Total",
    paid: "Payé",
    checkPayment: "Vérifier le paiement",
    downloadReceipt: "Télécharger le reçu",
    footer: "Conservez cette page : c'est votre justificatif de commande.",
  },
  adminFlowLatencyDashboard: {
    phaseCatalogLookup: "Résolution catalogue (expected_values)",
    phaseRunTurn: "run_turn (tour complet, hors catalogue)",
    phaseExtraction: "Extraction (Niveau 0/0.5/1, toutes voies confondues)",
    phaseExtractionLlm: "…dont appel LLM réel (Niveau 1 uniquement)",
    phaseCartOps: "Opérations panier (ajout/retrait)",
    phaseAction: "Action de nœud (branch/recap/fin d'appel)",
    phaseDynamicValues: "Valeurs dynamiques (catalogue/récap/nom d'article)",
    phasePhraseRender: "Rendu de la phrase suivante",
    title: "Latence par tour — Flow scripté",
    subtitle: "Décomposition du moteur flow_v1 (Sprint 14/15) — alimentée par les events voice.brain.finished (engine=flow_v1). Distinct du tableau « Latence IA M3 », qui couvre l'ancien orchestrateur Realtime/M3.",
    lastHour: "Dernière heure",
    last6h: "6 dernières heures",
    last24h: "24h",
    last3d: "3 jours",
    last7d: "7 jours",
    kpiBrainP50: "Tour complet (brain_ms) P50",
    p90Label: "P90 :",
    asrTtsExcluded: "(ASR/TTS exclus)",
    kpiSamples: "Tours analysés",
    over: "sur {hours}h",
    kpiLlmShare: "Tours passés en Niveau 1 (LLM)",
    llmShareHint: "seul cas où la phrase d'ameublement se déclenche",
    engineComparisonTitle: "Comparaison Premium vs Realtime scripté",
    colTier: "Tier",
    colTurns: "Tours",
    colBrainP50: "brain_ms P50",
    colBrainP90: "brain_ms P90",
    colBrainMean: "brain_ms Moy.",
    colLevel1Pct: "% Niveau 1 (LLM)",
    tierRealtimeScripted: "Realtime scripté",
    tierPremium: "Premium",
    engineComparisonHint: "brain_ms = décision seule (extraction + catalogue + rendu de phrase), hors ASR/TTS — même convention des deux côtés puisque les deux tiers appellent la même fonction run_flow_turn_for_call. Le coût/latence TTS (ElevenLabs/Aura, OpenAI côté realtime) est sur l'écran « Coût voix » séparé.",
    phaseBreakdownTitle: "Décomposition par phase (ms)",
    loading: "Chargement…",
    noData: "Aucune donnée pour cette plage — passez quelques appels via le moteur flow scripté pour générer des events.",
    phaseDetailTitle: "Détail par phase",
    colPhase: "Phase",
    colSamples: "Échantillons",
    colP50: "P50 (ms)",
    colP90: "P90 (ms)",
    colP99: "P99 (ms)",
    colMean: "Moy.",
    fullTurn: "brain_ms (tour complet)",
    levelBreakdownTitle: "Répartition Niveau 0 / 0.5 / 1",
    level: "Niveau",
    levelBreakdownHint: "Plus la part de Niveau 1 est faible, moins les fillers de latence (voir onglet Audio) se déclenchent — c'est attendu.",
    statusBreakdownTitle: "Statuts de tour",
  },
  adminUnderstandingQuality: {
    title: "Qualité de compréhension",
    subtitle: "Messages/appels tombés en dehors de toute compréhension déterministe/LLM ciblée et escaladés (orchestrateur général côté WhatsApp, transfert humain côté voix) — un signal de priorisation, pas une mesure de panne. La colonne « tous canaux » (24/08) et les phrases dépliables sont alimentées par core.understanding_log, qui journalise le texte réel — le compteur « WhatsApp » reste l'ancien signal jour/tenant, gardé pour comparaison historique.",
    last7d: "7 derniers jours",
    last30d: "30 derniers jours",
    last90d: "90 derniers jours",
    kpiTotal: "Escalades WhatsApp totales",
    over: "sur {days}j",
    kpiTenantsAffected: "Tenants concernés",
    tenantsAffectedHint: "au moins une escalade sur la période",
    kpiWorstTenant: "Tenant le plus touché",
    escalationsSuffix: "escalades",
    noneYet: "Aucune escalade sur la période",
    trendTitle: "Tendance quotidienne WhatsApp (tous tenants)",
    loading: "Chargement…",
    noData: "Aucune donnée pour cette plage.",
    byTenantTitle: "Détail par tenant",
    colTenant: "Tenant",
    colTotalAllChannels: "Tous canaux",
    colTotalAllChannelsHint: "WhatsApp + voix, depuis le 24/08 (core.understanding_log)",
    colTotal: "WhatsApp (ancien compteur)",
    colDaysActive: "Jours actifs",
    colAvgPerDay: "Moy./jour actif",
    worstBadge: "PIRE",
    recentPhrasesTitle: "Phrases/mots récemment incompris — cliquer pour replier",
  },
  adminVoiceObservability: {
    title: "Fiabilité des appels vocaux",
    subtitle: "Taux de reask, de transfert humain, d'abandon avant finalisation, et latence STT→LLM→TTS — par tenant et globalement. Sans ce tableau, un problème vocal en production ne se voit qu'en rejouant un appel test manuellement.",
    lastHour: "Dernière heure",
    last6h: "6 dernières heures",
    last24h: "24 dernières heures",
    last3d: "3 derniers jours",
    last7d: "7 derniers jours",
    loading: "Chargement…",
    noData: "Aucune donnée pour cette plage.",
    kpiTotalCalls: "Appels",
    over: "sur {hours}h",
    kpiReaskRate: "Taux de reask",
    reaskRateHint: "part des tours où la question a dû être reposée",
    kpiFinalizedRate: "Taux de finalisation",
    finalizedRateHint: "part des appels ayant abouti à une commande",
    kpiTransferRate: "Taux de transfert humain",
    kpiAbandonedRate: "Taux d'abandon",
    abandonedRateHint: "appel terminé sans commande ni transfert humain",
    latencyTitle: "Latence bout-en-bout (par tour)",
    latencyHint: "Temps entre la fin de parole du client (VAD) et la fin de la réponse — décomposé par étape pour voir où le temps part réellement.",
    phaseVad: "Détection fin de parole",
    phaseBackend: "Réception backend",
    phaseTtft: "1er token LLM (TTFT)",
    phaseTtfa: "1er audio TTS (TTFA)",
    phaseTail: "Fin de restitution audio",
    phaseTotal: "Tour complet",
    colPhase: "Étape",
    colSamples: "Échantillons",
    colP50: "P50",
    colP90: "P90",
    colP99: "P99",
    colMean: "Moyenne",
    byTenantTitle: "Détail par tenant",
    colTenant: "Tenant",
    colCalls: "Appels",
    colTurns: "Tours",
    colReaskRate: "Reask",
    colFinalizedRate: "Finalisé",
    colTransferRate: "Transfert",
    colAbandonedRate: "Abandon",
    worstBadge: "À SURVEILLER",
    unknownTenantHint: "Événements sans tenant identifié (appels passés avant le correctif du 28/09/2026) — regroupés ici en attendant que l'historique se reconstitue.",
    statusBreakdownTitle: "Répartition des statuts de tour",
    coverageTitle: "Couverture Niveau 0 (appris) vs Niveau 1 (LLM), par étape",
    coverageHint: "Pour chaque étape du graphe, part des tours résolus sans appel LLM (déterministe ou appris via la base de connaissance) vs résolus par un vrai appel LLM. Seuls les appels passés après le 06/10/2026 sont comptés ici — étape la plus consommatrice de LLM en premier.",
    coverageEmpty: "Aucune donnée de couverture pour cette plage (appels trop anciens, ou aucun tour n'est passé par le chemin principal du moteur).",
    colStep: "Étape",
    colNodeKind: "Type",
    colTurnsShort: "Tours",
    colLevel0Rate: "Niveau 0",
    colLevel1Rate: "Niveau 1 (LLM)",
    colLlmGate: "LLM",
    llmGateTitle: "Interrupteur LLM par étape",
    llmGateCardHint: "Désactive le LLM pour UNE étape précise d'UN tenant précis — le moteur retombe alors directement sur reask/transfert humain pour cette étape, jamais sur une réponse inventée. Fonctionne même sans encore avoir de données dans le tableau de couverture ci-dessous : le step_id se tape à la main (c'est l'identifiant technique du nœud dans l'éditeur de parcours, ex. \"ask_order_type\").",
    llmGateTenantLabel: "Tenant ciblé",
    llmGateTenantPlaceholder: "ID du tenant",
    llmGateStepLabel: "Étape (step_id)",
    llmGateStepPlaceholder: "ex: ask_order_type",
    llmGateStepIdHint: "Le step_id exact se trouve dans l'éditeur de parcours (admin/flow-editor) ou dans la colonne « Étape » du tableau de couverture plus bas une fois que des appels auront généré des données.",
    llmGateTenantRequired: "Indique d'abord l'ID du tenant à cibler.",
    llmGateActiveCount: "{count} étape(s) avec LLM désactivé pour ce tenant",
    llmGateNoneActive: "Aucun interrupteur actif pour ce tenant — le LLM reste utilisé comme avant ce chantier.",
    llmGateNoneActiveGlobal: "Aucun interrupteur actif, tous tenants confondus.",
    llmGateUpdatedBy: "Activé par",
    llmGateDisable: "Désactiver le LLM",
    llmGateReenable: "Réactiver le LLM",
    llmGateDisabledToast: "LLM désactivé pour cette étape — repli automatique sur reask/transfert humain.",
    llmGateEnabledToast: "LLM réactivé pour cette étape.",
    kbTitle: "Suggestions d'apprentissage à valider",
    kbSubtitle: "Formulations client récurrentes que le LLM a dû résoudre à chaque fois — l'assistant propose de les mémoriser. Les cas sans risque (type de commande, menu vs à l'unité...) sont déjà appliqués automatiquement et n'apparaissent pas ici ; tout ce qui touche la commande ou le paiement attend ta validation.",
    kbLearnedTitle: "Déjà appris",
    kbLearnedSubtitle: "{count} formulation(s) actuellement actives — consultées par l'assistant à chaque appel/message, avant même de solliciter le LLM.",
    kbLearnedSearchPlaceholder: "Rechercher une formulation ou une valeur…",
    kbLearnedEmpty: "Rien d'actif pour l'instant — ce qui est enregistré depuis les Échecs réels ou approuvé ci-dessous apparaîtra ici.",
    kbLearnedSince: "Actif depuis le {date}",
    kbLearnedRemove: "Retirer",
    kbLearnedEdit: "Modifier",
    kbLearnedSaved: "Entrée mise à jour.",
    kbLearnedFieldPhrase: "Phrase qui doit être comprise",
    kbLearnedFieldPhraseHint: "La formulation exacte du client (ou proche) qui doit déclencher cette réponse.",
    kbLearnedFieldValue: "Valeur retenue",
    kbLearnedFieldValueHint: "Ce que l'assistant doit comprendre ou répondre pour cette phrase.",
    kbLearnedFieldIntent: "Ce que l'assistant doit comprendre",
    kbLearnedFieldIntentHint: "L'intention reconnue — choisis parmi les intentions que l'assistant sait déjà traiter.",
    kbLearnedEditedAt: "Modifié le {date} par {by}",
    kbHitCount: "vu {count} fois, toujours résolu pareil",
    kbApprove: "Valider",
    kbReject: "Rejeter",
    kbApproved: "Ajouté à la base de connaissance",
    kbRejected: "Suggestion rejetée",
    simTitle: "Testeur — que comprendrait/répondrait l'IA ?",
    simSubtitle: "Outil manuel, pour une hypothèse tapée à la main (les échecs réels ci-dessus ont déjà leur propre test intégré, sans ressaisie). Rejoue le vrai moteur d'extraction — lecture seule, aucun impact en production.",
    simStepKind: "Type d'étape",
    simSlot: "Slot attendu (optionnel)",
    simExpectedValues: "Valeurs/options possibles",
    simExpectedValuesPlaceholder: "à emporter, sur place, livraison",
    simQuestionAsked: "Question posée par l'assistant",
    simQuestionAskedPlaceholder: "Ce sera à emporter ou sur place ?",
    simCustomerText: "Message du client à tester",
    simCustomerTextPlaceholder: "Non en fait je vais repartir avec",
    simRun: "Tester",
    simRunning: "Test en cours…",
    simMatchedChoice: "Valeur reconnue",
    simConfirmed: "Confirmé",
    simItemsMentioned: "Articles mentionnés",
    simEscalation: "Escalade",
    simErrors: "Erreurs",
    phraseTitle: "Brouillon de nouvelle formulation",
    phraseSubtitle: "Outil manuel, pour retravailler une phrase SANS partir d'un échec réel (les échecs ci-dessus ont déjà leur propre brouillon intégré). L'IA propose un texte à partir du problème décrit — tu le relis, le corriges si besoin, puis tu enregistres ; génération audio et mise en service dans le graphe vocal sont ensuite automatiques.",
    phraseTenantId: "ID du tenant",
    phraseKey: "Clé de la phrase (phrase_key)",
    phraseLanguage: "Langue",
    phraseContext: "Ce qui n'allait pas",
    phraseContextPlaceholder: "Le client ne comprenait pas la question, trop ambiguë sur le menu vs à l'unité...",
    phraseSuggest: "Proposer un brouillon",
    phraseSuggesting: "Rédaction en cours…",
    phraseDraftLabel: "Brouillon (modifiable avant d'enregistrer)",
    phraseDraftHint: "Vérifie que les variables {{comme_ça}} sont conservées si la phrase originale en avait.",
    phraseSave: "Enregistrer et publier",
    phraseSaving: "Enregistrement…",
    phraseSaved: "Variante enregistrée — audio généré et mis en service",
    failTitle: "Échecs de compréhension réels",
    failSubtitle: "Chaque ligne part d'un vrai appel qui a échappé au bot. Contexte complet fourni à l'IA (plus que ce qu'elle avait en direct) pour reconstituer l'intention et proposer une meilleure formulation — que tu peux corriger avant d'enregistrer.",
    failLast30d: "30 derniers jours",
    failKindAll: "Tout ({count})",
    failKindFailure: "Échecs réels ({count})",
    failKindLlmResolved: "Résolu par l'IA — à vérifier ({count})",
    failKindFailureBadge: "Échec réel",
    failKindLlmResolvedBadge: "Résolu par l'IA",
    failLlmResolvedHint: "L'IA a compris : {value} — non escaladé, mais pas confirmé par le client.",
    failWhatsappNoTestHint: "Échec WhatsApp (orchestrateur M3) : ce canal n'a pas de nœud/question fermée à rejouer ici — seule la reformulation ci-dessous est pertinente.",
    failWhatsappRuleHint: "Cette reformulation sera enregistrée comme une règle Learning Lab (déclencheur = ce message) — elle servira dès le prochain message WhatsApp similaire, avant même que l'IA (LLM) ne soit sollicitée.",
    failChannelAll: "Tous canaux ({count})",
    failChannelVoice: "Voix ({count})",
    failChannelWhatsapp: "WhatsApp ({count})",
    goToKnowledgeBase: "Ouvrir la base de connaissance",
    kbPageTitle: "Base de connaissance",
    kbPageSubtitle: "Échecs de compréhension réels (voix et WhatsApp), suggestions apprises, testeur d'extraction et brouillon de phrase — tout ce qui sert à corriger et enrichir l'assistant.",
    failEmpty: "Aucun échec de compréhension sur cette période.",
    failContext: "Contexte de la conversation",
    failNoContext: "Aucun contexte disponible.",
    failRoleClient: "Client",
    failRoleAssistant: "Assistant",
    failAnalyze: "Analyser avec l'IA",
    failAnalyzing: "Analyse en cours…",
    failIntention: "Intention comprise par l'IA",
    failSuggestedValue: "Valeur reconnue",
    failDraftLabel: "Réponse/formulation proposée (modifiable)",
    failDraftPlaceholder: "Aucune reformulation proposée — tu peux en écrire une toi-même",
    failDraftHint: "Non modifié = la version générée est utilisée telle quelle. Modifié = ta version prend le dessus.",
    failDraftGenerated: "Généré par l'IA",
    failDraftEdited: "Modifié par toi",
    failSave: "Enregistrer et publier",
    failSaving: "Enregistrement…",
    failSaved: "Correction enregistrée",
    failNoAction: "Rien à enregistrer — écris une formulation ou laisse la suggestion générée",
    failStepContext: "1. Contexte",
    failStepTest: "2. Test en direct",
    failStepAnalyze: "3. Analyse IA",
    failStepDraft: "4. Reformulation",
    failTestRun: "Tester maintenant",
    failTestRetry: "Retester",
    failTestRunning: "Test en cours…",
    failTestHint: "Rejoue le moteur réel sur cette phrase, avec les mêmes valeurs attendues qu'en direct — pour voir si le problème vient de l'extraction elle-même.",
    failTestLevel0: "Niveau 0 — règle/synonyme",
    failTestLevel1: "Niveau 1 — appel LLM",
    failTestLevelFail: "Échec complet",
    failTestMatchedChoice: "Valeur détectée",
    failTestConfirmed: "Confirmé",
    failTestEscalation: "Échappe encore",
    failTestErrors: "Erreurs",
    failTestOk: "Compris correctement par le moteur",
    failTestStillFails: "Toujours pas compris — confirme le diagnostic",
    failRevalidate: "Revérifier après correction",
    failRevalidating: "Vérification…",
    failRevalidateFixed: "Corrigé — l'IA comprend maintenant",
    failRevalidateStill: "Toujours pas reconnu — la correction ne suffit pas encore",
    failRevalidateHint: "La base de connaissance peut prendre jusqu'à quelques secondes à se rafraîchir.",
    failValueNotApplicableComposition: "Cette question porte sur un choix de composition (viande, sauce, crudité...) — ce type de réponse est désormais compris automatiquement EN DIRECT par le dernier recours IA à chaque appel, pas via une base de synonymes enregistrée ici. Rien à faire pour que ça reprenne au prochain appel. Tu peux quand même reformuler la question ci-dessous si c'est elle qui posait problème.",
    failValuePlaceholder: "Valeur à mémoriser (doit correspondre exactement à un choix possible)",
    failValueHint: "Sera compris automatiquement dès le prochain appel pour ce slot ({slot}) — non modifié = la suggestion générée est utilisée telle quelle.",
    failValueNoSlot: "Cette question n'a pas de slot identifiable — impossible d'enregistrer une valeur ici pour l'instant.",
    failNoPhraseKey: "Cette question n'a pas de formulation identifiable — impossible d'enregistrer une reformulation ici.",
    failNothingToSaveHint: "Rien à enregistrer pour l'instant : édite la valeur reconnue et/ou la reformulation ci-dessus.",
  },
  flowScriptTabs: {
    keyLangRequired: "phrase_key et language sont requis",
    phraseSaved: "Phrase enregistrée",
    saveError: "Erreur enregistrement",
    previewError: "Aperçu impossible",
    vertical: "Verticale",
    noPhrase: "Aucune phrase pour cette verticale.",
    phraseKeyLabel: "phrase_key",
    languageLabel: "language",
    templateLabel: "Texte (gabarit {{variable}})",
    variablesLabel: "Variables (séparées par virgules)",
    saving: "Enregistrement…",
    save: "Enregistrer",
    previewLabel: "Aperçu de rendu (valeurs JSON, ex: {\"item_name\": \"Crousty\"})",
    preview: "Aperçu",
    voiceIdLabel: "voice_id",
    tierLabel: "tier",
    tierPro: "pro (Deepgram Aura)",
    tierPremium: "premium (ElevenLabs)",
    voicesLoading: "Chargement des voix…",
    voicesChoose: "Choisir une voix ElevenLabs…",
    audioTabHint: "Chaque phrase est découpée en fragments FIXES (mis en cache individuellement, exactement ce qu'un appel réel rejouerait) et fragments VARIABLES (surlignés — leur valeur vient du choix du client en direct, donc jamais mise en cache ici : elles seront toujours synthétisées à la volée pendant l'appel).",
    loading: "Chargement…",
    variableTitle: "Variable — valeur du choix client en direct, non mise en cache ici, toujours synthétisée à la volée.",
    notSpeakable: "(non parlable)",
    cached: "En cache",
    notCached: "Pas encore",
    mainWording: "Modèle principal",
    variantWording: "Variante",
    generating: "Génération…",
    generate: "Générer",
    audioGeneratedToast: "Audio généré pour \"{key}\" (fragment {n})",
    audioGenError: "Erreur de génération audio",
    fillerSaved: "Phrase d'ameublement enregistrée",
    noFiller: "Aucune phrase d'ameublement pour cette verticale — créez-en une à droite.",
    fillerHint: "Ces phrases sont jouées PENDANT l'appel LLM d'un nœud (Niveau 1) pour masquer la latence, avant que la vraie réponse ne soit prête — voir le champ filler_phrase_key dans l'inspecteur de nœud de l'onglet Graphe (nœuds ask_open_item / ask_closed_choice / confirm_yes_no).",
    staticTextLabel: "Texte (100% statique — aucune {{variable}})",
    variableWarning: "Une phrase d'ameublement doit être dite immédiatement, avant que le moteur ne connaisse le contexte du tour — une {{variable}} ne pourra jamais être résolue ici et sera dite littéralement au client.",
    newPhrase: "Nouvelle phrase",
    nothingToGenerate: "Rien à générer pour l'instant.",
    fillerVariableTitle: "Une phrase d'ameublement ne devrait jamais avoir de variable.",
    variantsLabel: "Variantes (formulations alternatives)",
    variantsHint: "À chaque fois que cette phrase doit être dite, l'assistant en choisit une au hasard parmi le texte principal ci-dessus et ces variantes — utile pour ne pas répéter toujours la même formulation. Laissez vide si vous n'en voulez qu'une seule.",
    variantPlaceholder: "Autre formulation…",
    addVariant: "Ajouter une variante",
    removeVariant: "Supprimer cette variante",
  },
  adminLatencyDashboard: {
    phaseHistoryLoad: "Mongo history",
    phaseGuardrailsIntent: "Guardrails + Intent (LLM)",
    phaseRag: "RAG / Inventory / Dispatch / Playbook",
    phaseLlmReply: "Réponse Haiku 4.5 (LLM)",
    phaseTotal: "Total backend",
    measured: "Mesuré",
    estimated: "Estimation",
    measuredOn: "Mesuré sur",
    samples: "échantillons",
    estimatedHint: "Aucun appel réel dans la fenêtre — chiffre estimé, pas mesuré.",
    tierStandard: "Voix Standard",
    tierPro: "Voix Pro",
    tierPremium: "Voix Premium",
    tierRealtime: "Voix Realtime",
    tierRealtimePro: "Voix Realtime Pro",
    title: "Latence IA M3",
    subtitle: "Mesure end-to-end backend (hors ASR / TTS) — alimentée par les events m3.latency.",
    lastHour: "Dernière heure",
    last6h: "6 dernières heures",
    last24h: "24h",
    last3d: "3 jours",
    last7d: "7 jours",
    kpiTotalP50: "Total P50",
    p90Label: "P90 :",
    kpiSamples: "Tours analysés",
    over: "sur {hours}h",
    kpiSticky: "Intent sticky-reuse",
    stickyHint: "tours qui ont sauté la classification",
    phaseBreakdownTitle: "Décomposition par phase (ms)",
    loading: "Chargement…",
    noData: "Aucune donnée pour cette plage. Lancez quelques tours via /api/m3/simulator/turn pour générer des events.",
    phaseDetailTitle: "Détail par phase",
    colPhase: "Phase",
    colSamples: "Échantillons",
    colP50: "P50 (ms)",
    colP90: "P90 (ms)",
    colP99: "P99 (ms)",
    colMean: "Moy.",
    intentBreakdownTitle: "Répartition des intents",
    costMatrixTitle: "Coût provider × Tarif retail × Latence — par tier vocal",
    colTier: "Tier",
    colProviderCost: "Coût provider",
    colRetailPrice: "Prix retail",
    colMarginPerMin: "Marge / min",
    colMarginPct: "Marge %",
    colTargetLatency: "Latence cible",
    colLatency: "Latence",
    colTenants: "Tenants",
    marginHint: "💡 Une marge ≥ 60 % couvre les pics de coût (prompt non-caché, dépassements quotas).",
    costHint: "⚠️ Coût provider basé sur tarif OpenAI public Feb 2026 avec prompt cache. Sans cache, multiplier ×3.",
    measuredCostTitle: "Realtime scripté — coût mesuré réel (7 derniers jours)",
    unconfirmedEstimate: "~ estimation OpenAI non confirmée",
    avgMeasured: "moyenne mesurée",
    minMaxPerCall: "min–max par appel",
    callsMeasured: "appels mesurés",
    noMeasuredCalls: "Aucun appel realtime scripté mesuré sur les 7 derniers jours — la ligne « realtime » ci-dessus reste une estimation statique obsolète (ancienne architecture) tant qu'aucun appel récent n'a été passé.",
  },
  adminSettings: {
    groqIntro: "Groq propose une inférence nettement plus rapide qu'Anthropic/OpenAI (matériel LPU dédié) — configurer une clé ici la fait passer en priorité sur tous les appels LLM d'extraction du moteur scripté (voir core/llm_compat.py). Aucun chiffrement au repos n'est appliqué (comme le reste de cette collection) : la clé n'est jamais réaffichée en clair, uniquement masquée.",
    groqEnvOverrideNotice: "Une variable d'environnement GROQ_API_KEY est déjà définie sur le serveur — elle prime toujours sur la valeur enregistrée ici tant qu'elle reste présente.",
    loading: "Chargement…",
    currentKey: "Clé actuelle",
    noKeyConfigured: "Aucune clé configurée",
    modelOptional: "Modèle (optionnel)",
    newKeyLabel: "Nouvelle clé (laisser vide pour ne rien changer, ou pour effacer si vous enregistrez sans en saisir une nouvelle après avoir vidé ce champ)",
    saving: "Enregistrement…",
    save: "Enregistrer",
    groqKeySaved: "Clé Groq enregistrée",
    overline: "Plateforme",
    title: "Paramètres",
    subtitle: "Identité, branding plateforme et tarification modulaire.",
    groqSection: "Intégration Groq (inférence rapide)",
    cceGlobalSection: "CCE — Contenu global (Clôtures & TwiML)",
    cceRulesSection: "CCE — Réconciliation RULE (Realtime/M3)",
    identitySection: "Identité plateforme",
    name: "Nom",
    supportEmail: "E-mail support",
    termsUrl: "CGU (URL)",
    privacyUrl: "Confidentialité (URL)",
    settingsSaved: "Paramètres enregistrés",
    pricingSection: "Tarifs des modules",
    colKey: "Clé",
    colName: "Nom",
    colPriceMonth: "Prix (€/mois)",
    priceUpdatedToast: "Prix {key} mis à jour",
    seatsSection: "Tarifs par siège (par rôle)",
    seatsHint: "Le tenant paie ce montant pour chaque utilisateur additionnel selon son rôle. Le premier OWNER est inclus dans le pack de base.",
    colRole: "Rôle",
    colPricePerSeat: "Prix / siège / mois",
    permissions: "permissions",
    perMonth: "€/mois",
    noTenantRole: "Aucun rôle tenant",
  },
  adminLatencyDashboards: {
    title: "Latence IA",
    subtitle: "Deux moteurs d'appel distincts, deux pipelines de mesure — choisissez celui utilisé par les appels que vous inspectez.",
    tabM3: "Voix Realtime / M3 (legacy)",
    tabFlow: "Flow scripté (Sprint 14)",
  },
  adminTrialSettings: {
    loadError: "Erreur de chargement : {err}",
    saveError: "Échec : {err}",
    settingsSaved: "Réglages onboarding enregistrés",
    settingsReset: "Réglages réinitialisés",
    invalidEmail: "Adresse e-mail invalide",
    alreadyInList: "Déjà dans la liste",
    loading: "Chargement…",
    overline: "Plateforme",
    title: "Essai gratuit & inscription",
    subtitle: "Pilotez le tunnel d'inscription : durée de l'essai, durée de validité des liens de vérification, destinataires des notifications, etc.",
    reset: "Réinitialiser",
    saving: "Enregistrement…",
    save: "Enregistrer",
    upToDate: "À jour",
    dirtyBanner: "Modifications non publiées. Cliquez sur",
    dirtyBannerSave: "Enregistrer",
    trialDurationTitle: "Durée de l'essai gratuit",
    trialDaysLabel: "Durée de l'essai (en jours)",
    trialDaysHint: "0 = pas d'essai, abonnement immédiat requis. Recommandé : 7 jours.",
    lockLabel: "Verrouillage strict en fin d'essai",
    lockHint: "Si activé : à l'expiration, les modules facturables sont bloqués jusqu'à souscription. Sinon, simple bandeau d'avertissement.",
    verificationTitle: "Lien de vérification e-mail",
    verificationTtlLabel: "Validité du lien (en heures)",
    verificationTtlHint: "Par défaut : 48 h. Au-delà, l'utilisateur doit demander un nouveau lien.",
    autoBookingsTitle: "Confirmation automatique des réservations",
    autoBookingsLabel: "Activer la prise de réservation 100% automatique",
    autoBookingsDesc: "Quand l'IA détecte une réservation (date, créneau, nombre de personnes) ET que le client confirme, la réservation est créée directement, un SMS récap part, et l'appel se termine poliment. Sans cette option : la demande passe en file d'attente « En attente de validation » dans le dashboard du pro.",
    autoOrderModeLabel: "Mode commande automatique (RESTAURANT + M5)",
    autoOrderModeDesc: " : toujours actif lorsque le tenant a un catalogue M5. Pour le désactiver, retirer le catalogue ou désactiver M5.",
    emailsTitle: "E-mails transactionnels",
    welcomeEmailLabel: "Envoyer l'e-mail de bienvenue à l'OWNER",
    welcomeEmailDesc: "Mail envoyé juste après confirmation de l'adresse, avec les 3 prochaines étapes.",
    notifyAdminLabel: "Notifier l'équipe à chaque signup vérifié",
    notifyAdminDesc: "Mail interne avec la fiche du nouveau pro (slug, vertical, contact).",
    recipientEmailsLabel: "Adresses e-mail destinataires",
    noEmails: "Aucune adresse — les notifications ne partiront pas.",
    addEmail: "Ajouter",
    resetConfirmTitle: "Réinitialiser aux valeurs par défaut ?",
    resetConfirmItem: "Tous les réglages ci-dessus (durée d'essai, TTL de vérification, e-mails de notification…) reviennent à leur valeur d'origine.",
    grantTrialTitle: "Attribuer un essai gratuit à un établissement",
    grantTrialDesc: "Ne modifie pas le réglage global ci-dessus. À utiliser au cas par cas pour convaincre un prospect hésitant — l'essai n'est pas accordé par défaut.",
    grantTrialSearchLabel: "Rechercher un établissement",
    grantTrialSearchPlaceholder: "Nom, slug ou e-mail…",
    grantTrialSearching: "Recherche…",
    grantTrialNoResults: "Aucun établissement trouvé.",
    grantTrialDaysLabel: "Durée de l'essai à accorder (jours)",
    grantTrialButton: "Accorder l'essai",
    grantTrialGranting: "Attribution…",
    grantTrialSuccess: "Essai de {days} jours accordé à {tenant} (jusqu'au {date})",
    grantTrialError: "Échec : {err}",
    grantTrialAlreadyPaying: "Ce tenant a déjà un abonnement payant actif.",
    grantTrialSelected: "Établissement sélectionné",
    grantTrialChangeSelection: "Changer",
    grantTrialCurrentStatus: "Statut actuel : {status}{trial}",
    grantTrialCurrentTrialSuffix: " (essai jusqu'au {date})",
  },
  adminVerticalConfig: {
    title: "Verticales & IA",
    subtitle: "Registre des métiers, ton de l'assistant et déroulé de conversation — les trois réglages qui se configurent ensemble pour un métier donné.",
    tabVerticals: "Verticales",
    tabPersonas: "Personas IA",
    tabPlaybooks: "Playbooks IA",
  },
  adminLegal: {
    docTerms: "CGU",
    docPrivacy: "Politique de confidentialité",
    docLegalNotice: "Mentions légales",
    docCookies: "Politique cookies",
    noChanges: "Aucun changement à sauver",
    templatesUpdated: "Templates mis à jour",
    configUpdated: "Configuration RGPD mise à jour",
    templatesReset: "Templates réinitialisés",
    overline: "Plateforme",
    title: "Conformité RGPD & documents légaux",
    subtitle: "Templates et durées de conservation par verticale. Les tenants consultent ; seul le Super Admin édite.",
    loading: "Chargement…",
    gdprConfig: "Configuration RGPD",
    medicalVertical: "Verticale médicale",
    retentionYears: "Durée de conservation (années)",
    pseudonymizeTitle: "Pseudonymisation par défaut",
    pseudonymizeDesc: "Les conversations IA n'envoient pas les noms aux sous-traitants.",
    consentTitle: "Consentement explicite tracé",
    consentDesc: "Chaque consentement client est journalisé (recommandé en santé).",
    autoAnonTitle: "Anonymisation automatique après expiration",
    autoAnonDesc: "Purge périodique des données expirées.",
    saveConfig: "Sauver la configuration",
    variablesAvailable: "Variables disponibles :",
    resetFactory: "Réinitialiser usine",
    saveTemplates: "Sauver les templates",
    resetConfirmTitle: "Réinitialiser tous les templates aux valeurs d'usine ?",
    resetConfirmItem: "Toute personnalisation apportée aux templates de cette verticale sera perdue.",
    reset: "Réinitialiser",
  },
  adminVerticalPersonas: {
    fieldRoleIntro: "Rôle & posture",
    fieldRoleIntroHint: "Description du rôle et du ton de l'agent. 2-3 phrases en français.",
    fieldVocabulary: "Vocabulaire métier",
    fieldVocabularyHint: "Lexique propre à la verticale (ex : commande/RDV/séance).",
    fieldWorkflow: "Workflow",
    fieldWorkflowHint: "Étapes numérotées du flux (prise de commande, prise de RDV…).",
    fieldDomainRules: "Règles métier",
    fieldDomainRulesHint: "Règles spécifiques à la verticale (anti-hallucination métier, durée, format…).",
    fieldRecapFormat: "Format de récap",
    fieldRecapFormatHint: "Comment l'agent doit récapituler avant confirmation.",
    fieldForbidden: "Interdictions",
    fieldForbiddenHint: "Comportements absolument interdits pour cette verticale.",
    loadError: "Erreur de chargement",
    genericError: "Erreur",
    saveError: "Erreur enregistrement",
    personaSaved: "Persona enregistré — actif sur tous les tenants de la verticale",
    defaultsRestored: "Défauts restaurés",
    overline: "Super Admin",
    title: "Personas IA — verticales",
    subtitle: "Couche 1 du système Dual-Level AI Specialization. Chaque persona définit le comportement de base de l'agent IA pour TOUS les tenants d'une verticale. Vos overrides s'appliquent immédiatement, sans déploiement.",
    custom: "Custom",
    pickVertical: "Sélectionnez une verticale à gauche pour éditer son persona.",
    loading: "Chargement…",
    hasOverride: "Cette verticale a une personnalisation active en base.",
    noOverride: "Aucune personnalisation — l'agent suit les valeurs par défaut du code.",
    hideDefaults: "Masquer défauts",
    showDefaults: "Voir défauts",
    restoreDefaults: "Restaurer défauts",
    saving: "Enregistrement…",
    save: "Enregistrer",
    warningBanner: "Toute modification s'applique {rt} à tous les tenants de cette verticale. Aucun déploiement n'est requis.",
    realTime: "en temps réel",
    modified: "modifié",
    restoreField: "Restaurer ce champ",
    defaultValueCode: "Valeur par défaut (code)",
    cceCardTitle: "CCE (contenu mesuré en parallèle — shadow only)",
    resetConfirmTitle: "Restaurer les valeurs par défaut pour {label} ?",
    resetConfirmItem: "Toute personnalisation apportée à ce persona sera supprimée.",
    restore: "Restaurer",
  },
  pricing: {
    loadError: "Impossible de charger les tarifs",
    stripeUnavailable: "Lien Stripe indisponible",
    stripeError: "Erreur Stripe",
    back: "← Retour",
    heroOverline: "Tarifs transparents · sans surprise",
    heroTitleStart: "Une formule pour chaque",
    heroTitleEm: "besoin",
    heroSubtitle: "Toutes les formules incluent l'IA téléphonique 24/7, votre numéro Twilio FR dédié, le dashboard temps réel et l'hébergement Europe RGPD-conforme. Sans engagement, résiliable à tout moment.",
    roiCta: "Calculer mon ROI en 30 secondes",
    subscriptionOverline: "Abonnement",
    subscriptionTitle: "Choisissez votre formule.",
    subscriptionSubtitle: "Sans engagement. Démarrage sous 48 h. Vous changez ou résiliez quand vous voulez.",
    legacyOverline: "Formules legacy (interne)",
    voiceTiersOverline: "Niveaux de voix IA",
    voiceTiersTitle: "Choisissez la voix de votre assistant.",
    voiceTiersSubtitle: "Cascade automatique : si la voix Premium n'est plus disponible, l'appel bascule sur Pro puis Standard. Vos clients ne tomberont jamais sur du silence.",
    included: "Inclus",
    perMonth: "/mois",
    perMinute: "/min",
    usageBilledSeparately: "d'usage (débité du solde prépayé)",
    setupFee: "de frais de mise en service",
    optionsOverline: "Options à la carte",
    optionsTitle: "Ajoutez ce qu'il vous faut, quand il vous le faut.",
    footerTitle: "Pas sûr de la formule à choisir ?",
    footerSubtitle: "Décrivez votre activité en deux phrases — on vous recommande la formule la plus adaptée et un devis personnalisé sous 24h.",
    requestQuote: "Demander un devis",
    recommended: "Recommandé",
    htPerMonth: "HT / mois",
    choose: "Choisir",
    invalidEmail: "Email invalide",
    genericError: "Erreur",
    quoteSent: "Demande envoyée ✓ Nous revenons vers vous sous 24h.",
    sendError: "Erreur lors de l'envoi",
    requestQuoteFor: "Demander un devis — {name}",
    htPerMonthShort: "€ HT / mois · réponse sous 24h",
    personalizedResponse: "Réponse personnalisée sous 24h.",
    nameOptional: "Nom (optionnel)",
    email: "Email *",
    activityType: "Type d'activité",
    selectPlaceholder: "— Sélectionner —",
    vRestaurant: "Restaurant",
    vHairdresser: "Coiffeur / Barbier",
    vDoctor: "Médecin / Cabinet",
    vEsthetics: "Esthéticienne",
    vPhysio: "Kinésithérapeute",
    vVet: "Vétérinaire",
    vOther: "Autre",
    describeNeed: "Décrivez votre besoin (optionnel)",
    describeNeedPlaceholder: "Combien d'appels par jour, équipe…",
    sendRequest: "Envoyer ma demande",
    setupFeeOneShot: "de mise en service (one-shot)",
    subscribe: "Souscrire —",
    perMonthShort: "€/mois",
    noCommitment: "Sans engagement · Résiliable à tout moment",
  },
  verifyEmail: {
    invalidLink: "Lien invalide : jeton manquant.",
    alreadyVerified: "Adresse déjà confirmée. Bienvenue à nouveau !",
    confirmed: "Adresse confirmée. Votre essai est ouvert.",
    validating: "Validation du lien…",
    successOverline: "Bienvenue",
    successTitle: "Votre compte est prêt",
    redirecting: "Redirection automatique vers votre tableau de bord…",
    checklistVerified: "Compte et e-mail vérifiés",
    checklistSetup: "Configuration de l'assistant IA…",
    checklistNumber: "Numéro de téléphone dédié",
    errorOverline: "Lien invalide",
    expiredHint: "Le lien peut avoir expiré (48 h) ou avoir déjà été utilisé.",
    login: "Se connecter",
    recreateAccount: "Recréer un compte",
  },
  adminVerticals: {
    overline: "Plateforme",
    title: "Verticales",
    subtitle: "Chaque verticale définit les modules par défaut et règles métier appliquées aux nouveaux établissements.",
    newVertical: "Nouvelle verticale",
    colKey: "Clé",
    colNameFr: "Nom FR",
    colNameEn: "Nom EN",
    colDefaultModules: "Modules par défaut",
    colMedical: "Médical",
    colActions: "Actions",
    yes: "Oui",
    detail: "Détail",
    edit: "Modifier",
    delete: "Supprimer",
    emptyTitle: "Aucune verticale",
    emptyDescription: "Créez la première verticale métier (restaurant, coiffeur, médecin…) pour catégoriser vos établissements.",
    editTitle: "Modifier {key}",
    keyLabel: "Clé",
    medicalMode: "Mode médical (RGPD renforcé)",
    nameFrLabel: "Nom FR",
    nameEnLabel: "Nom EN",
    activeModules: "Modules actifs par défaut",
    cancel: "Annuler",
    save: "Enregistrer",
    create: "Créer",
    deleteConfirmTitle: "Supprimer la verticale {key} ?",
    deleteConfirmItem: "Les tenants existants utilisant cette verticale ne seront pas supprimés, mais leur métier de référence disparaîtra.",
    deleteConfirmLabel: "Supprimer",
    toastUpdated: "Verticale mise à jour",
    toastCreated: "Verticale créée",
    toastDeleted: "Verticale supprimée",
    placeholderKey: "EX: NOTAIRE",
  },
  adminTenants: {
    toastStatusUpdated: "Statut mis à jour",
    toastDeletedPrefix: "Établissement supprimé. Stripe : ",
    toastDeletedCanceled: "annulé",
    toastDeletedNA: "n/a",
    toastDeletedSuffix: " · {count} facture(s) anonymisée(s).",
    toastImpersonate: "Connexion en tant que {name}",
    toastCreated: "Établissement créé",
    overline: "Plateforme",
    title: "Établissements",
    filteredBy: "Filtré par statut : ",
    remove: "retirer",
    searchPlaceholder: "Rechercher…",
    statusPlaceholder: "Statut",
    statusAll: "Tous",
    statusPending: "En attente",
    statusActive: "Actifs",
    statusSuspended: "Suspendus",
    newTenant: "Nouvel établissement",
    reload: "Recharger",
    colTenant: "Établissement",
    colSlug: "Slug",
    colVertical: "Verticale",
    colStatus: "Statut",
    colModules: "Modules",
    colActions: "Actions",
    emptyTitle: "Aucun établissement",
    emptyDescription: "Créez votre premier établissement pour commencer, ou attendez une inscription self-service.",
    deletedName: "SUPPRIMÉ",
    deletedOn: "Supprimé le {date} par {role}",
    badgeDeleted: "Supprimé",
    badgeActive: "Actif",
    badgePending: "Attente",
    badgeSuspended: "Suspendu",
    detail: "Détail",
    impersonateAction: "Connexion en tant que",
    activate: "Activer",
    suspend: "Suspendre",
    delete: "Supprimer",
    createTitle: "Nouvel établissement",
    formName: "Nom",
    formSlug: "Slug",
    formVertical: "Verticale",
    formChoose: "Choisir",
    formOwnerEmail: "E-mail propriétaire",
    formPhone: "Téléphone",
    formOwnerName: "Nom du propriétaire",
    formPassword: "Mot de passe",
    cancel: "Annuler",
    create: "Créer",
    impersonateTitle: "Connexion en tant que {name}",
    impersonateDescLine1: "Vous allez prendre la main sur ce tenant avec un accès",
    impersonateDescStrong: "lecture + écriture",
    impersonateDescLine2: "Toute action que vous effectuerez sera journalisée et imputable à votre compte SUPER_ADMIN.",
    impersonateDescLine3: "Quittez l'impersonation à tout moment depuis le bandeau orange en haut de l'écran.",
    confirm: "Confirmer",
    deleteTitle: "Supprimer définitivement « {slug} » ?",
    deleteItem1: "Annule l'abonnement Stripe (seul le mois en cours est prélevé).",
    deleteItem2: "Supprime tous les utilisateurs, commandes, appels, catalogue, RDV.",
    deleteItem3: "Anonymise les factures (conservées 10 ans par obligation légale).",
    deleteItem4: "Libère le numéro Twilio.",
    deleteItem5: "Envoie un e-mail de confirmation au propriétaire.",
    typeToConfirm: "Tapez {slug} pour confirmer",
    deleteReasonLabel: "Raison de la suppression (audit RGPD, obligatoire)",
    deleteReasonPlaceholder: "Choisir une raison…",
    reasonFraud: "Fraude",
    reasonTos: "Violation des CGU",
    reasonGdpr: "Demande RGPD (droit à l'effacement)",
    reasonOther: "Autre",
    deleting: "Suppression…",
    deletePermanently: "Supprimer définitivement",
    voiceDistTitle: "Distribution Voix IA",
    loading: "Chargement…",
    voiceDistSubtitle: "Répartition des tenants par stack TTS et MRR estimée",
    voiceMrr: "MRR Voix",
    tenantsTotal: "{count} tenant{s} au total",
    noTenant: "Aucun tenant",
    tenantWord: "tenant",
    perMonth: "/mois",
    mrrLabel: "MRR : ",
  },
  adminFlowEditorV2: {
    toastGraphValid: "Graphe valide",
    toastValidationError: "Erreur de validation",
    toastGraphSaved: "Graphe enregistré",
    toastErrorsDetail: "{count} erreur(s) — voir le détail",
    toastSaveError: "Erreur enregistrement",
    toastGraphDeleted: "Graphe supprimé",
    toastGenericError: "Erreur",
    toastVersionRestored: "Version {version} restaurée",
    toastRestoreError: "Erreur de restauration",
    toastInvalidFacts: "Faits JSON invalides : {error}",
    toastJsonApplied: "JSON appliqué au diagramme",
    invalidJson: "JSON invalide : {error}",
    backHome: "Retour à l'accueil admin",
    home: "Accueil",
    choosePlaceholder: "Choisir une verticale",
    newBadge: "nouveau",
    entryLabel: "Entrée",
    history: "Historique",
    simulate: "Simuler",
    json: "JSON",
    validating: "Validation…",
    validate: "Valider",
    deleteGraphAria: "Supprimer le graphe scripté",
    saving: "Enregistrement…",
    save: "Enregistrer",
    tabGraph: "Graphe",
    tabPhrases: "Phrases",
    tabAudio: "Audio",
    tabFiller: "Ameublement",
    validationErrorsCount: "{count} erreur(s) de validation",
    chooseVerticalHint: "Choisis une verticale en haut à gauche pour ouvrir son graphe de conversation.",
    loading: "Chargement…",
    graphJsonLabel: "Graphe (JSON)",
    applyToDiagram: "Appliquer au diagramme",
    versionHistoryLabel: "Historique des versions",
    noArchivedVersion: "Aucune version archivée pour l'instant.",
    historyMeta: "{count} nœud(s) · {by} · {date}",
    restore: "Restaurer",
    simulateBranchLabel: "Simuler un branchement",
    fromOption: "depuis…",
    noEdgeFromNode: "Aucune arête ne part de ce nœud.",
    triggered: "✓ déclenchée",
    deleteGraphTitle: "Supprimer le graphe scripté de {vertical} ?",
    deleteGraphItem: "Le tenant retombera sur Realtime seul (plus de script guidé pour cette verticale).",
    delete: "Supprimer",
    restoreVersionTitle: "Restaurer la version {version} ?",
    restoreVersionItem: "Ceci crée une NOUVELLE version reprenant cet ancien contenu — l'historique actuel n'est pas perdu.",
    reloadDefaults: "Recharger les valeurs par défaut",
    reloadingDefaults: "Rechargement…",
    reloadDefaultsAria: "Recharger le graphe et les phrases par défaut de cette verticale",
    reloadDefaultsTitle: "Recharger les valeurs par défaut pour {vertical} ?",
    reloadDefaultsItem: "Le graphe et les phrases de cette verticale seront remplacés par la dernière version par défaut fournie par l'équipe technique. Toute personnalisation faite depuis l'éditeur pour cette verticale sera écrasée — une nouvelle version est créée (rien n'est perdu, tu peux restaurer l'ancienne depuis l'Historique).",
    toastDefaultsReloaded: "Valeurs par défaut rechargées",
    toastReloadDefaultsError: "Erreur lors du rechargement des valeurs par défaut",
    toastReloadDefaultsUnavailable: "Aucun modèle par défaut n'est disponible pour cette verticale.",
  },
  adminTenantDetail: {
    sectionInfo: "Infos",
    sectionModules: "Modules",
    sectionTelephony: "Téléphonie",
    sectionUsers: "Utilisateurs",
    sectionOrders: "Commandes",
    sectionBookings: "RDV",
    sectionConversations: "Conversations",
    sectionCrte: "CRTE",
    sectionCce: "CCE",
    sectionAudit: "Audit",
    allEstablishments: "Tous les établissements",
    overline: "Établissement · {vertical}",
    badgeActive: "Actif",
    badgePending: "Attente",
    badgeSuspended: "Suspendu",
    activate: "Activer",
    suspend: "Suspendre",
    printOnboarding: "🖨️ Imprimer pack onboarding",
    printContract: "📄 Imprimer contrat",
    billingDetail: "Facturation détaillée",
    viewAudit: "Voir audit",
    publicPage: "Page publique",
    delete: "Supprimer",
    infoTitle: "Informations",
    fieldVertical: "Verticale",
    fieldEmail: "E-mail",
    fieldPhone: "Téléphone",
    fieldCountry: "Pays",
    fieldTimezone: "Fuseau",
    fieldLanguage: "Langue par défaut",
    fieldCurrency: "Devise",
    fieldCreatedAt: "Créé le",
    fieldAddress: "Adresse",
    modulesActive: "Modules actifs ({count}/9)",
    telephonySms: "Téléphonie & SMS (M2)",
    usersCount: "Utilisateurs ({count})",
    addUser: "Ajouter un utilisateur",
    colName: "Nom",
    colEmail: "E-mail",
    colRole: "Rôle",
    colStatus: "Statut",
    colPassword: "Mot de passe",
    badgeTemporary: "Temporaire",
    ok: "OK",
    noUser: "Aucun utilisateur",
    crteTitle: "CRTE — Garde-fous conversationnels (shadow mode)",
    cceTitle: "CCE — Contenu conversationnel (Greeting)",
    greetingLabel: "Phrase d'accueil (greeting)",
    auditRecent: "Audit récent ({count})",
    colDate: "Date",
    colAction: "Action",
    colResource: "Ressource",
    noEvent: "Aucun événement",
    deleteTenantTitle: "Supprimer définitivement ce tenant ?",
    deleteTenantItem1: "Toutes les données du tenant (commandes, réservations, conversations, config) seront perdues.",
    deleteTenantItem2: "Cette action est irréversible.",
    toastStatusChanged: "Statut → {status}",
    toastDeleted: "Supprimé",
    loading: "Chargement…",
    tenantNotFound: "Tenant introuvable",
    slugUrlPublic: "Slug (URL publique)",
    editSlugAria: "Modifier le slug",
    saveSlugAria: "Enregistrer le slug",
    cancelSlugAria: "Annuler la modification du slug",
    checking: "Vérification…",
    available: "✓ Disponible",
    slugTaken: "✗ Slug déjà pris",
    typeToCheck: "Tapez ≥ 3 caractères pour vérifier",
    formerSlugs: "· Anciens: ",
    toastSlugRenamed: "Slug renommé → /p/{slug}",
    toastPlaybookReset: "Playbook IA réinitialisé — tenant revient au défaut vertical",
    toastNoOverrides: "Le tenant n'avait aucune personnalisation — rien à supprimer",
    playbookResetTitle: "Playbook IA — Réinitialiser au défaut vertical",
    playbookResetDescription: "Supprime toutes les surcharges (étapes ajoutées, étapes désactivées) que ce tenant a appliquées à son Playbook IA. Le tenant revient au playbook standard de sa verticale. Action tracée dans l'audit log.",
    overridesDeleted: "Surcharges supprimées ({count} document)",
    noOverridesToDelete: "Aucune surcharge à supprimer",
    reset: "Réinitialiser",
    resetPlaybookTitle: "Réinitialiser le Playbook IA de ce tenant ?",
    resetPlaybookItem1: "Toutes les étapes personnalisées et exclusions seront perdues.",
    resetPlaybookItem2: "Le tenant revient au playbook standard de sa verticale.",
    resetPlaybookItem3: "Cette action est tracée dans l'audit.",
  },
};

export const en = {
  common: {
    appName: "AI Commerce OS",
    tagline: "Your venue, available 24/7",
    login: "Login",
    register: "Get started",
    logout: "Logout",
    dashboard: "Dashboard",
    backHome: "Back to home",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    copy: "Copy",
    refresh: "Refresh",
    confirm: "Confirm",
    loading: "Loading…",
    error: "Error",
    success: "Success",
    email: "Email",
    password: "Password",
    name: "Name",
    optional: "(optional)",
    required: "Required",
    activate: "Activate",
    deactivate: "Deactivate",
    active: "Active",
    inactive: "Inactive",
    yes: "Yes",
    no: "No",
    search: "Search",
    learnMore: "Learn more",
    perMonth: "/ month",
    totalMonth: "Total / month",
  },
  nav: {
    overview: "Overview",
    conversations: "Conversations",
    bookings: "Bookings",
    resources: "Resources",
    services: "Services",
    kiosk: "Kiosk mode",
    blacklist: "Client lists",
    orders: "Orders",
    clients: "Clients",
    analytics: "Analytics",
    settings: "Settings",
    publicPage: "Public page",
    team: "Team",
    audit: "Audit log",
    modules: "Modules & Voice",
    tenants: "Tenants",
    verticals: "Verticals",
    platform: "Platform",
    pricing: "Pricing",
  },
  kiosk: {
    title: "Today's bookings",
    fullscreenAria: "Fullscreen",
    exitAria: "Exit kiosk mode",
    upcoming: "Upcoming",
    finished: "Finished",
    covers: "Covers (upcoming)",
    resources: "Resources",
    empty: "No bookings",
    emptyHint: "Enjoy the calm ☕",
    inProgress: "● In progress",
    loading: "Loading…",
    footer: "Auto-refresh every 30 seconds · Esc to exit",
    today: "Today",
    coversShort: "COVER",
    coversShortPlural: "COVERS",
  },
  landing: {
    heroTitle: "A 24/7 venue — without hiring.",
    heroSubtitle:
      "AI Commerce OS answers your calls, handles your bookings, takes orders and collects payments. You stay in control, the AI does the rest.",
    heroCta: "Start free trial",
    heroCtaSecondary: "Watch a demo",
    heroBullet1: "No commitment",
    heroBullet2: "Setup in 1 hour",
    heroBullet3: "European hosting",
    moduleSectionLabel: "9 modules. One platform.",
    moduleSectionTitle: "Activate only what you need.",
    moduleSectionBody:
      "Each business has unique needs. Each module is independent. Toggle them one by one — billing adjusts instantly.",
    verticalsLabel: "Built for your industry",
    verticalsTitle: "Restaurant, hotel, clinic, salon — one foundation.",
    pricingLabel: "Transparent pricing",
    pricingTitle: "You only pay for what you activate.",
    pricingBaseLabel: "Base — always included",
    pricingBaseDescription: "Foundations + public page + team.",
    ctaFinalTitle: "Ready to take back control?",
    ctaFinalBody: "Set up your venue in under an hour. No commitment.",
    footerRights: "All rights reserved.",
    liveCallsBadge: "+312 calls handled this week",
    modulesSelected: "{count} module{s} selected.",
    heroLiveCallTitle: "Call in progress — Le Bistrot du Coin",
    heroLiveCallSub: "Table for 4 · 8:30pm · confirmed by the AI",
    heroLiveCallBadge: "Live",
  },
  auth: {
    loginTitle: "Login",
    loginSubtitle: "Access your dashboard.",
    loginButton: "Sign in",
    registerTitle: "Create your venue",
    registerSubtitle: "3 steps. 5 minutes. No commitment.",
    registerButton: "Create account",
    forgotPassword: "Forgot password?",
    magicLink: "Get a magic link",
    noAccount: "No account yet?",
    hasAccount: "Already registered?",
    chooseVertical: "Choose your industry",
    businessInfo: "Your venue",
    accountInfo: "Your account",
    businessName: "Venue name",
    slug: "Public URL",
    slugHelp: "Available at",
    contactEmail: "Contact email",
    contactPhone: "Phone",
    country: "Country",
    language: "Default language",
    ownerName: "Your name",
    next: "Next step",
    previous: "Back",
    finish: "Create my venue",
    forgotTitle: "Reset password",
    forgotBody: "Enter your email. You'll receive a reset link.",
    forgotButton: "Send link",
    forgotSent: "If an account exists, a link has been sent.",
    magicTitle: "Magic link",
    magicBody: "Receive a login link by email.",
    magicButton: "Send the link",
    magicSent: "Check your inbox (and the server console in dev).",
    resetTitle: "New password",
    resetButton: "Update",
    confirmPasswordLabel: "Confirm",
    showPasswordAria: "Show",
    mismatch: "The two passwords do not match.",
    invalidToken: "Invalid or expired link.",
    modulesCount: "{count} modules",
    medicalMode: "Medical mode",
    accountCreated: "Account created — check your inbox.",
    establishmentCreated: "Establishment created!",
    yourSlugPlaceholder: "your-slug",
    slugAvailable: "✓ available",
    slugTaken: "✗ already taken",
    countryFrance: "France",
    countryBelgium: "Belgium",
    countrySwitzerland: "Switzerland",
    countryLuxembourg: "Luxembourg",
    langFrench: "French",
    langEnglish: "English",
    summary: "Summary",
    preactivatedModules: "Pre-activated modules: ",
    acceptTermsPrefix: "I accept the",
    termsLink: "Terms of Service",
    acceptPrivacyPrefix: "I have read and accept the",
    privacyLink: "Privacy Policy",
    loginSuccess: "Login successful",
    emailNotConfirmed: "E-mail not confirmed — check your inbox.",
    demoAccountsTitle: "Demo accounts — one per role",
    demoPasswordShared: "Shared password: ",
    forgotDevModeLabel: "Local dev mode (FORGOT_PASSWORD_DEV_LINK) — ",
  },
  moduleLocked: {
    body: "This module is not yet activated for your establishment. Activate it from settings to access its features.",
    cta: "Activate the module →",
  },
  welcomeModal: {
    overline: "Welcome to AICommerceOS",
    title: "{count} steps before you go live",
    body: "Your venue is created, but your AI assistant isn't operational yet. Here's what's left to set up:",
    requiredTag: "Required",
    optionalTag: "Optional",
    exploreFirst: "Explore first",
    launchCta: "Start setup",
  },
  notFound: {
    seoTitle: "Page not found",
    overline: "404 error",
    body: "This page doesn't exist anymore. Check the address or go back home.",
    cta: "Back to home",
  },
  dashboard: {
    welcome: "Hello",
    statusPending: "Pending publish",
    statusActive: "Live",
    statusSuspended: "Suspended",
    publishCta: "Publish my venue",
    publishedToast: "Business published!",
    publishFailedToast: "Publish failed",
    overviewSubtitle: "Real-time control of your business.",
    activeModules: "Active modules",
    monthlyTotal: "Monthly cost",
    publicUrl: "Public URL",
    members: "Team members",
    moduleManager: "Module manager",
    moduleManagerSub: "Toggle each module on or off. Billing updates in real time.",
    publicPageTitle: "Public page",
    publicPageSub: "Configure the blocks visible to your customers.",
    blockType: {
      hero: "Hero banner",
      about: "About",
      services: "Services",
      hours: "Hours",
      location: "Location",
      faq: "FAQ",
      testimonials: "Testimonials",
    },
    settingsTitle: "Settings",
    settingsSub: "Contact, hours, branding.",
    teamTitle: "Team",
    teamSub: "Manage your collaborators and their access.",
    addMember: "Add member",
    auditTitle: "Audit log",
    auditSub: "Every action is tracked (append-only).",
  },
  superAdmin: {
    title: "Super admin console",
    subtitle: "Control the AI Commerce OS platform.",
    tenants: "Tenants",
    verticals: "Verticals",
    platform: "Platform",
    audit: "Global audit",
    tenantsCount: "Tenants",
    activeCount: "Active",
    pendingCount: "Pending",
    suspendedCount: "Suspended",
    usersCount: "Users",
    auditCount: "Events",
    navDashboard: "Dashboard",
    navTenantsAccess: "Tenants & access",
    navRoles: "Roles & permissions",
    navLeads: "Leads",
    navVerticalsAi: "Verticals & AI",
    navFlowEditorBeta: "Flow editor (beta)",
    navCommerceBilling: "Commerce & billing",
    navB2bBilling: "B2B billing",
    navCommercePricing: "Business documents",
    navCostsMargins: "Costs & margins",
    navPricing: "Pricing",
    navPlatform: "Platform",
    navTrialSignup: "Free trial & signup",
    navGdprLegal: "GDPR & Legal",
    navSystemHealth: "System health",
    navAiLatency: "AI latency",
    navUnderstandingQuality: "WhatsApp comprehension quality",
    navVoiceObservability: "Voice call reliability",
    navKnowledgeBase: "Knowledge base",
    closeMenu: "Close menu",
    openMenu: "Open menu",
  },
  adminOverview: {
    verticalsLabel: "Verticals",
    topVertical: "Top vertical",
    aiCostsTitle: "AI Costs · {month}",
    grossMarginTitle: "Platform gross margin",
    seeDetail: "See detail",
    aiCostLabel: "AI cost",
    revenueLabel: "Revenue",
    marginLabel: "Margin",
    activeTenantsLabel: "Active tenants",
    withAiCostThisMonth: "with AI cost > 0 this month",
    topTenantsByAiCost: "Top tenants by AI cost",
    costLabel: "Cost",
    verticalBreakdownTitle: "Breakdown by vertical",
    noEstablishment: "No establishments registered",
  },
  publicTenant: {
    orderOnline: "Order online",
    descriptionMenu: "Online menu, ordering, allergens.",
    descriptionAvailable: "Available 24/7.",
    notFoundTitle: "Establishment not found",
    notFoundBody: "This profile doesn't exist or isn't published yet.",
    viewMenu: "View menu",
    about: "About",
    services: "Services",
    toConfigure: "To be configured.",
    hours: "Hours",
    closed: "Closed",
    location: "Location",
    addressComingSoon: "Address coming soon.",
    menuOf: "Menu for {name}",
  },
  adminRoles: {
    overline: "Platform",
    title: "Roles & permissions",
    subtitle: "System roles (locked) cover standard cases. Create custom roles for your specific business needs.",
    newRole: "New role",
    editTitle: "Edit {key}",
    createTitle: "Create a new role",
    keyLabel: "Key (UPPER_SNAKE)",
    placeholderKey: "E.G.: BARISTA",
    scopeLabel: "Scope",
    scopeTenant: "Tenant (establishment)",
    scopePlatform: "Platform (super admin)",
    nameFrLabel: "Name (French)",
    nameEnLabel: "Name (English)",
    permissionsSelected: "{count} permission(s) selected",
    deselectAll: "Deselect all",
    selectAll: "Select all",
    cancel: "Cancel",
    save: "Save",
    createRole: "Create role",
    permissionsCount: "{count} permission(s)",
    edit: "Edit",
    deleteRoleAria: "Delete role {key}",
    deleteRoleTitle: "Delete role {key}?",
    deleteRoleItem: "Users with this role will lose the associated permissions.",
    delete: "Delete",
    toastRoleUpdated: "Role updated",
    toastRoleCreated: "Role created",
    toastRoleDeleted: "Role deleted",
  },
  verticals: {
    RESTAURANT: "Restaurant",
    HOTEL: "Hotel",
    DOCTOR: "Doctor",
    COIFFEUR: "Hair salon",
    ESTHETIQUE: "Beauty salon",
  },
  orders: {
    moduleLabel: "Module M5",
    title: "Orders",
    subtitle: "All orders — manual, AI and website.",
    kitchenView: "Kitchen view",
    refresh: "Refresh",
    newOrder: "New order",
    searchLabel: "Search",
    searchPlaceholder: "Number, customer, phone…",
    statusLabel: "Status",
    allStatuses: "All statuses",
    channelLabel: "Channel",
    allChannels: "All channels",
    typeLabel: "Type",
    allTypes: "All types",
    resetFilters: "Reset",
    colNumber: "No.",
    colType: "Type",
    colChannel: "Channel",
    colCustomer: "Customer",
    colItems: "Items",
    colTotal: "Total",
    colStatus: "Status",
    colDate: "Date",
    emptyTitle: "No orders",
    emptyNoOrders: "Orders taken by phone, online, or entered manually will appear here.",
    emptyFiltered: "No orders match these filters.",
    detailsTitle: "Details",
    printTicketTitle: "Print receipt",
    dialogTitle: "New order",
    formType: "Type",
    formChannel: "Channel",
    formTableNumber: "Table number",
    formDeliveryAddress: "Delivery address",
    formCustomerName: "Customer name",
    formPhone: "Phone",
    formItems: "Items",
    formAddItem: "Add",
    formNotePlaceholder: "Note (e.g. no onions)",
    formNotes: "Notes",
    formTotal: "Total",
    formPaymentRequired: "Payment required (Stripe SMS)",
    formCancel: "Cancel",
    formSubmit: "Create order",
    noItemsAvailable: "No items available. Create some in the Catalog first.",
    orderCreated: "Order created",
    orderCancelled: "Order cancelled",
    cancelOrderTitle: "Cancel order #{number}?",
    cancelOrderWarning: "The customer will not be notified automatically — call them if needed.",
    cancelOrderConfirm: "Cancel order",
    status: {
      PENDING_PAYMENT: "Awaiting payment",
      CONFIRMED: "To prepare",
      IN_PREPARATION: "In preparation",
      READY: "Ready",
      COMPLETED: "Delivered / Handed over",
      CANCELLED: "Cancelled",
    },
    type: {
      PICKUP: "Pickup",
      DELIVERY: "Delivery",
      DINE_IN: "Dine in",
    },
    channel: {
      AI: "🤖 AI",
      WIDGET: "🌐 Web",
      MANUAL: "✋ Manual",
    },
  },
  resources: {
    overline: "Resources",
    titleDefault: "Bookable resources",
    titleDOCTOR: "Practitioners",
    titleHOTEL: "Rooms",
    titleCOIFFEUR: "Stylists",
    titleESTHETIQUE: "Beauticians / Cabins",
    subtitleRESTAURANT: "Tables and areas in your venue.",
    subtitleHOTEL: "Rooms available for booking.",
    subtitleDOCTOR: "Practitioners at the practice.",
    subtitleCOIFFEUR: "Stylists and chairs.",
    subtitleESTHETIQUE: "Beauticians and cabins.",
    addButton: "Add",
    dialogTitleEdit: "Edit resource",
    dialogTitleNew: "New resource",
    formName: "Name",
    formType: "Type",
    formCapacity: "Capacity",
    formColor: "Color (calendar)",
    formDescription: "Description (optional)",
    formIcalUrl: "External iCal URL to import (optional)",
    formIcalPlaceholder: "https://… (Doctolib, Outlook, public Google Cal, Calendly…)",
    formIcalHint: "Slots from this feed will automatically block the resource (synced every 5 min).",
    formActiveLabel: "Active resource (available for booking)",
    formSubmit: "Save",
    formSaving: "...",
    colName: "Name",
    colType: "Type",
    colCapacity: "Capacity",
    colStatus: "Status",
    statusActive: "Active",
    statusInactive: "Disabled",
    syncAriaLabel: "Sync {name}'s calendar",
    editAriaLabel: "Edit {name}",
    deleteAriaLabel: "Delete {name}",
    syncSuccessToast: "iCal sync — {count} slots imported",
    updateSuccessToast: "Resource updated",
    createSuccessToast: "Resource created",
    deleteSuccessToast: "Resource deleted",
    emptyTitle: "No resources",
    emptyDescription: "Tables, rooms, practitioners… create the first resource your customers can book.",
    emptyActionLabel: "Add a resource",
    deleteConfirmTitle: "Delete \"{name}\"?",
    deleteConfirmWarning: "Bookings already made on this resource are not cancelled.",
    deleteConfirmLabel: "Delete",
    types: {
      table: "Table",
      room: "Room",
      practitioner: "Practitioner",
      stylist: "Stylist",
      chair: "Chair",
      esthetician: "Esthetician",
      cabin: "Cabin",
    },
  },
  blacklist: {
    overline: "Cancellation management",
    title: "Grey list & blacklist",
    subtitle: "Clients under watch or blocked. Matching is done on first name + last name + date of birth (fallback email/phone). Thresholds are configurable in {settingsPath}.",
    subtitleSettingsPath: "Settings → Cancellation policy",
    addManually: "Add manually",
    kpiTotal: "Total",
    kpiGrey: "Grey list",
    kpiBlack: "Blacklist",
    searchLabel: "Search",
    searchPlaceholder: "Name, email, phone…",
    statusLabel: "Status",
    statusAll: "All",
    statusGrey: "Grey list",
    statusBlack: "Blacklist",
    refresh: "Refresh",
    colClient: "Client",
    colBirthDate: "Date of birth",
    colContact: "Contact",
    colStatus: "Status",
    colCancellations: "Cancellations",
    colSource: "Source",
    statusGreyBadge: "Grey",
    statusBlackBadge: "Black",
    noShowSuffix: "no-show",
    lastMinuteSuffix: "last-minute",
    sourceManual: "Manual",
    sourceAuto: "Auto",
    editAriaLabel: "Edit {name}",
    removeAriaLabel: "Remove {name}",
    emptyTitle: "No clients on the list",
    emptyDescription: "Future cancellations and no-shows will automatically feed this list, or add a client manually.",
    emptyActionLabel: "Add a client",
    dialogTitleEdit: "Edit entry",
    dialogTitleNew: "Add to the list",
    formFirstName: "First name *",
    formLastName: "Last name *",
    formBirthDate: "Date of birth (strongly recommended)",
    formEmail: "Email",
    formPhone: "Phone",
    formStatus: "Status *",
    formStatusGrey: "Grey list (watch)",
    formStatusBlack: "Blacklist (block)",
    formStatusRemove: "Remove from list",
    formReason: "Reason",
    formReasonPlaceholder: "e.g. 3 consecutive no-shows",
    formNotes: "Internal notes",
    formSubmit: "Save",
    formSaving: "...",
    updateSuccessToast: "Entry updated",
    createSuccessToast: "Entry added",
    deleteSuccessToast: "Entry removed",
    deleteConfirmTitle: "Remove \"{name}\" from the list?",
    deleteConfirmWarning: "The client will no longer be flagged when booking.",
    deleteConfirmLabel: "Remove",
  },
  catalog: {
    overlineM4M5: "Modules M4 + M5 — Orders & Services",
    overlineM5: "Module M5 — Orders",
    title: "Catalog",
    subtitleM4: "Manage your menu: items to order and services to book, in one list.",
    subtitleM5: "Manage your menu: categories, items, prices, photos, allergens, prep time.",
    importFromPhoto: "Import from photo",
    newItem: "New item",
    newService: "New service",
    newCategory: "New category",
    newMaterial: "New material",
    publicHintBold: "This menu is published on your storefront.",
    publicHintRest: "Every available item appears under the \"Our menu\" section of your public page.",
    publicPageLink: "Public page",
    viewOnline: "View online",
    establishmentInfoTitle: "Hours & dietary options",
    establishmentInfoSubtitle: "Shown on your public page and the WhatsApp shop.",
    establishmentInfoExpand: "Expand",
    establishmentInfoCollapse: "Collapse",
    establishmentInfoSavedToast: "Information saved",
    hoursManagedInTelephony: "Your hours are managed from the AI telephony settings (multiple time slots per day).",
    hoursManagedInTelephonyLink: "Edit them",
    dietaryLabelsTitle: "Dietary options",
    dietaryLabelsHint: "Shown as a badge on your public page and in the WhatsApp shop so customers know in advance.",
    dietaryVegan: "Vegan",
    dietaryVegetarian: "Vegetarian",
    dietaryHalal: "Halal",
    dietaryKosher: "Kosher",
    deliveryProvidersTitle: "Delivery",
    deliveryProvidersHint: "The services you actually use — the voice assistant and WhatsApp answer honestly when a customer asks if you deliver.",
    deliveryProvidersEmpty: "No delivery service configured yet.",
    deliveryProviderLabelPlaceholder: "Name (e.g. Uber Eats)",
    deliveryProviderUrlPlaceholder: "Link to your shop (optional)",
    deliveryProviderRemove: "Remove",
    deliveryProviderAdd: "Add a service",
    tabOffers: "Offers ({count})",
    tabItems: "Items ({count})",
    tabCategories: "Categories ({count})",
    tabMaterials: "Materials ({count})",
    tabOptions: "Add-ons",
    tabMenus: "Menus / Combos",
    tabVoice: "Voice playback",
    categoryLabel: "Category",
    allCategories: "All categories",
    colType: "Type",
    colPhoto: "Photo",
    colItem: "Item",
    colCategory: "Category",
    colPrice: "Price",
    colDurationPrep: "Duration/Prep",
    colPrep: "Prep",
    colAllergens: "Allergens",
    colAvailable: "Available",
    badgeService: "Service",
    badgeItem: "Item",
    itemsEmptyTitle: "No items",
    itemsEmptyDescription: "Start your menu by adding your first item.",
    colCategoryName: "Category",
    colOrder: "Order",
    colActive: "Active",
    active: "Active",
    inactive: "Inactive",
    categoriesEmptyTitle: "No categories",
    categoriesEmptyDescription: "Create one to organize your items (starters, mains, drinks…).",
    colRawMaterial: "Raw material",
    colUnit: "Unit",
    colCostPerUnit: "Cost / unit",
    colSupplier: "Supplier",
    materialsEmptyTitle: "No raw materials",
    materialsEmptyDescription: "Add your ingredients (steak, bread, milk…) to calculate gross margin.",
    matDialogEdit: "Edit material",
    matDialogNew: "New raw material",
    matFormName: "Name",
    matFormNameError: "The material name is required.",
    matFormUnit: "Unit",
    matFormUnitError: "The unit is required.",
    matFormUnitHint: "Used to calculate the material cost of your items (e.g. g, kg, ml, pcs).",
    matFormCost: "Cost / unit (€)",
    matFormSupplier: "Supplier (optional)",
    matFormNotes: "Notes",
    itemDialogEdit: "Edit item",
    itemDialogNew: "New item",
    itemFormName: "Name",
    itemFormNameError: "The item name is required.",
    itemFormCategory: "Category",
    itemFormNoCategory: "— None —",
    itemFormPrice: "Price (€)",
    itemFormPrepTime: "Prep time (min)",
    itemFormPhoto: "Photo (URL)",
    itemFormDescription: "Description",
    itemFormAllergens: "Allergens",
    itemFormAllergensHint: "(legal requirement in France)",
    itemFormAvailable: "Available for sale",
    serviceDialogEdit: "Edit service",
    serviceDialogNew: "New service",
    serviceFormName: "Name",
    serviceFormNameError: "The service name is required.",
    serviceFormDescription: "Description (optional)",
    serviceFormDuration: "Duration (minutes)",
    serviceFormPrice: "Price (€)",
    serviceFormResourceType: "Required resource type (optional)",
    serviceFormActive: "Active",
    catDialogEdit: "Edit category",
    catDialogNew: "New category",
    catFormName: "Name",
    catFormNameError: "The category name is required.",
    catFormOrder: "Display order",
    catFormActive: "Active",
    cancel: "Cancel",
    save: "Save",
    create: "Create",
    itemUpdatedToast: "Item updated",
    itemCreatedToast: "Item created",
    itemDeletedToast: "Item deleted",
    serviceUpdatedToast: "Service updated",
    serviceCreatedToast: "Service created",
    serviceDeletedToast: "Service deleted",
    catUpdatedToast: "Category updated",
    catCreatedToast: "Category created",
    catDeletedToast: "Category deleted",
    matUpdatedToast: "Material updated",
    matCreatedToast: "Material created",
    matDeletedToast: "Material deleted",
    deleteItemTitle: "Delete \"{name}\"?",
    deleteItemWarning: "The item disappears immediately from your menu and public page.",
    deleteServiceTitle: "Delete \"{name}\"?",
    deleteServiceWarning1: "The service disappears immediately from your menu and public page.",
    deleteServiceWarning2: "Bookings already made for this service are not cancelled.",
    deleteCatTitle: "Delete \"{name}\"?",
    deleteCatWarning: "Items in this category are NOT deleted — they'll be detached (no category).",
    deleteMatTitle: "Delete \"{name}\"?",
    deleteMatWarning: "Items using this raw material in their composition will no longer be linked to it.",
    deleteConfirmLabel: "Delete",
  },
  alerts: {
    overline: "M2 · AI monitoring",
    title: "Keyword alerts",
    subtitle: "Conversations where the AI detected a sensitive keyword (configured by your platform administrator).",
    refresh: "Refresh",
    emptyTitle: "No alerts yet",
    emptyDescription: "If the AI detects a sensitive keyword in a conversation, the event will appear here in real time.",
    client: "Client",
    ai: "AI",
    open: "Open",
  },
  kitchen: {
    overline: "Module M5",
    title: "Kitchen",
    subtitle: "Real-time view — ",
    connected: "● connected",
    disconnected: "● disconnected",
    soundTitle: "New order sound",
    exitTv: "Exit TV",
    tvMode: "TV mode",
    colToPrepare: "To prepare",
    colInPrep: "In preparation",
    colReady: "Ready",
    nextStart: "Start",
    nextMarkReady: "Mark ready",
    nextDeliver: "Deliver / Hand over",
    noOrders: "No orders",
    typePickup: "PICKUP",
    typeDelivery: "DELIVERY",
    typeDineIn: "DINE IN",
    channelAi: "🤖 AI",
    channelWidget: "🌐 Web",
    channelManual: "✋ Dashboard",
    table: "Table {number}",
    minutesShort: "min",
  },
  conversations: {
    overline: "M2 · Telephony & SMS",
    title: "Conversations",
    subtitle: "All calls and texts received on your dedicated number.",
    refresh: "Refresh",
    phoneOverline: "Your dedicated number",
    phoneHint: "Share this number with your customers. Calls and texts are handled by your automatic IVR and archived below.",
    noPhone: "No number provisioned for your establishment. Contact your platform administrator.",
    filterAll: "All",
    filterCalls: "Calls",
    filterSms: "SMS",
    filterUnderstandingFailed: "Understanding failures",
    filterAlerts: "AI alerts",
    filterCallbacks: "Callbacks to make",
    understandingFailedLabel: "Understanding failed",
    understandingFailedCoachPlaceholder: "(understanding failed — the AI couldn't process this and escalated the conversation)",
    colChannel: "Channel",
    colRemote: "Remote number",
    colStart: "Start",
    colStatus: "Status",
    colDuration: "Duration",
    colOrder: "Order",
    loading: "Loading…",
    empty: "No conversations yet.",
    emptyDescription: "Calls and texts received on your number will appear here.",
    statusActive: "Active",
    statusDone: "Ended",
    channelVoice: "Call",
    channelSms: "SMS",
    replayBtn: "Retest with current config",
    costTitle: "AI cost (SUPER_ADMIN)",
    turnsLabel: "turn",
    sttLabel: "STT",
    llmLabel: "LLM",
    ttsLabel: "TTS",
    voiceLabel: "Twilio voice",
    totalLabel: "Total",
    transcriptTitle: "AI transcript",
    exchangesLabel: "exchanges",
    orderTakenByAi: "Order taken by AI",
    itemLabel: "item",
    pickupLabel: "pickup",
    client: "Client",
    ai: "AI",
    coachBtn: "Coach",
    techEventsTitle: "Technical events",
    copyAll: "Copy all",
    noEvents: "No events.",
    keyPressed: "Key pressed",
    ruleTriggered: "Rule triggered",
    sensitiveKeywords: "Sensitive keywords detected",
    listenRecording: "Listen to the recording",
    fromLabel: "From",
    rawDetail: "Raw detail",
    copy: "Copy",
    payloadCopied: "Payload copied",
    coachingSaved: "Coaching taken into account starting next similar call",
    eventsCopiedToast: "{n} event(s) copied",
    intentCorrectionBtn: "Explain intent",
    intentCorrectionHint: "Explain what the customer really meant",
    intentCorrectionMissingFields: "Please fill in what the customer said and what they really meant",
    intentCorrectionSaved: "Intent saved and applied immediately",
    intentCorrectionDialogTitle: "Explain customer intent",
    intentCorrectionDialogSubtitle: "Explain what the customer really meant, even if the AI misheard or misunderstood. This rule is applied immediately to upcoming calls.",
    intentCorrectionCustomerTextLabel: "What the customer said",
    intentCorrectionResolvedValueLabel: "What they really meant",
    intentCorrectionResolvedValuePlaceholder: "E.g.: \"lunch menu\" = menu number 2",
    intentCorrectionNoteLabel: "Note (optional)",
    intentCorrectionNotePlaceholder: "Additional context to understand this correction",
    intentCorrectionSubmitBtn: "Save",
    phraseOverrideBtn: "Change this phrase",
    phraseOverrideHint: "Replace the assistant's wording for this phrase",
    phraseOverrideMissingText: "Please enter the new wording",
    phraseOverrideSaved: "New wording saved",
    phraseOverrideDialogTitle: "Change this phrase",
    phraseOverrideDialogSubtitle: "Suggest a better wording for this assistant reply. It will be added as a variant specific to your business, and you can generate its audio right away.",
    phraseOverrideOriginalLabel: "Current wording:",
    phraseOverrideNewTextLabel: "New wording",
    phraseOverridePhraseKeyLabel: "Phrase key (optional)",
    phraseOverridePhraseKeyPlaceholder: "Leave empty for automatic detection",
    phraseOverridePhraseKeyHint: "If left empty, the phrase key is detected automatically from this bubble.",
    phraseOverrideSubmitBtn: "Save",
    phraseOverrideSavedAs: "Variant #{n} added for \"{key}\"",
    phraseOverrideGenerateAudioLabel: "Generate audio for this variant",
    phraseOverrideAudioGenerated: "Audio generated",
    phraseOverrideAudioGenError: "Audio generation error",
    phraseOverrideDoneBtn: "Done",
  },
  legal: {
    docTerms: "Terms of Service",
    docPrivacy: "Privacy policy",
    docLegalNotice: "Legal notice",
    docCookies: "Cookie policy",
    loading: "Loading…",
    overline: "Compliance",
    title: "GDPR & legal notices",
    subtitle: "Documents auto-generated from your establishment's information.",
    medicalBadge: "Medical vertical · {years} years",
    tabDocs: "Documents",
    tabRights: "Client rights",
    editRestricted: "Editing reserved to the platform Super Admin. Contact support to adapt these texts to your specific case.",
    viewPublic: "View public version →",
    exportTitle: "Data export (Art. 15)",
    exportDesc: "Download all data held on a client (bookings, orders, conversations). JSON format, timestamped and audited.",
    exportBtn: "Export a client's data",
    forgetTitle: "Right to be forgotten (Art. 17)",
    forgetDesc: "Anonymizes the client and all their traces (bookings, orders, conversations). Records remain for accounting purposes, but identifying data is replaced with an irreversible pseudonym.",
    forgetBtn: "Anonymize a client",
    errNoContact: "Enter at least an email or a phone number",
    errConfirm: "Confirm the irreversibility of this operation",
    exportModalTitle: "Export a client's data",
    exportModalDesc: "Enter the client's email or phone number. The JSON file will be downloaded.",
    emailLabel: "Email",
    phoneLabel: "Phone",
    exportDone: "Export complete",
    exportSummary: "{bookings} bookings · {orders} orders · {conversations} conversations",
    close: "Close",
    download: "Download",
    exportSuccessToast: "Export generated and downloaded",
    forgetModalTitle: "Anonymizing a client",
    forgetModalDescPre: "Operation ",
    forgetModalDescBold: "irreversible",
    forgetModalDescPost: ". Identifiers will be replaced with a cryptographic pseudonym. Accounting records remain.",
    forgetWarning: "Once executed, the operation is logged in the audit trail and cannot be undone.",
    forgetConfirmLabel: "I confirm I have received a valid GDPR request",
    forgetDone: "Anonymization complete",
    pseudoLabel: "Pseudonym",
    bookingsLabel: "Bookings",
    ordersLabel: "Orders",
    conversationsLabel: "Conversations",
    anonymize: "Anonymize",
    forgetSuccessToast: "Anonymization completed",
  },
  orderDetail: {
    statusPendingPayment: "Awaiting payment",
    statusConfirmed: "To prepare",
    statusInPrep: "In preparation",
    statusReady: "Ready",
    statusCompleted: "Delivered / Handed over",
    statusCancelled: "Cancelled",
    statusRefunded: "Refunded",
    typePickup: "Pickup",
    typeDelivery: "Delivery",
    typeDineIn: "Dine in",
    channelAi: "🤖 Phone AI",
    channelWidget: "🌐 Website",
    channelManual: "✋ Manual",
    nextStartPrep: "Start preparation",
    nextMarkReady: "Mark ready",
    nextMarkDelivered: "Mark delivered",
    back: "Back to orders",
    tableLabel: " · Table {number}",
    printTicket: "PDF receipt",
    smsClient: "SMS client",
    smsNotify: "Notify client (SMS)",
    smsTitle: "SMS to {phone}",
    cancelBtn: "Cancel",
    refundBtn: "Refund",
    customerOverline: "Client",
    nameLabel: "Name",
    phoneLabel: "Phone",
    emailLabel: "Email",
    pickupTimeLabel: "Requested time",
    addressLabel: "Delivery address",
    customerNotes: "Client notes",
    itemsOverline: "Items",
    totalLabel: "Total",
    costLabel: "Materials cost (BOM)",
    profitLabel: "Gross margin",
    prepTimeLabel: "Estimated prep time",
    paymentStatusLabel: "Payment status",
    paidLabel: "✓ Paid",
    pendingLabel: "Pending",
    convoOverline: "Linked AI conversation",
    convoChannelLabel: "Channel",
    convoPhoneWord: "Phone",
    convoNumberLabel: "Number",
    convoStartedLabel: "Started",
    openInbox: "Open in Inbox",
    noExchange: "No exchange recorded",
    guardrailTriggered: "guardrail triggered",
    timelineOverline: "Timeline",
    noEvents: "No events.",
    idLabel: "ID",
    loading: "Loading…",
    notFound: "Order not found.",
    statusUpdatedToast: "Status updated: {status}",
    smsSentToast: "Notification SMS sent",
    smsFailedToast: "Status updated, but the SMS could not be sent",
    orderCancelledToast: "Order cancelled",
    smsMockedToast: "SMS saved (mock mode — Twilio trial)",
    smsSentToClientToast: "SMS sent to {to}",
    cancelDialogTitle: "Cancel this order?",
    cancelDialogItem: "The client will not be notified automatically — call them if needed.",
    cancelConfirmLabel: "Cancel the order",
    orderRefundedToast: "Order refunded",
    refundDialogTitle: "Refund this order?",
    refundDialogItem: "Confirm the refund has already been issued to the client (outside the system) before validating here — this action updates accounting.",
    refundConfirmLabel: "Refund the order",
  },
  billing: {
    periodDay: "Day",
    periodWeek: "Week",
    periodMonth: "Month",
    title: "Billing",
    subtitle: "Live usage, active modules, seats, and a per-second detailed invoice. No subscription, no tier — you pay for what you use.",
    exportPdf: "Export PDF",
    statVoice: "AI voice",
    statOrders: "AI orders",
    statOrdersSub: "taken by the assistant",
    statConversations: "Conversations",
    statConversationsSub: "all channels",
    statSms: "SMS sent",
    statSmsSub: "including payment links",
    callWord: "call",
    stackBreakdownTitle: "Breakdown by voice stack",
    invoiceTitle: "Detailed invoice · {period}",
    totalLabel: "Total",
    modulesTitle: "Active modules ({n})",
    modulesSubtotal: "Modules subtotal",
    seatsTitle: "User seats ({n})",
    perPerson: "/ person",
    seatsSubtotal: "Seats subtotal",
    voiceCallsTitle: "AI calls ({n})",
    noCallsPeriod: "No calls for this period.",
    perMinuteCts: "cts/min",
    voiceSubtotal: "Voice subtotal",
    whatsappTitle: "WhatsApp ({n} messages)",
    whatsappSent: "Sent",
    whatsappReceived: "Received",
    whatsappIncluded: "Included in plan",
    whatsappOverage: "Overage ({n} x {price})",
    whatsappSubtotal: "WhatsApp subtotal",
    whatsappNoCostDetail: "Overage cost is only computed on the monthly invoice.",
    phoneNumberNote: "Phone number",
    totalToPay: "Total due",
    alertsTitle: "Usage alerts",
    enabled: "Enabled",
    disabled: "Disabled",
    alertsDesc: "Get an email (and/or a Slack ping) as soon as your voice usage exceeds a threshold for the day, week, or month. One alert per period and per threshold — no more.",
    thresholdDay: "Day threshold (cts)",
    thresholdWeek: "Week threshold (cts)",
    thresholdMonth: "Month threshold (cts)",
    thresholdPlaceholder: "e.g. 1000 (= €10)",
    emailsLabel: "Emails to notify (1 per line)",
    emailsPlaceholder: "billing@my-restaurant.com",
    slackLabel: "Slack webhook (optional)",
    save: "Save",
    lastAlertsTitle: "Latest alerts fired",
    thresholdWord: "threshold",
    savedToast: "Usage alerts saved",
  },
  notifications: {
    overline: "Notifications",
    title: "Notification center",
    subtitle: "90-day history · {count} entries loaded · {unread} unread",
    markAllRead: "Mark all read",
    catAll: "All",
    catBooking: "Bookings",
    catOrder: "Orders",
    catCall: "Calls",
    catLead: "Leads",
    catBilling: "Billing",
    catTeam: "Team",
    catSystem: "System",
    catChurn: "Churn",
    catGdpr: "GDPR",
    searchPlaceholder: "Search…",
    includeRead: "Include read",
    emptyMessage: "No matching notifications.",
    openLink: "Open →",
    today: "Today",
    yesterday: "Yesterday",
    secondsAgo: "{n}s ago",
    minutesAgo: "{n} min ago",
    hoursAgo: "{n} h ago",
    daysAgo: "{n} d ago",
  },
  accounting: {
    overline: "Accounting M5",
    title: "Revenue & Profit",
    subtitle: "Month-by-month history. Revenue — materials cost — gross profit — margin.",
    modeToday: "1 day",
    modeWeek: "7 days",
    mode30Days: "30 days",
    modeByMonth: "By month",
    monthLabel: "Month",
    exportCsv: "Export CSV",
    kpiGross: "Revenue (incl. tax)",
    kpiCost: "Materials cost",
    kpiProfit: "Gross profit",
    kpiMargin: "Gross margin",
    chartTitle: "Revenue this month — by day",
    chartCa: "Revenue",
    chartProfit: "Profit",
    loading: "Loading…",
    noData: "No data",
    colDate: "Date",
    colGross: "Revenue (incl. tax)",
    colCost: "Materials cost",
    colProfit: "Profit",
    colOrders: "Orders",
    colStatus: "Status",
    closedBadge: "Closed",
    liveBadge: "Live",
    dailyPdfTitle: "Daily revenue (PDF)",
    closeBtn: "Close",
    closeDayToast: "Day {date} closed",
    closeDialogTitle: "Permanently close the day {date}?",
    closeDialogItem: "This day's figures are locked for accounting — no order can modify them afterward.",
    closeConfirmLabel: "Close",
    monthNames: [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December",
    ],
  },
  callbacks: {
    reasonOffTopic: "Off-topic (3+)",
    reasonOutOfTime: "Time limit exceeded",
    reasonMaxTurns: "Too many turns",
    reasonManual: "Manual",
    overline: "Module M2 · AI guardrails",
    title: "Callbacks to make",
    subtitle: "Conversations closed by the AI (off-topic, time exceeded, too many turns) automatically generate a callback ticket. Your team handles them here.",
    refresh: "Refresh",
    statPending: "To call back",
    statDone: "Called back",
    statTotal: "Total visible",
    filterPending: "To call back",
    filterDone: "Called back",
    filterDismissed: "Dismissed",
    filterAll: "All",
    empty: "No callbacks to display.",
    unknownNumber: "unknown number",
    viewConversation: "View conversation",
    markDone: "Called back",
    dismiss: "Dismiss",
    loadError: "Loading error",
    genericError: "Error",
    markedDoneToast: "Marked as called back",
    dismissedToast: "Request dismissed",
    updatedToast: "Updated",
  },
  analytics: {
    range7d: "7 days",
    range30d: "30 days",
    range90d: "90 days",
    range365d: "1 year",
    loading: "Loading…",
    overline: "Analytics",
    title: "Dashboard",
    periodLabel: "Period: {start} → {end}",
    revenueHeadlineLabel: "Order revenue generated",
    tabBusiness: "Business",
    tabOps: "Operations",
    businessOverline: "Business",
    kpiBookings: "Bookings",
    kpiBookingsSub: "{n} confirmed",
    kpiOrders: "Orders",
    kpiOrdersSub: "{amount} revenue",
    kpiAvgTicket: "Average ticket",
    kpiAvgTicketSub: "per order",
    kpiCovers: "Covers",
    kpiCoversSub: "guests seated",
    kpiConversion: "Widget conversion",
    kpiConversionSub: "{n} lead(s)",
    dailyActivity: "Daily activity · {range}",
    legendBookings: "Bookings",
    legendOrders: "Orders",
    legendRevenue: "Order revenue",
    bookingsHealth: "Booking health",
    noShowRate: "No-show rate",
    cancelRate: "Cancellation rate",
    confirmRate: "Confirmation rate",
    topServices: "Top services / slots",
    noBookingsPeriod: "No bookings for this period.",
    opsOverline: "Operations",
    kpiConvos: "AI conversations",
    kpiConvosSub: "{n}% resolved",
    kpiAvgDuration: "Avg. call duration",
    kpiAvgDurationSub: "per conversation",
    kpiVoiceMin: "Voice minutes",
    kpiVoiceMinSub: "cumulated over period",
    kpiSms: "SMS sent",
    kpiSmsSub: "reminders & confirmations",
  },
  helpForwarding: {
    overline: "Telephony M2",
    title: "Redirect your landline to the AI",
    subtitlePre: "For your customers to be handled by your AI, set up ",
    subtitleBold: "call forwarding on the restaurant's landline",
    subtitlePost: " (not a mobile) to the number below. Follow the 3 steps.",
    twilioNumberOverline: "Number to enter as the forwarding destination",
    copy: "Copy",
    numberCopiedToast: "Number copied",
    codeCopiedToast: "Copied",
    noTwilioNumber: "No number provisioned. Contact your Super Admin.",
    step1Title: "Step 1 — Who's your landline carrier?",
    step1Hint: "The one for the restaurant's box or phone line — not necessarily the same as your personal mobile.",
    operatorOtherLabel: "Other carrier",
    operatorOtherHint: "Contact your carrier's support and ask for \"unconditional / always-on call forwarding\" to the number above — the exact method varies by carrier.",
    step2Title: "Step 2 — Set up the forwarding",
    step2Hint: "Most reliable method: {name}'s online customer area. Paste the number shown at the top of this page as the destination.",
    openSpaceBtn: "Open {name} customer area",
    step3Title: "Other method (optional): dial a code",
    step3Hint: "Some carriers also let you turn on forwarding directly from the restaurant's phone. This can vary by box — if it doesn't work, use the customer area from step 2.",
    codeCancelLabel: "To cancel:",
    codeUnavailable: "{name} doesn't offer this shortcut for a landline/box — use the customer area in step 2.",
    step4Title: "Step 3 — Check that it works",
    step4Desc: "From another phone (your mobile, say), call the restaurant's number. If forwarding is set up correctly, your AI should answer.",
    warningTitle: "Good to know",
    warnItem1: "\"Unconditional / always-on\" forwarding sends every call to the AI without ever ringing the restaurant's phone — the simplest setup to start with.",
    warnItem2: "If you'd rather have the restaurant's phone ring first and only have the AI step in when there's no answer, that option (with an adjustable delay) is usually available in the same customer area, in step 2.",
    warnItem3: "Forwarding to a foreign number may be billed by your carrier — if the number above isn't a French number, ask your Super Admin for one.",
    warnItem4: "Remember to turn off forwarding if you change carrier or line, or you'll stop receiving calls entirely.",
  },
  whatsapp: {
    justNow: "just now",
    minAgo: "{n} min",
    hAgo: "{n} h",
    loadingInbox: "Loading WhatsApp inbox…",
    moduleTitle: "WhatsApp Business",
    moduleDisabledTitle: "Module disabled",
    moduleDisabledPre: "Enable the ",
    moduleDisabledBold: "M10 WhatsApp Business",
    moduleDisabledMid: " module from the ",
    moduleDisabledLink: "Modules & Voice",
    moduleDisabledPost: " page to run your WhatsApp inbox with the AI.",
    headerOverline: "WhatsApp Business · M10",
    headerTitle: "WhatsApp inbox",
    headerSubtitle: "Your AI automatically replies to WhatsApp messages. Take over whenever you want via the field below.",
    usageOverline: "WhatsApp messages · {month}",
    tabInbox: "Inbox",
    tabSettings: "Settings",
    conversationsTitle: "Conversations ({n})",
    noConversations: "No conversations yet.",
    directionIn: "Incoming",
    directionOut: "AI / Agent",
    humanRequested: "Human requested",
    aiPaused: "AI paused",
    selectConversation: "Select a conversation to view it.",
    loading: "Loading…",
    startedAt: "Started {time}",
    aiActive: "AI active",
    reactivateAi: "Reactivate AI",
    takeOver: "Take over",
    escalatedToHuman: "Escalated to human",
    aiPausedEvent: "AI paused",
    aiReactivatedEvent: "AI reactivated",
    voiceLabel: "🎤 Voice:",
    replyPlaceholderPaused: "You're handling this thread — send your reply to the client…",
    replyPlaceholderActive: "The AI is handling this thread. Send a manual message to intervene once (the AI resumes next turn).",
    send: "Send",
    sandboxOverline: "Twilio Sandbox mode",
    sandboxTitle: "Test without Meta approval",
    sandboxDescPre: "Shared number ",
    sandboxDescMid: ". The client first sends ",
    sandboxDescPost: " to sign up.",
    sandboxCodeLabel: "Sandbox code",
    sandboxCodePlaceholder: "e.g. join orange-pizza",
    greetingLabel: "AI greeting message",
    metaOverline: "Production — Meta-approved number",
    metaTitle: "Activate your own WhatsApp Business number",
    metaDescPre: "Once approved by Meta (2-3 weeks), your business number sends messages under your establishment's name. Current Twilio status: ",
    metaApproved: "✓ Meta approved",
    metaRejected: "✗ Rejected",
    metaPending: "⏳ Meta review in progress",
    metaNotStarted: "Not started",
    metaUpdated: "Updated {time}",
    resubmit: "Resubmit",
    startOnboarding: "Start Meta onboarding",
    refreshStatus: "Refresh status",
    otpPlaceholder: "OTP code received",
    validateOtp: "Validate OTP",
    testersOverline: "Enrolled numbers (sandbox)",
    testersDesc: "Whitelist of testers allowed to chat with your AI via the shared Twilio number. One number per line, E.164 format.",
    toastMessageSent: "Message sent",
    toastAiPaused: "AI paused — you're now in control",
    toastAiReactivated: "AI reactivated",
    toastSettingsSaved: "Settings saved",
    toastMetaRequestSent: "Request sent to Meta via Twilio. Status visible below.",
    toastTwilioStatus: "Twilio status: {status}",
    toastOtpSent: "OTP sent · status: {status}",
    dialogTitle: "Submit your number to Meta",
    dialogDesc: "Twilio will send this information to Meta. Review usually takes 2-3 weeks. You can track the status from this page.",
    fieldSenderId: "WhatsApp number (E.164) *",
    fieldSenderIdHintPre: "International format, e.g. ",
    fieldSenderIdHintPost: ". Twilio will automatically prefix with ",
    fieldWabaId: "WABA ID *",
    fieldWabaIdHint: "WhatsApp Business Account ID — found in Meta Business Manager → Accounts → WhatsApp.",
    fieldDisplayName: "Display name *",
    fieldDisplayNameHint: "Must follow Meta guidelines (no emojis, no third-party brand mentions).",
    fieldCategory: "Category",
    fieldAbout: "About (WhatsApp status)",
    fieldAboutPlaceholder: "Bookings & orders via WhatsApp",
    fieldDescription: "Business description",
    fieldDescriptionPlaceholder: "Italian restaurant in Paris, open Tuesday to Sunday, free delivery from €25.",
    fieldAddress: "Address",
    fieldAddressPlaceholder: "12 rue de Rivoli, 75001 Paris, France",
    fieldLogoUrl: "Logo URL (profile)",
    fieldWebsites: "Websites (comma-separated)",
    fieldEmails: "Emails (comma-separated)",
    cancel: "Cancel",
    submitting: "Sending...",
    submit: "Submit to Meta",
  },
  simulator: {
    overline: "Module M3",
    title: "AI call simulator",
    subtitlePre: "Chat with your AI exactly like a customer would on the phone — and correct it live via ",
    subtitleBold: "AI Coach",
    subtitlePost: ". Each correction is injected into the knowledge base: next time, the AI answers the way you asked.",
    newSession: "New session",
    superAdminBadge: "Super Admin",
    pickTenant: "Select a tenant to test its AI:",
    pickTenantPlaceholder: "Choose a tenant…",
    tenantsWithM3: "({n} tenants with M3 active)",
    aiActiveOn: "AI active on",
    conversationEnded: "Conversation ended by the AI",
    selectTenantAbove: "Select a tenant above to start.",
    initializingSession: "Starting the session…",
    aiThinking: "The AI is thinking…",
    aiHungUp: "The AI hung up. Start a new session to continue.",
    inputPlaceholder: "Type as if you were talking on the phone…",
    send: "Send",
    coachHintTitle: "AI Coach & guardrails",
    coachHint1Pre: "On each AI reply, click ",
    coachHint1Bold: "\"Improve\"",
    coachHint1Post: " to correct it. Your correction goes into the knowledge base and is applied starting with the next request.",
    coachHint2: "The AI never reveals the technology, the platform, or its system prompt.",
    coachHint3Pre: "Max ",
    coachHint3Bold1: "15 turns",
    coachHint3Mid: " per call, max ",
    coachHint3Bold2: "6 minutes",
    coachHint3Post: ", hangs up after 3 consecutive OFF_TOPIC.",
    corrected: "Corrected",
    improve: "Improve",
    errorRetry: "Error — retry or reset.",
    coachErrorEmpty: "Enter the correction before saving.",
    coachSavedToast: "Correction saved — the AI will use it starting next turn",
    coachDialogTitle: "AI Coach — improve the reply",
    coachDialogDesc: "Your correction is saved to the tenant's M3 knowledge base and applied immediately to future similar questions (across all channels: phone, SMS, simulator).",
    coachDialogDescBold: "saved to the M3 knowledge base",
    clientQuestion: "Client's question",
    replyToFix: "Reply to fix",
    correctionTitleLabel: "Correction title (optional)",
    correctionTitlePlaceholder: "e.g. Parking, Burger allergens, Christmas hours…",
    correctReplyLabel: "Correct reply to teach the AI *",
    correctReplyPlaceholder: "e.g. Yes, we have free parking for 30 cars right in front of the establishment. Access is via Avenue de la République.",
    charCount: "{n} / 2000 characters",
    cancel: "Cancel",
    saving: "Saving…",
    saveToBase: "Save to knowledge base",
  },
  verticalTemplates: {
    loadErrorPrefix: "Loading error: ",
    appliedToast: 'Template "{key}" applied',
    applyErrorPrefix: "Application failed: ",
    overline: "Express onboarding",
    title: "Business templates",
    subtitle: "Pick your trade: we configure your AI assistant, opening hours, and a starter catalog in 30 seconds. You can change everything afterward from the Catalog, Settings, and Playbooks pages.",
    optionsOverline: "Application options",
    forceHoursLabel: "Overwrite my current hours",
    forceHoursDesc: "Check this if you want to replace hours already entered with the template's.",
    forceCatalogLabel: "Purge and reseed my catalog",
    forceCatalogDesc: "Deletes all current categories and products before inserting the template's.",
    loadingTemplates: "Loading templates…",
    close: "Close",
    applyThisTemplate: "Apply this template",
    confirmApplyTitle: "Confirm application",
    confirmApplyDescPre: "You're about to apply the template ",
    confirmItem1Bold: "AI vertical",
    confirmItem1Rest: " will be updated (impacts the assistant's replies).",
    confirmItem2Bold: "hours",
    confirmItem2Overwrite: "will be OVERWRITTEN by the template's",
    confirmItem2Seed: "will only be seeded if empty today",
    confirmItem3Bold: "catalog",
    confirmItem3Purge: "will be PURGED then reseeded",
    confirmItem3Seed: "will only be seeded if empty today",
    cancel: "Cancel",
    applyNow: "Apply now",
    statusCurrentVertical: "Current vertical:",
    templateWord: "template",
    catalogStats: "{cat} categorie(s), {items} product(s)",
    emptyCatalog: "empty catalog",
    hoursDefined: "hours defined",
    hoursNotDefined: "hours not defined",
    noTemplateApplied: "No template applied yet.",
    noTemplateAppliedRest: " Select yours below — you'll save ~2h of setup.",
    m5InactiveWarning: "⚠ M5 module (Catalog) inactive: only the vertical and hours will be applied.",
    resultTitle: 'Template "{name}" applied successfully',
    appliedLabel: "Applied",
    skippedLabel: "Skipped",
    currentBadge: "Current",
    catShort: "cat.",
    productsWord: "products",
    openDaysShort: "d/7 open",
    preview: "Preview",
    apply: "Apply",
    personaOverline: "AI persona",
    hoursOverline: "Hours",
    closedLabel: "Closed",
    catalogOverline: "Catalog ({n} products)",
    notificationsOverline: "Recommended notifications",
    destructiveWarning: "⚠ Destructive action. Your current data will be erased.",
    dayMon: "Mon",
    dayTue: "Tue",
    dayWed: "Wed",
    dayThu: "Thu",
    dayFri: "Fri",
    daySat: "Sat",
    daySun: "Sun",
  },
  playbook: {
    triggerGreeting: "On call greeting",
    triggerItemAdded: "After an item is added to cart",
    triggerBookingRequest: "On a booking request",
    triggerBeforeConfirm: "Before final confirmation",
    triggerConfirm: "On explicit confirmation",
    triggerObjection: "If the client objects",
    triggerGoodbye: "On sign-off",
    loading: "Loading playbook…",
    unavailable: "Playbook unavailable.",
    overline: "AI configuration",
    title: "Agent playbook",
    subtitle: "Layer 2 of the Dual-Level AI system: customize your agent's behavior on top of the Vertical Persona. Disable steps you don't want, add your own greeting or follow-up rules.",
    cancelChanges: "Discard changes",
    save: "Save",
    saving: "Saving…",
    personaTitle: "AI Persona — vertical",
    personaDesc: "Base behavior inherited from your industry (read-only).",
    verticalStepsTitle: "Vertical steps ({n})",
    verticalStepsDesc: "Disable steps that don't apply to your establishment.",
    noVerticalSteps: "No steps configured by default for your vertical.",
    disabledBadge: "disabled",
    reactivate: "Reactivate",
    disable: "Disable",
    customStepsTitle: "Custom steps ({n})",
    customStepsDesc: "Add your own greeting, upsell, objection rules…",
    addStep: "Add a step",
    noCustomSteps: 'No custom steps. Click "Add a step" to create a script specific to your establishment.',
    customBadge: "Custom",
    delete: "Delete",
    titleLabel: "Title",
    triggerLabel: "Trigger",
    instructionLabel: "Instruction given to the agent",
    instructionPlaceholder: 'e.g. "Always ask for the client\'s first and last name before finalizing the order."',
    effectivePreviewTitle: "Effective preview ({n})",
    effectivePreviewDesc: "What the AI will receive after applying your changes.",
    effectiveNote: 'Note: this preview is frozen. Click "Save" then reopen the page to refresh the preview after your changes.',
    resetDialogTitle: "Discard all your changes?",
    resetItem1: "All vertical steps will be reactivated.",
    resetItem2: "Your custom steps will be deleted.",
    resetConfirmLabel: "Reset",
    newStepDefaultLabel: "New step",
    tooShortToast: "Custom step #{n}: the instruction must be at least 10 characters.",
    savedToast: "Playbook saved — the AI immediately follows your rules",
  },
  setupWizard: {
    overline: "Setup",
    titlePrefix: "Publish ",
    subtitle: "Everything can be changed later from Settings.",
    navIdentity: "Identity",
    navHours: "Hours",
    navTelephony: "Telephony",
    navCatalog: "Catalog",
    navTeam: "Team",
    navPublication: "Publication",
    optionalTag: "optional",
    hoursSavedToast: "Hours saved",
    identitySavedToast: "Identity saved",
    invalidEmailToast: "Invalid email",
    inviteSentToast: "Invitation sent to {email}",
    publishedToast: "Business published",
    planToastPre: 'You had selected the "',
    planToastPost: '" plan — head to Billing to finalize your subscription.',
    billingAction: "Billing",
    readyToPublish: "Everything is ready to publish.",
    missingStepsText: "{n} required step{plural} remaining: {list}",
    updateBtn: "Update",
    publishBtn: "Publish my business",
    identityTitle: "Identity & contact details",
    identitySubtitle: "Used on your public page and in automatic SMS sent to your customers.",
    addressLabel: "Postal address",
    addressPlaceholder: "12 Pizza Street, 75011 Paris",
    phoneLabel: "Business phone (forwarded to the AI)",
    phonePlaceholder: "+33 1 23 45 67 89",
    logoLabel: "Logo URL (optional)",
    save: "Save",
    hoursTitle: "Opening hours",
    hoursSubtitle: "The AI declines appointments outside these hours and adapts its answers.",
    presetOffice: "Office · Mon-Fri 9am-6pm",
    presetRestaurant: "Restaurant · Tue-Sun 11:30am-10:30pm",
    preset247: "Open 24/7",
    dayMonday: "Monday",
    dayTuesday: "Tuesday",
    dayWednesday: "Wednesday",
    dayThursday: "Thursday",
    dayFriday: "Friday",
    daySaturday: "Saturday",
    daySunday: "Sunday",
    telephonyTitle: "Telephony & call forwarding",
    telephonySubtitle: "The AI takes calls when you don't answer (away, busy line, holidays). You keep your business number.",
    m2InactivePre: "The ",
    m2InactiveBold: "M2 — AI Telephony",
    m2InactivePost: " module is not activated.",
    activateM2: "Activate M2",
    forwardingDone: "Call forwarding is already set up.",
    forwardingCtaDesc: "Our assistant guides you through 5 steps to enter the right GSM code with your carrier (Orange, SFR, Free, Bouygues…). Reversible via ",
    launchForwarding: "Launch the forwarding assistant",
    catalogTitle: "Catalog",
    catalogSubtitle: "Without any item or service, the voice assistant has nothing to offer on the phone — this is the most important requirement before publishing.",
    catalogDone: "Your catalog already contains at least one item.",
    catalogEmpty: "No items or services yet.",
    startFromTemplate: "Start from a template",
    manageCatalog: "Manage my catalog",
    addManually: "Add an item manually",
    teamTitle: "Team",
    teamSubtitle: "Optional — you can invite a teammate now or later from the Team tab.",
    invitePlaceholder: "manager@yourcompany.com",
    invite: "Invite",
    defaultRole: "Default role: MANAGER.",
    publicationTitle: "Publication",
    publicationSubtitle: "Summary of what's required before publishing your business.",
    toComplete: "to complete",
    missingPre: "Missing: ",
  },
  bookings: {
    overline: "Bookings",
    title: "Bookings calendar",
    subtitle: "Drag and drop to move a booking. Click an open slot to create one.",
    syncCalendars: "Sync calendars",
    syncSuccessToast: "Google: {n} slots imported",
    googleNotConnectedToast: "Google Calendar not connected — go to Settings to connect it",
    syncErrorToast: "Google sync: {msg}",
    kioskMode: "Kiosk mode",
    newBooking: "New booking",
    kpiTotal: "Total",
    kpiPending: "Pending",
    kpiConfirmed: "Confirmed",
    kpiCancelled: "Cancelled",
    kpiNoShow: "No-show",
    filterResource: "Resource",
    allResources: "All resources",
    filterStatus: "Status",
    allStatuses: "All statuses",
    statusPending: "Pending",
    statusConfirmed: "Confirmed",
    statusCancelled: "Cancelled",
    statusNoShow: "No-show",
    statusCompleted: "Completed",
    filterSource: "Source",
    allSources: "All sources",
    sourceAi: "🤖 Via AI",
    sourceHuman: "Human / Manual",
    calToday: "Today",
    calMonth: "Month",
    calWeek: "Week",
    calDay: "Day",
    calList: "List",
    dialogTitleEdit: "Booking details",
    dialogTitleNew: "New booking",
    noResourcesHint: "No resources. Create one on the Resources page.",
    emptyTitle: "No bookings yet",
    emptyDescription: "Click a slot on the calendar or use \"New booking\" to create the first one.",
    emptyAction: "New booking",
    serviceLabel: "Service (optional)",
    serviceNone: "— None —",
    clientNameLabel: "Client full name",
    firstNameLabel: "First name (optional)",
    lastNameLabel: "Last name (optional)",
    birthDateLabel: "Date of birth",
    emailLabel: "Email",
    phoneLabel: "Phone",
    startLabel: "Start",
    endLabel: "End (optional)",
    partyLabel: "Party size",
    notesLabel: "Notes",
    confirmBtn: "Confirm",
    cancelBtn: "Cancel",
    saveBtn: "Save",
    updatedToast: "Booking updated",
    createdToast: "Booking created",
    cancelledToast: "Booking cancelled",
    confirmedToast: "Booking confirmed",
    movedToast: "Booking moved",
    resizedToast: "Booking resized",
    cancelDialogTitle: "Cancel this booking?",
    cancelDialogItem: "The client won't be notified automatically — call them if needed.",
    cancelDialogConfirm: "Cancel booking",
    resourceDoctor: "Doctor",
    resourceDoctorPlaceholder: "Select a practitioner…",
    resourceHotel: "Room",
    resourceHotelPlaceholder: "Select a room…",
    resourceHairdresser: "Stylist",
    resourceHairdresserPlaceholder: "Select a stylist…",
    resourceBeauty: "Beautician",
    resourceBeautyPlaceholder: "Select…",
    resourceDefault: "Resource",
    resourceDefaultPlaceholder: "Select…",
  },
  team: {
    nameRequired: "Name is required.",
    emailRequired: "Email is required.",
    emailInvalid: "Invalid email address.",
    passwordRequired: "Password required (minimum 8 characters) if you're not sending an email invitation.",
    fixErrorsToast: "Fix the fields in red before saving.",
    inviteSentToast: "Invitation sent by email",
    memberAddedToast: "Member added",
    memberRemovedToast: "Member removed",
    membersRemovedToast: "{n} member(s) removed",
    resendConfirm: "Resend the invitation to {email}?",
    resendSuccessToast: "Invitation resent by email",
    seatCostTitle: "Seat cost",
    seatCostSubtitle: "{n} active member(s) — estimated monthly billing",
    perMonth: "/mo",
    selectedCount: "{n} member(s) selected",
    clearSelection: "Cancel",
    deleteSelection: "Delete selection",
    roleLabel: "Role",
    roleHint: "Determines permissions AND seat cost (see pricing below).",
    emailHint: "The invitation (or credentials) will be sent to this address.",
    sendInviteLabel: "Send an email invitation (recommended)",
    selectAllAria: "Select all",
    selectRowAria: "Select {name}",
    resendInviteTitle: "Resend invitation",
    noMembers: "No members",
    emptyTitle: "No team members yet",
    emptyDescription: "Invite a teammate to give them dashboard access.",
    removeTitle: "Remove this member?",
    removeItem1: "They will immediately lose access to the dashboard.",
    removeItem2: "Their action history (audit log) is kept.",
    removeConfirmLabel: "Remove",
    bulkRemoveTitle: "Remove {n} member(s)?",
    bulkRemoveItem1: "Each selected member immediately loses access to the dashboard.",
    bulkRemoveItem2: "Their action history (audit log) is kept.",
  },
  settings: {
    dayMonday: "Monday", dayTuesday: "Tuesday", dayWednesday: "Wednesday",
    dayThursday: "Thursday", dayFriday: "Friday", daySaturday: "Saturday", daySunday: "Sunday",
    businessNameRequired: "The business name is required.",
    emailInvalid: "Invalid email address.",
    fixErrorsToast: "Fix the fields in red before saving.",
    savedToast: "Settings saved",
    readOnlyTitle: "Read-only — you don't have the settings.update / tenant.update permission",
    saveAllTitle: "Saves all sections at once",
    readOnlyBannerTitle: "Read-only mode",
    readOnlyBannerBodyPre: "You can view the settings but not edit them. Ask your OWNER to enable the ",
    readOnlyBannerBodyPost: " permission on your role.",
    groupGeneral: "General information",
    groupTelephonyAi: "Phone & AI",
    groupBookings: "Bookings",
    draftSaveBadge: "Needs Save",
    brandingTitle: "Branding",
    brandingSubtitle: "Logo shown on your public page and emails. PNG, JPG, WEBP or SVG, max 2 MB.",
    noLogo: "No logo",
    uploadingLogo: "Uploading…",
    replaceLogo: "Replace logo",
    uploadLogoBtn: "Upload a logo",
    remove: "Remove",
    identityTitle: "Identity",
    businessNameHint: "Shown on your public page, confirmation emails, and used by the AI assistant on the phone.",
    contactEmailHint: "Receives account notifications (invoices, alerts). Not shown to customers.",
    countryFrance: "France",
    countryBelgium: "Belgium",
    countrySwitzerland: "Switzerland",
    countryLuxembourg: "Luxembourg",
    timezoneLabel: "Timezone",
    timezoneHint: "Used to compute your accounting days and reports (\"today\", day close) at the right local time.",
    timezoneParis: "Paris (Mainland France)",
    timezoneBrussels: "Brussels (Belgium)",
    timezoneZurich: "Zurich (Switzerland)",
    timezoneLuxembourg: "Luxembourg",
    timezoneReunion: "Réunion",
    timezoneGuadeloupe: "Guadeloupe",
    timezoneMartinique: "Martinique",
    addressLabel: "Address",
    addressHint: "Used on your public page and to locate your business for customers.",
    hoursTitle: "Opening hours",
    hoursSubtitle: "Used by the public page, the booking module, and the AI assistant.",
    closedLabel: "Closed",
    telephonyTitle: "Telephony & numbers",
    telephonySubtitle: "Twilio number, call forwarding, greeting message, and AI handling rules.",
    m3Title: "AI knowledge base",
    m3Subtitle: "FAQ, menu, services, and documents the AI uses to answer customers.",
    guardrailsTitle: "AI guardrails",
    guardrailsSubtitle: "Max call duration, off-topic handling, playbook steps.",
    paymentPolicyTitle: "Payment policy",
    paymentPolicySubtitle: "Mandatory deposit for new customers, pre-order validation, etc.",
    guardrailsDurationLabel: "Maximum call duration",
    guardrailsDurationHint: "Beyond this duration, the AI wraps up politely and creates a callback.",
    guardrailsDurationUnit: "seconds (30-900)",
    guardrailsSoftWarningLabel: "Warn the AI starting at",
    guardrailsSoftWarningUnit: "seconds (the AI is asked to wrap up)",
    guardrailsMaxTurnsLabel: "Max customer turns",
    guardrailsOffTopicLabel: "Off-topic detection",
    guardrailsOffTopicHint: "If the customer talks about topics unrelated to your business, the AI offers a callback from your team and hangs up.",
    guardrailsOffTopicEnable: "Enable detection",
    guardrailsToleranceLabel: "Tolerance (consecutive off-topic messages)",
    guardrailsAutoCallbackLabel: "Automatically create a callback",
    guardrailsAllowedTopicsLabel: "Additional allowed topics (one per line)",
    guardrailsAllowedTopicsPlaceholder: "E.g.: Gift cards\nPrivate event\nBirthday",
    guardrailsSaving: "Saving…",
    guardrailsSaveBtn: "Save guardrails",
    guardrailsSavedToast: "AI guardrails saved",
    guardrailsPlaybookOverlinePrefix: "Business playbook — vertical",
    guardrailsVerticalUndefined: "undefined",
    guardrailsPlaybookTitle: "AI dialogue steps",
    guardrailsPlaybookHint: "These steps are defined by your vertical. Disable the ones that don't apply to your business.",
    guardrailsSavePlaybookBtn: "Save playbook",
    guardrailsPlaybookSavedToast: "Playbook updated",
    paymentPolicyEnableLabel: "Enable payment before confirmation",
    paymentPolicyModeLabel: "Mode",
    paymentPolicyModeFull: "Full",
    paymentPolicyModeFullHint: "100% of the total",
    paymentPolicyModeDeposit: "Deposit",
    paymentPolicyModeDepositHint: "Configurable %",
    paymentPolicyDepositPctLabel: "Deposit percentage:",
    paymentPolicyChannelsLabel: "Link delivery channels",
    paymentPolicyChannelSms: "Twilio SMS",
    paymentPolicyChannelWhatsapp: "WhatsApp",
    paymentPolicyChannelActive: "active",
    paymentPolicyExpiryLabel: "Link expiry delay (min)",
    paymentPolicyExpiryHint: "Beyond this delay without payment, the order is automatically cancelled.",
    paymentPolicyStripeNotice: "Payments are processed by Stripe on the platform account. Payouts to your account follow the terms of your AI Commerce OS contract.",
    paymentPolicySaving: "Saving…",
    paymentPolicySaveBtn: "Save",
    paymentPolicySavedToast: "Payment policy saved",
    posIntegrationsTitle: "POS (checkout systems)",
    posIntegrationsSubtitle: "Connect your POS to automatically send it your orders.",
    posIntegrationsLoading: "Loading…",
    posIntegrationsEmpty: "No compatible POS yet.",
    posIntegrationsAvailableBadge: "Available",
    posIntegrationsComingSoonBadge: "Coming soon",
    posIntegrationsActiveBadge: "Active",
    posIntegrationsConfiguredBadge: "Configured",
    posIntegrationsCapabilityOrderPush: "Order push",
    posIntegrationsCapabilityPaymentPush: "Payment collection",
    posIntegrationsCapabilityCatalogSync: "Catalog sync",
    posIntegrationsCapabilityPullWebhook: "Order reception",
    posIntegrationsConfigureBtn: "Configure",
    posIntegrationsDeactivateBtn: "Deactivate",
    posIntegrationsCredentialsLabel: "API credentials",
    posIntegrationsCredentialsHint: "Provided by your POS — never shown again once saved.",
    posIntegrationsSaveBtn: "Save and activate",
    posIntegrationsSaving: "Saving…",
    posIntegrationsSavedToast: "Integration saved",
    posIntegrationsDeactivatedToast: "Integration deactivated",
    posIntegrationsCancelBtn: "Cancel",
    posIntegrationsUnavailableNotice: "This POS is on our roadmap but not yet implemented — contact us if you use it, to help us prioritize it.",
    bookingTitle: "Booking settings",
    bookingSubtitle: "Adapt booking behavior to your business (confirmation mode, lead times, deposit…).",
    confirmationModeLabel: "Confirmation mode",
    confirmationAuto: "Automatic (confirmed immediately)",
    confirmationManual: "Manual (pending validation)",
    confirmationHint: "AUTO: recommended for Restaurant / Hairdresser. MANUAL: recommended for Hotel / Doctor.",
    slotStepLabel: "Slot step (minutes)",
    minLeadLabel: "Minimum lead time before booking (minutes)",
    maxLeadLabel: "Maximum booking lead time (days)",
    cancelWindowLabel: "Cancellation window (hours)",
    autoAssignLabel: "Automatically assign a resource (Restaurant)",
    depositRequiredLabel: "Require a deposit at booking",
    depositPctLabel: "Deposit — % of total",
    depositEurLabel: "Deposit — fixed amount (€)",
    shareTitle: "Public sharing & QR code",
    shareSubtitle: "Print the QR code at your reception, put it in a window display, or add it to your materials. Customers scan it and land directly on your booking page.",
    testPage: "Test the page",
    unavailable: "Unavailable",
    qrAlt: "Booking QR code",
    publicLinkLabel: "Public booking link",
    shareHint: "Share this link on Google My Business, Instagram, your website, or by SMS.",
    downloadsLabel: "Downloads",
    downloadPngBtn: "QR PNG (HD)",
    downloadSvgBtn: "QR SVG (vector)",
    downloadPdfBtn: "A4 poster (PDF)",
    posterHint: "The A4 poster includes your name and a call to scan, ready to print for your reception.",
    ideasSummary: "Usage ideas",
    idea1: "Print the A4 poster and stick it in your window display or at the register.",
    idea2: "Add the QR code to your business cards, menus, or invoices.",
    idea3: "Post the QR code on Instagram / Facebook with a call to action.",
    idea4: "Add the link to your Google Business listing to boost bookings.",
    idea5: "Send the link by SMS to customers who call outside business hours.",
    icalTitle: "iCal sync",
    icalSubtitle: "Subscribe to this feed in Google Calendar, Outlook, or Apple Calendar to see your bookings read-only on your personal calendar.",
    icalUrlLabel: "iCal URL (read-only)",
    icalHint: "Keep this URL private — anyone with access to it will see your bookings. Regenerate the token to break existing subscriptions.",
    howToSubscribeSummary: "How to subscribe?",
    icalGoogleHeader: "Google Calendar",
    icalGoogleStep1: "Open Google Calendar → left sidebar → \"Other calendars\" → \"+\" → \"From URL\".",
    icalGoogleStep2: "Paste the URL above and click \"Add calendar\".",
    icalOutlookHeader: "Outlook",
    icalOutlookStep1: "Outlook web → Calendar → \"Add calendar\" → \"Subscribe from web\".",
    icalOutlookStep2: "Paste the URL and confirm.",
    icalAppleHeader: "Apple Calendar (iPhone/Mac)",
    icalAppleStep1: "iPhone: Settings → Calendar → Accounts → Add Account → Other → Add Subscribed Calendar. Paste the URL.",
    icalAppleStep2: "Mac: File → New Calendar Subscription. Paste the URL.",
    subsTitle: "External calendars to import",
    subsSubtitle: "Add as many iCal (.ics) URLs as you want (Doctolib, Outlook, Calendly, public Google calendar…). Auto sync every 5 min.",
    subResourceLabel: "Resource",
    subAllResources: "All resources",
    subLastSync: "Last sync",
    subSlotsSuffix: "slots",
    subNone: "No subscriptions yet. Add one below.",
    subNamePlaceholder: "Name (e.g. Doctolib Dr Smith)",
    subUrlPlaceholder: "iCal URL (.ics)",
    subSyncBtn: "Sync",
    subAddBtn: "Add",
    googleTitle: "Google Calendar",
    googleSubtitle: "Two-way sync: your bookings are pushed to Google Calendar and events on your Google calendar block slots in AI Commerce OS.",
    googleConnected: "Connected",
    googleNotConnected: "Not connected",
    googleAccountLabel: "Account",
    googleCalendarLabel: "Calendar",
    googleLastPullLabel: "Last pull (Google → ACOS)",
    googleEventsReadSuffix: "events read",
    googleLastPushLabel: "Last push (ACOS → Google)",
    googleLastPushErrorLabel: "Last push error",
    googleConnectBtn: "Connect",
    googlePullBtn: "Pull (busy → ACOS)",
    googlePushBtn: "Push (ACOS → Google)",
    googleDisconnectBtn: "Disconnect",
    googleNotConfiguredWarning: "Google Calendar integration is not configured server-side. Contact the administrator.",
    policyTitle: "Cancellation policy",
    policySubtitle: "Configure the thresholds that move a customer to the grey list (watch) or the black list (block). Matches first + last name + date of birth, falls back to email/phone.",
    policyEnableLabel: "Enable automatic grey/black list management",
    policyGreyThresholdLabel: "Grey list threshold (cancellations)",
    policyBlackThresholdLabel: "Black list threshold (cancellations)",
    policyLookbackLabel: "Calculation window (days)",
    policyLastMinWindowLabel: "\"Last minute\" window (hours before the appointment)",
    policyLastMinBlacklistLabel: "Last-minute cancellation = immediate blacklist",
    policyNoshowLabel: "No-show counts as a last-minute cancellation",
    subAddedToast: "Subscription added — syncing…",
    subSyncedToast: "Synced — {n} slots imported",
    subDeletedToast: "Subscription removed",
    qrDownloadStartedToast: "Download started",
    posterDownloadedToast: "A4 poster downloaded",
    linkCopiedToast: "Link copied to clipboard",
    copyFailedToast: "Couldn't copy",
    googleConnectedToast: "Google Calendar connected",
    googleErrorToastPrefix: "Google error: ",
    unknownError: "unknown error",
    googleDisconnectedToast: "Google Calendar disconnected",
    googleSyncDoneToast: "Sync complete — {n} slots imported",
    policySavedToast: "Cancellation policy saved",
    icalUrlCopiedToast: "URL copied to clipboard",
    icalRotatedToast: "iCal URL regenerated",
    bookingSettingsSavedToast: "Booking settings saved",
    logoUpdatedToast: "Logo updated",
    logoRemovedToast: "Logo removed",
    googleBackfillToast: "Push complete — {ok} OK, {failed} failed",
    deleteLogoTitle: "Remove the logo?",
    deleteLogoItem: "Your public page and confirmation emails will no longer show a logo.",
    deleteSubTitle: "Remove this subscription?",
    deleteSubItem: "Slots already imported from this external calendar will remain, but will no longer be synced.",
    disconnectGoogleTitle: "Disconnect Google Calendar?",
    disconnectGoogleItem1: "Events already imported from Google will be deleted from AI Commerce OS.",
    disconnectGoogleItem2: "Bookings will no longer be pushed to your Google calendar.",
    disconnectBtn: "Disconnect",
    rotateIcalTitle: "Regenerate the iCal URL?",
    rotateIcalItem: "All existing subscriptions pointing to the old URL (Google Calendar, Outlook, Apple Calendar…) will stop syncing — you'll need to recreate them with the new URL.",
    rotateBtn: "Regenerate",
  },
  modules: {
    activatedToast: "Module {key} activated",
    deactivatedToast: "Module {key} deactivated",
    modulesTitle: "Modules",
    activeSuffix: "active",
    included: "included",
    personaTitle: "AI Persona — vertical",
    personaSubtitle: "The agent's base behavior, inherited from your business sector.",
    voiceTitle: "AI assistant voice",
    voiceSubtitle: "Choose the voice stack. Billed per second at the platform rate — see Billing.",
    billingSummaryTitle: "Modules · €/mo",
    billingSummaryHint: "Fixed monthly cost of activated modules. User seats and voice usage (per second) are billed separately on the Billing page.",
    viewBillingLink: "View detailed billing",
  },
  publicPageEditor: {
    blockHero: "Hero banner",
    blockAbout: "About",
    blockServices: "Services",
    blockHours: "Opening hours",
    blockAvailability: "Next available slots",
    blockLocation: "Address",
    blockFaq: "Frequently asked questions",
    noPermissionToast: "You don't have permission to edit this page.",
    readOnlyTitle: "Read-only — you don't have permission to edit",
    pageTitle: "Public page",
    subtitlePre: "Everything you need to configure your public storefront ",
    subtitlePost: ": visual identity, marketing content, menu/services. Live preview on the right.",
    openBtn: "Open",
    saveAllBtn: "Save all",
    savingBtn: "Saving…",
    savedToast: "Public page saved",
    readOnlyBannerTitle: "Read-only mode",
    readOnlyBannerP1: "You can view the public page but not edit it. Ask your OWNER to enable the ",
    readOnlyBannerP2: " or ",
    readOnlyBannerP3: " permissions on your role.",
    brandingTitle: "Visual identity",
    brandingCaption: "Logo + accent color applied to the header, buttons, and prices on your storefront.",
    accentColorLabel: "Accent color",
    logoUrlLabel: "Logo URL",
    logoUrlHint: "To upload, use the Settings → Branding page.",
    taglineLabel: "Tagline",
    taglinePlaceholder: "E.g.: The taste of the Southwest since 1998",
    catalogTitle: "Our menu",
    catalogCaption: "The menu shown on your storefront is built automatically from your M5 catalog. Includes prices, photos, ingredients (BOM), and allergens.",
    statCategories: "Categories",
    statItems: "Items",
    statAvailable: "Available",
    statOutOfStock: "Out of stock",
    previewCategoriesLabel: "Categories preview",
    emptyCatalogWarning: "Your catalog is empty — the \"Our menu\" section won't show on the storefront until it contains at least one item.",
    manageCatalogBtn: "Manage menu",
    servicesTitle: "Your services / consultations",
    servicesCaption: "Consultations shown on your storefront come from the M4 Services module.",
    statServicesTotal: "Total services",
    statServicesActive: "Active",
    manageServicesBtn: "Manage services",
    blocksTitle: "Marketing sections",
    blocksCaption: "Hero banner, about, hours, address, FAQ. Enable/disable each section and customize its text.",
    titleLabel: "Title",
    subtitleLabel: "Subtitle",
    bodyLabel: "Content",
    addressLabel: "Address",
    ctaLabelLabel: "Button label",
    slotsCountLabel: "Number of slots shown",
    slotsHint: "Clicking a slot redirects the visitor to the booking form with the date and time pre-filled.",
    contactTitle: "Contact details",
    contactCaption: "Shown in the footer and contact section. Editable from Settings.",
    emailLabel: "Email",
    phoneLabel: "Phone",
    editInSettingsBtn: "Edit in Settings",
    notProvided: "Not provided",
    previewLive: "Live preview",
    previewAlt: "Preview of {name}",
    previewHint: "Save, then click ↻ to see your changes.",
    loading: "Loading…",
  },
  auditLog: {
    platform: "Platform",
    globalTitle: "Global audit",
    globalSub: "All platform events (click to see details).",
    colDate: "Date",
    colAction: "Action",
    colTenant: "Tenant",
    colResource: "Resource",
    colDetails: "Details",
    noEvents: "No events",
  },
  adminHealth: {
    overline: "Backend monitoring",
    title: "System health",
    subtitle: "Live status of external dependencies + backend exception capture (mini-Sentry equivalent).",
    errorsTitle: "Backend errors",
    errorsSubtitle: "Exceptions captured by the middleware — grouped by fingerprint.",
    kpiOpenGroups: "Open groups",
    kpiSeen24h: "Seen last 24h",
    kpiSeen7d: "Seen last 7 days",
    emptyTitle: "No open errors",
    emptyDesc: "The backend is in perfect health.",
    seenAt: "Seen {date}",
    metaTitle: "Metadata",
    rowFirst: "First",
    rowFingerprint: "Fingerprint",
    rowIp: "IP",
    rowUser: "User",
    rowTenant: "Tenant",
    topFrameTitle: "Top frame",
    tracebackTitle: "Traceback",
    markResolved: "Mark resolved",
    resolvedToast: "Error archived",
    confirmTitle: "Mark this error as resolved?",
    confirmItem: "It will be archived and won't reappear in the list unless it happens again.",
    loading: "Loading…",
  },
  adminLeads: {
    overline: "Platform",
    title: "Leads — pricing calculator",
    subtitle: "Visitors who requested a custom quote from the landing page. An email with a pre-filled signup link is sent automatically.",
    colDate: "Date",
    colEmail: "Email",
    colVertical: "Vertical",
    colModules: "Modules",
    colMonthly: "€ / mo",
    colStatus: "Status",
    statusUpdatedToast: "Status updated",
    emptyTitle: "No leads",
    emptyDesc: "Quote requests sent from the public pricing page will appear here.",
    statusNew: "New",
    statusContacted: "Contacted",
    statusConverted: "Converted",
    statusDropped: "Dropped",
  },
  adminDocuments: {
    toolboxOverline: "Toolbox",
    title: "Documents & resources",
    subtitleP1: "Blank printable templates + pricing editor + public pages. For versions ",
    subtitleBold: "pre-filled with a specific client",
    subtitleP2: ", go to their tenant record and use the \"Print\" buttons in the Actions menu.",
    printableTemplatesOverline: "Printable templates (blank)",
    onboardingPackTitle: "Onboarding pack",
    onboardingPackDesc: "Client sheet + 6-phase visit checklist + USSD code table. Print before every prospect meeting.",
    contractTitle: "Service contract",
    contractDesc: "Plans + options + terms + signatures. Prices synced with the pricing config below.",
    flyerTitle: "Tri-fold brochure",
    flyerDesc: "A4 landscape sales flyer, double-sided, with logo. To hand out during prospecting.",
    newBadge: "New",
    publicPagesOverline: "Public pages",
    pricingPageTitle: "Public pricing page",
    pricingPageDesc: "Your prospects discover the 3 plans + options. The \"Request a quote\" button creates a lead automatically.",
    formulasBadge: "{n} plans",
    pricingConfigTitle: "Pricing config (JSON)",
    pricingConfigDesc: "Source of truth for prices consumed by the contract, the public page, and the API.",
    openLabel: "Open",
    loadFailedToast: "Could not load pricing: ",
    savedToast: "Pricing saved and published",
    saveFailedToast: "Save failed: ",
    resetToast: "Pricing reset",
    resetFailedToast: "Reset failed: ",
    editingOverline: "Pricing editor",
    loading: "Loading…",
    editTitle: "Edit prices live",
    editSubtitleP1: "Changes are published ",
    editSubtitleB1: "immediately",
    editSubtitleP2: " on the public page ",
    editSubtitleP3: ", in the printable contract, and in the API.",
    resetBtn: "Reset",
    savingBtn: "Saving…",
    saveBtn: "Save",
    upToDateBtn: "Up to date",
    dirtyBannerPre: "Unpublished changes. Click ",
    dirtyBannerBold: "Save",
    dirtyBannerPost: " to apply.",
    currencyLabel: "Currency",
    vatLabel: "VAT",
    engagementLabel: "Commitment (months)",
    formulasOverline: "Plans",
    addFormulaBtn: "Add a plan",
    newFormulaName: "New plan",
    voiceTiersOverline: "AI voice tiers (add-ons)",
    addVoiceTierBtn: "Add a voice tier",
    newVoiceTierName: "New voice tier",
    voiceTiersHint: "Standard = Polly (included), Pro = Deepgram Aura 2 (€1.99/mo), Premium = ElevenLabs (€50 setup + €3/mo). Automatic cascade: Premium ↘ Pro ↘ Standard if a provider is unavailable.",
    optionsOverline: "À la carte options",
    addOptionBtn: "Add an option",
    newOptionLabel: "New option",
    resetConfirmTitle: "Reset pricing to default values?",
    resetConfirmItem: "The custom override will be deleted — plans, options, and voice tiers revert to the code defaults.",
    keyLabel: "Key",
    nameLabel: "Name",
    priceMonthlyLabel: "€ excl. VAT / mo",
    badgeLabel: "Badge",
    badgePlaceholder: "e.g.: Recommended",
    featuredLabel: "Featured",
    removeFormulaAria: "Remove plan {name}",
    modulesIncludedLabel: "Included modules (comma-separated)",
    modulesPlaceholder: "M1, M2, M3…",
    featuresLabel: "Features (1 per line)",
    labelLabel: "Label",
    priceOptionalLabel: "Price € (empty = quote on request)",
    unitLabel: "Unit",
    unitPlaceholder: "/ month",
    recurringLabel: "Recurring",
    removeOptionAria: "Remove option {label}",
    providerLabel: "Provider",
    providerPlaceholder: "e.g.: deepgram_aura2",
    setupFeeLabel: "€ setup",
    monthlyLabel: "€ / mo",
    pricePerMinLabel: "Price / min (actual billing)",
    pricePerMinPlaceholder: "Not set for this tier",
    pricePerMinEditLink: "Edit →",
    voiceIdLabel: "Default voice ID",
    taglineLabel: "Tagline (1 line)",
    benefitsLabel: "Benefits (1 per line)",
    includedInSubLabel: "Included in the subscription (no billed add-on)",
    removeBtn: "Remove",
  },
  adminBilling: {
    overline: "Platform",
    title: "B2B billing",
    subtitle: "Cross-tenant view of subscriptions, AI markup, invoices, and the monthly cron.",
    generateNowBtn: "Generate now",
    tabOverview: "Overview",
    tabLive: "Live usage",
    tabPlans: "Plans & Markups",
    tabCosts: "Costs & margins",
    tabInvoices: "Invoices",
    tabCron: "Scheduler",
    tabVoicePricing: "Voice pricing",
    tabRevenue: "Revenue",
    pricingMovedPre: "Price definition (modules, voice, SMS/WhatsApp, margins, contract pricing) has moved — ",
    pricingMovedLink: "see the Pricing page",
    loading: "Loading…",
    invoicesGeneratedToast: "{count} invoices generated for {month}",
    generateConfirmTitle: "Generate invoices for {month}?",
    generateConfirmItem: "All invoices for the month will be (re)generated for ALL active tenants on the platform, not just one.",
    totalBillableLabel: "Total billable",
    tenantsCountSuffix: "tenant{plural} · month {month}",
    refreshBtn: "Refresh",
    colTenant: "Tenant",
    colVertical: "Vertical",
    colStatus: "Status",
    colSubscription: "Subscription",
    colTelephony: "Telephony",
    colAiMarkup: "AI markup",
    colTotal: "Total",
    colInvoice: "Invoice",
    detailLink: "Detail",
    noTenants: "No tenants",
    telephonyPricesTitle: "Variable telephony prices",
    telephonyPricesSubtitle: "Cost re-billed to the tenant for each voice minute and each SMS used. Includes Twilio cost + your margin.",
    voiceCentsLabel: "Voice (cents / minute)",
    voiceCentsObsoleteNote: "No longer affects real billing — voice is debited from the prepaid wallet per call (see Voice Pricing). Kept for historical reference only.",
    smsCentsLabel: "SMS (cents / message)",
    perMin: " / min",
    perSms: " / SMS",
    saveBtn: "Save",
    noChangesToast: "No changes",
    telephonyUpdatedToast: "Telephony prices updated",
    moduleCatalogTitle: "Modular catalog",
    moduleCatalogSubtitle: "Monthly excl. VAT price per tier. Limits define the threshold beyond which the next tier applies.",
    moduleUpdatedToast: "{key} updated",
    monthlyTierPriceLabel: "Monthly price (cents)",
    emptyCatalog: "Catalog is empty.",
    aiMarkupTitle: "AI markup per vertical",
    aiMarkupSubtitle: "Surcharge applied to AI usage. Per call or per minute.",
    colMode: "Mode",
    colAmountCents: "Amount (cents)",
    markupUpdatedToast: "Markup {vk} updated",
    perCall: "Per call",
    perMinuteOpt: "Per minute",
    colId: "ID",
    colMonth: "Month",
    colIssued: "Issued",
    colLines: "Lines",
    noInvoices: "No invoices for {month}",
    invoiceTitlePrefix: "Invoice ",
    invoiceTitleFallback: "Invoice",
    tenantMonthCurrency: "Tenant {tenant} · Month {month} ·",
    issuedOnLabel: "Issued on",
    monthBilledLabel: "Month billed",
    linesLabel: "Lines",
    totalHtLabel: "Total excl. VAT",
    colType: "Type",
    colLabel: "Label",
    colQty: "Qty",
    colUnit: "Unit",
    colAmount: "Amount",
    kindSubscription: "Subscription",
    kindAiMarkup: "AI markup",
    consumptionSnapshotLabel: "Month's usage (snapshot)",
    closeBtn: "Close",
    cronTitle: "Monthly scheduler",
    cronEnabledLabel: "Enabled",
    cronEnabledHint: "Automatically generates last month's invoices.",
    cronDayLabel: "Day of month (1–28)",
    cronHourLabel: "UTC hour (0–23)",
    saveLabel: "Save",
    cronUpdatedToast: "Scheduler updated",
    lastRunTitle: "Last run",
    neverRun: "Never run",
    monthBilledInline: "Month billed: ",
    invoicesGeneratedInline: "Invoices generated: ",
    cronHint: "The scheduler checks every hour. Only one run per month is guaranteed (idempotent).",
    liveConsumptionTitle: "Live usage — {month}",
    tenantsAtRiskSuffix: "tenant{plural} at risk",
    totalTenantsSuffix: "{count} tenants total — sorted by descending voice %",
    filterGte: "Filter ≥",
    all: "All",
    overageOption: "100% (over limit)",
    colVoice: "Voice",
    colAiConv: "AI conv.",
    colSms: "SMS",
    colAlerts: "Alerts",
    topUpSuffix: " top-up",
    noTenantsAtThreshold: "No tenants at the selected threshold",
    howToReadTitle: "How to read this table?",
    howToReadBody: "Real cost = what you pay Twilio / Anthropic. × Coefficient = your markup multiplier. Selling price = what the tenant pays beyond the included quota. Change the cost or coefficient to adjust the selling price.",
    colService: "Service",
    colRealCost: "Real cost",
    colCoefficient: "Coefficient ×",
    colSellingPrice: "Selling price (calculated)",
    colGrossMargin: "Gross margin",
    voiceMinuteLabel: "AI voice minute",
    voiceMinuteDesc: "Twilio inbound + ASR + Polly TTS",
    smsSentLabel: "SMS sent",
    smsSentDesc: "Twilio outbound FR",
    aiConvLabel: "AI conversation",
    aiConvDesc: "Claude Sonnet 4.5 — ~3k tokens / conv.",
    currentLabel: "current: ",
    seePlansMarkups: "See \"Plans & Markups\" →",
    aiMarkupPerVertical: "AI markup is configured per vertical in the Plans & Markups tab.",
    coefficientsHint: "Coefficients will be applied to costs to calculate selling prices.",
    costsUpdatedToast: "Costs & margins updated",
  },
  adminPricing: {
    overline: "Pricing",
    title: "Price definition",
    subtitle: "All price definition in one place: modules, voice, SMS/WhatsApp, margins, and public contract pricing. Reporting (invoices, cron, revenue) stays on the Billing page.",
    sectionModulesTitle: "Modules & per-vertical margins",
    sectionModulesSubtitle: "Monthly subscription per module/tier and AI markup per vertical.",
    sectionTelephonyTitle: "Telephony — SMS & WhatsApp",
    sectionTelephonySubtitle: "Tariff billed to the tenant per SMS and per WhatsApp message (beyond the included allowance).",
    sectionVoiceTitle: "Voice",
    sectionVoiceSubtitle: "Per-minute tariff debited from the prepaid wallet on every call — the single source of truth for voice billing.",
    sectionCostsTitle: "Real vendor costs & margin",
    sectionCostsSubtitle: "Assumed SMS/AI costs and margin coefficient used to compute the selling price. Real voice cost now lives in the Voice section above.",
    sectionContractTitle: "Contract pricing (quotes)",
    sectionContractSubtitle: "What shows up on a prospect quote: formulas, options, public voice tiers with setup fees.",
    whatsappCentsLabel: "WhatsApp (cents / message)",
    perMsg: " / message",
    voiceMovedNote: "Voice is no longer managed here — see the \"Voice\" section further down this page (wallet tariff, single source of truth).",
    voiceCostsMovedNote: "Real voice cost and margin now live in this page's \"Voice\" section, not here.",
  },
  adminVoicePricing: {
    invalidDelayToast: "Invalid delay — enter a number of seconds > 0",
    tuningSavedToast: "Setting saved — applies to the next Premium call",
    stackUpdatedToast: "{stack} updated",
    title: "Voice pricing",
    subtitlePre: "Rate ",
    subtitleBold: "per minute",
    subtitlePost: " billed to tenants for each voice stack. Server-side per-second metering — min:sec display on the invoice. Operator model, no tiers.",
    colStack: "Stack",
    colLabelFr: "Label (FR)",
    colEurMin: "€/min",
    colActive: "Active",
    colActions: "Actions",
    saveBtn: "Save",
    modeOperatoireBold: "How it works: ",
    modeOperatoireRest: "rates apply to the next call. Already-billed calls keep the rate frozen at the time of recording (the per_minute_cents column is frozen on each usage_voice_calls row).",
    premiumTuningTitle: "Advanced settings — Premium tier",
    hesitationDelayLabel: "Hesitation delay before the model resumes (seconds)",
    defaultBtn: "Default ({s}s)",
    tuningHint: "When a caller finishes a short or hesitant sentence (\"uh...\"), fewer than 2 words), the AI waits this delay for a continuation before responding to what it already heard. Combined with the end-of-sentence wait time (~1.5s) and processing time (Claude + speech synthesis), too long a delay here produces perceived silences of several seconds. Lowered from 5s → 2.5s by default; adjustable here without redeployment, effective on the next Premium call.",
    bargeInDelayLabel: "Delay before cutting off the AI when the customer interrupts it (ms)",
    defaultBtnMs: "Default ({ms}ms)",
    invalidBargeInToast: "Invalid delay — enter a number between 150 and 2000 ms",
    bargeInHint: "How long the AI waits, after detecting the customer starting to speak, before cutting off its own sentence and listening — too short, it cuts off on background noise or a cough (raised from 400 to 600ms for this reason); too long, it keeps talking over the customer. Adjustable here without redeployment, effective on the next Premium call — test in real conditions (a noisy restaurant) before lowering it for good.",
  },
  adminRevenue: {
    loading: "Loading…",
    overline: "Platform",
    title: "Revenue & growth",
    subtitlePre: "Real-time metrics · current month ",
    kpiMrr: "MRR",
    kpiMrrSub: "Monthly Recurring Revenue",
    kpiArr: "ARR",
    kpiArrSub: "Annual Recurring Revenue",
    kpiPaying: "Paying subscriptions",
    kpiPayingSub: "{n} active tenants",
    kpiChurn: "30d churn",
    kpiChurnSub: "{canceled} canceled · {pastDue} past due",
    projectionTitle: "12-month projection",
    projectionSubtitle: "Conservative linear projection based on current MRR (zero growth, zero additional churn).",
    mrrProjected: "Projected MRR",
    mrrByVertical: "MRR by vertical",
    payingOfTenants: "· {paying} paying / {tenants} tenants",
    churnBadge: "{n} churn",
    top10Title: "Top 10 tenants (this month)",
    colRank: "#",
    colTenant: "Tenant",
    colSubscription: "Subscription",
    colVariable: "Variable",
    colTotal: "Total",
    noBillableTenants: "No billable tenants.",
    netMarginTitle: "Net margin · {month}",
    pctOfRevenue: "{pct}% of revenue",
    vsLastMonth: "{pct}% vs last month",
    revenueLabel: "Revenue",
    vendorCostsLabel: "Vendor costs",
    costBreakdownTitle: "Actual costs this month · breakdown",
    aiMeasuredBadge: "AI · {n} turns measured",
    aiEstimatedBadge: "AI · flat-rate estimate",
    costVoiceLabel: "Twilio voice",
    costVoiceUnitReal: "{n} calls measured · {min} real min",
    voicePerMinuteCompareTitle: "Real vs billed cost / minute",
    voicePerMinuteRealLabel: "real cost (Twilio)",
    voicePerMinuteBilledLabel: "billed to tenant",
    costSmsLabel: "Twilio SMS",
    costSttLabel: "STT (Deepgram)",
    costSttUnit: "{n} turns · audio in",
    costLlmLabel: "LLM (Claude/GPT)",
    costLlmUnit: "tokens in + out",
    costTtsLabel: "TTS (ElevenLabs / Aura)",
    costTtsUnit: "characters synthesized",
    costAiEstLabel: "AI (estimate)",
    costRealtimeLabel: "Realtime (OpenAI speech-to-speech)",
    costRealtimeUnit: "{n} turns · text + audio tokens",
    realtimeEstimatedFlag: "Mini audio rate estimated",
    aiCostRealNote: "AI costs aggregated live from ai.cost events for each conversation turn (Deepgram STT, Claude/GPT LLM, ElevenLabs/Aura TTS).",
    aiCostEstimatedNote: "No ai.cost event was captured this month — falling back to a flat-rate estimate.",
    realtimeCostNote: "Realtime cost aggregated live from actual tokens per turn (voice.turn.metrics).",
    realtimeAudioRateNote: " The mini model's audio rate isn't officially published by OpenAI for this exact version — a conservative estimate is used pending confirmation on the real invoice.",
    adjustCostsLink: "Adjust costs or margins.",
    profitTrendTitle: "Net margin · last 12 months",
    profitTrendSubtitle: "Actual revenue (invoices) minus vendor costs (Twilio + Claude) for the month.",
    monthTooltipPrefix: "Month ",
    legendRevenue: "Revenue",
    legendMargin: "Net margin",
    legendCosts: "Vendor costs",
  },
  adminTenantBilling: {
    statusActive: "Active",
    statusPastDue: "Past due",
    statusCanceled: "Canceled",
    statusInactive: "Inactive",
    loading: "Loading…",
    noData: "No data.",
    backToTenant: "Back to tenant",
    detailedBillingOverline: "Detailed billing",
    subscriptionModuleTitle: "Module subscription",
    activeModulesSuffix: "{n} active module(s)",
    seatsTitle: "Team seats",
    membersSuffix: "{n} member(s)",
    variableTelephonyTitle: "Variable telephony",
    minSmsOutOfQuota: "{min} min · {sms} SMS over quota",
    smsOutOfQuota: "{sms} SMS over quota",
    walletBalanceTitle: "Voice wallet balance",
    walletDebitedThisMonth: "{amount} debited this month",
    walletDebitedLabel: "Debited (wallet, real)",
    walletBalanceSub: "Current balance: {balance}",
    voiceMinutesUsedSubWallet: "{used} min · real per-second billing (wallet)",
    aiMarkupTitle: "AI markup",
    convOutOfQuota: "{n} conv. over quota × {amount}",
    totalToInvoiceTitle: "Total to invoice",
    monthHt: "Month {month} · excl. VAT",
    telephonyDetailTitle: "Variable telephony",
    voiceMinutesUsedLabel: "Voice minutes used",
    voiceMinutesUsedSub: "{used} min of {included} included",
    excessBilledLabel: "Overage billed",
    voiceExcessSub: "{n} min × {price} /min",
    smsSentLabel: "SMS sent",
    smsSentSub: "{sent} SMS of {included} included",
    smsExcessSub: "{n} SMS × {price} /SMS",
    subtotalLabel: "Subtotal",
    aiMarkupDetailTitle: "AI markup",
    aiConversationsLabel: "AI conversations",
    aiConvSub: "{used} of {included} included",
    aiExcessSub: "{n} conv. × {amount}",
    seatsBreakdownTitle: "Team seats — cost by role",
    colRole: "Role",
    colSeats: "Seats",
    colUnitPrice: "Unit price",
    colSubtotal: "Subtotal",
    seatsSubtotalLabel: "Seats subtotal",
    modulesDetailTitle: "Module subscription — breakdown by module",
    colModule: "Module",
    colTier: "Tier",
    colCountersLimits: "Counters / Limits",
    colPrice: "Price",
    modulesSubtotalLabel: "Subscription subtotal",
    usageSummaryTitle: "Raw usage · {month}",
    aiConversationsChip: "AI conversations",
    voiceMinutesChip: "Voice minutes",
    smsSentChip: "SMS sent",
    ordersChip: "Orders",
    recentInvoicesTitle: "Recent invoices",
    colMonth: "Month",
    colStatus: "Status",
    colAmount: "Amount",
    viewBtn: "View",
  },
  services: {
    overline: "Services",
    title: "Services catalog",
    intro: "Define your bookable services (duration, price, required resource). These services also appear under the \"Offers\" tab of your {catalogLink}, alongside orderable items.",
    catalogLink: "Catalog",
    add: "Add",
    editTitle: "Edit service",
    createTitle: "New service",
    name: "Name",
    nameRequired: "The service name is required.",
    description: "Description (optional)",
    durationMinutes: "Duration (minutes)",
    price: "Price (€)",
    resourceType: "Required resource type (optional)",
    resourceTypePlaceholder: "e.g. practitioner, stylist, cabin",
    active: "Service active",
    save: "Save",
    saving: "...",
    colName: "Name",
    colDuration: "Duration",
    colPrice: "Price",
    colResource: "Resource",
    colStatus: "Status",
    statusActive: "Active",
    statusInactive: "Inactive",
    empty: "No services yet. Add one.",
    deleteConfirmTitle: "Delete \"{name}\"?",
    deleteConfirmItem1: "The service disappears immediately from your menu and your public page.",
    deleteConfirmItem2: "Bookings already taken for this service are not cancelled.",
    deleteConfirm: "Delete",
    toastUpdated: "Service updated",
    toastCreated: "Service created",
    toastDeleted: "Service deleted",
  },
  inviteAccept: {
    invalidLink: "Invalid invitation link.",
    overlineInvitation: "Invitation",
    linkUnavailable: "Link unavailable",
    backToLogin: "← Back to login",
    loading: "Loading…",
    overlineWelcome: "Welcome",
    passwordSaved: "Password saved ✓",
    redirecting: "Redirecting to the login page…",
    overlineInvite: "Invitation to join",
    welcomeTo: "Welcome to",
    activateAccount: "Activate your account",
    greeting: "Hi {name}, ",
    invitedAs: "you have been invited as",
    invitedAsSuffix: ". Set your password to activate your access.",
    email: "Email address",
    newPassword: "New password",
    showPassword: "Show password",
    confirmPassword: "Confirm password",
    mismatch: "The two passwords do not match.",
    saving: "Saving…",
    activate: "Activate my account",
  },
  platformLegal: {
    backHome: "Back to home",
    sidebarOverline: "Platform notices",
    lastUpdated: "Last updated: {date}",
    docs: {
      cgu: { title: "Terms of Use", overline: "Terms", seoDescription: "Terms of use for the AI Commerce OS platform." },
      mentions: { title: "Legal Notice", overline: "Legal Notice", seoDescription: "Legal notice for the AI Commerce OS publisher." },
      confidentialite: { title: "Privacy Policy", overline: "Privacy", seoDescription: "Privacy policy and data processing — AI Commerce OS." },
      cookies: { title: "Cookie Policy", overline: "Cookies", seoDescription: "AI Commerce OS cookie policy — GDPR and ePrivacy compliant." },
    },
    cgu: {
      intro: "These terms of use (the \"Terms\") govern access to and use of the {name} platform (the \"Platform\"), provided by {publisher} ({legalForm}), intended for independent professionals and businesses wishing to deploy an intelligent assistant to manage their calls, bookings and orders.",
      h1: "1. Acceptance",
      p1: "Any use of the Platform implies full and unconditional acceptance of these Terms. If you do not accept these terms, you must refrain from using the Platform.",
      h2: "2. Service description",
      p2: "{name} is a multi-tenant software-as-a-service that allows a professional to:",
      p2_items: [
        "Receive and route phone calls via an AI voice assistant",
        "Manage a catalog, bookings and orders",
        "Publish a public presentation page and take orders online",
        "Track simplified accounting and generate reports",
        "Activate/deactivate functional modules according to their needs",
      ],
      h3: "3. Registration and account",
      p3: "Registration is reserved for adults with legal capacity, acting for professional purposes. The user undertakes to provide accurate information and to keep their credentials confidential. Any activity carried out from the account is deemed to be performed by its holder.",
      h4: "4. Subscription and billing",
      p4a: "Access to the Platform is subject to a monthly subscription made up of a base rate per module (Base / Pro / Premium) and a markup applied to AI consumption depending on the business vertical. Detailed pricing terms are presented in the user's \"Subscription\" area.",
      p4b: "The subscription has no commitment period and can be cancelled at any time. Cancellation takes effect at the end of the current month. Amounts already invoiced are not refunded pro rata.",
      h5: "5. User commitments",
      p5_items: [
        "Use the Platform in accordance with its professional purpose",
        "Not attempt to circumvent the security measures or quotas of the subscribed plan",
        "Not use the Platform for unlawful, fraudulent, defamatory purposes or in a way that infringes third-party rights",
        "Comply with applicable consumer protection and data protection laws",
        "Assume full responsibility for the content published (menus, descriptions, photos)",
      ],
      h6: "6. Availability and maintenance",
      p6: "{name} strives to ensure the Platform is available 24/7, without however guaranteeing absolute availability. Maintenance operations may cause interruptions, announced in advance whenever possible.",
      h7: "7. Intellectual property",
      p7: "The Platform, its code, design, trademarks and all elements that make it up are the exclusive property of {publisher} or its licensors. The subscription grants a personal, non-exclusive and non-transferable right of use. Content you publish on the Platform remains your property; you grant us a non-exclusive, revocable licence to store and display it strictly as necessary to provide the service.",
      h8: "8. Liability",
      p8: "{name} is bound by a best-efforts obligation. Its liability may not be engaged for indirect damages, loss of revenue, loss of customers or reputation. In any event, the total amount of compensation owed by {name} may not exceed the amount actually received under the subscription during the 6 months preceding the triggering event.",
      h9: "9. Suspension and termination",
      p9: "In the event of a serious breach of these Terms or non-payment, {name} reserves the right to suspend or terminate the account as of right, after formal notice has gone unheeded for 8 days, except in an emergency.",
      h10: "10. Personal data",
      p10: "The processing of personal data is described in the {link}.",
      p10_link: "privacy policy",
      h11: "11. Changes to these Terms",
      p11: "The Terms may evolve. Any substantial change will be notified to the user at least 30 days before it takes effect. Continued use of the Platform after that date constitutes acceptance of the new terms.",
      h12: "12. Governing law and jurisdiction",
      p12: "These Terms are governed by French law. Failing an amicable resolution, any dispute will be submitted to the exclusive jurisdiction of the courts within the jurisdiction of the publisher's registered office, unless mandatory legal provisions state otherwise.",
      h13: "13. Consumer mediation",
      p13: "In accordance with articles L. 611-1 et seq. of the French Consumer Code, when the user is a consumer, they may use a consumer mediator free of charge. The European online dispute resolution platform is accessible at {link}.",
    },
    mentions: {
      h1: "Publisher",
      li1a: "Name", li1a_val: ": {publisher} ({legalForm})",
      li1b: "Address", li1b_val: ": {address}",
      li1c: "Email", li1c_val: ": {email}",
      li1d: "Publication director", li1d_val: ": The current legal representative",
      h2: "Hosting",
      li2a: "Host", li2a_val: ": {host}",
      li2b: "Location", li2b_val: ": {hostAddress}",
      h3: "Intellectual property",
      p3: "The entire site, including its structure, texts, illustrations, logos, trademarks, photographs and other elements, is the exclusive property of {publisher} or its partners. Any reproduction, representation, modification, publication, full or partial adaptation is prohibited without prior written authorisation.",
      h4: "Hyperlinks",
      p4: "The site may contain links to third-party sites. {publisher} exercises no control over these sites and disclaims all liability for their content.",
      h5: "Credits",
      p5: "Design, development and operation: {publisher}. Iconography: {link}. Open source typefaces.",
      h6: "Contact",
      p6: "For any question relating to the site or the services, write to {email}.",
      h7: "Reporting unlawful content",
      p7: "In accordance with French law n° 2004-575 of 21 June 2004 on confidence in the digital economy (LCEN), any manifestly unlawful content may be reported to {email}.",
    },
    confidentialite: {
      intro: "This privacy policy explains how {name} (\"we\") processes your personal data when you use the Platform, in accordance with Regulation (EU) 2016/679 (\"GDPR\") and the amended French Data Protection Act.",
      h1: "1. Data controller",
      p1: "{publisher} is the controller for data collected via the Platform. Contact: {email}.",
      h2: "2. Data collected",
      h2_1: "2.1 User accounts (professionals)",
      h2_1_items: [
        "Email, name, password (bcrypt hashed — never stored in clear text)",
        "Business information (legal name, address, phone, vertical)",
        "Activity history (logins, audited actions)",
      ],
      h2_2: "2.2 Operational data",
      h2_2_items: [
        "Bookings, orders, AI conversations",
        "Consumption statistics (voice minutes, SMS, AI calls)",
        "Invoices and payment history",
      ],
      h2_3: "2.3 Cookies and technical data",
      h2_3_items: [
        "Strictly necessary session cookies (authentication)",
        "Anonymised analytics cookies (opt-in only)",
        "IP address (hashed for audit purposes) and user agent",
      ],
      h3: "3. Purposes and legal bases",
      h3_items: [
        "Performance of the contract (Art. 6.1.b GDPR): providing the service, billing, support",
        "Legal obligation (Art. 6.1.c): accounting retention (10 years), fraud prevention",
        "Legitimate interest (Art. 6.1.f): security, abuse prevention, product improvement (aggregated data)",
        "Consent (Art. 6.1.a): non-essential cookies, marketing communications",
      ],
      h4: "4. Retention period",
      h4_items: [
        "Account data: for the duration of the subscription, then 3 years after the last interaction (prospecting)",
        "Accounting data: 10 years (French Commercial Code)",
        "Technical logs: 12 months",
        "Cookies: 13 months maximum",
      ],
      h5: "5. Recipients and processors",
      p5: "Your data is accessible to authorised {publisher} staff and to our processors acting on documented instructions (Art. 28 GDPR):",
      h5_items: [
        "Hosting: {host}",
        "Telephony & SMS: Twilio Inc. (EU-US transfer governed by Standard Contractual Clauses)",
        "Conversational AI: Anthropic / OpenAI (pseudonymised data where possible)",
        "Transactional emails: Brevo (EU)",
        "Payment: Stripe Payments Europe Ltd",
      ],
      h6: "6. Transfers outside the EU",
      p6: "Some processors may process data outside the European Union. These transfers are governed by appropriate safeguards (Standard Contractual Clauses adopted by the European Commission, and where applicable the Data Privacy Framework).",
      h7: "7. Security",
      h7_items: [
        "TLS 1.3 encryption in transit, encryption at rest",
        "Hashed passwords (bcrypt)",
        "Granular role-based access control (RBAC)",
        "Logging and immutable audit log",
        "Regular backups and disaster recovery plan",
      ],
      h8: "8. Your rights",
      p8intro: "In accordance with articles 15 to 22 of the GDPR, you have the following rights:",
      h8_items: [
        "Access to data concerning you",
        "Rectification of inaccurate data",
        "Erasure (\"right to be forgotten\") under the conditions set by law",
        "Restriction of processing",
        "Objection on legitimate grounds",
        "Portability of your data in a structured format",
        "Set directives regarding the fate of your data after your death",
      ],
      p8outro: "To exercise these rights: {email}. A response is provided within one month.",
      h9: "9. Complaints",
      p9: "You have the right to lodge a complaint with the supervisory authority, {link} (3 place de Fontenoy, TSA 80715, 75334 Paris Cedex 07, France).",
      p9_link: "the CNIL",
      h10: "10. Changes",
      p10: "This policy may be updated. The applicable version is the one published on the date you access the Platform. Any substantial change will be notified to you.",
    },
    cookies: {
      intro: "This policy sets out the terms of use of cookies and trackers on the {name} Platform, in accordance with CNIL recommendations and Directive 2002/58/EC (\"ePrivacy\") as amended.",
      h1: "1. What is a cookie?",
      p1: "A cookie is a small file placed on your device when you visit a site. It notably helps remember preferences, ensure a service works correctly, or measure audience.",
      h2: "2. Cookies used",
      h2_1: "2.1 Strictly necessary cookies",
      p2_1: "Essential to the operation of the Platform: authentication, session, language preference, CSRF protection. These cookies are set without prior consent, in accordance with article 82 of the French Data Protection Act.",
      h2_2: "2.2 Anonymised audience measurement cookies",
      p2_2: "When enabled, they help us understand how the service is used in order to improve it. Identifiers are hashed and collection is limited to the essentials.",
      h2_3: "2.3 Marketing cookies",
      p2_3: "Not used at this time. Any future activation would be subject to prior explicit consent via the consent banner.",
      h3: "3. Consent management",
      p3a: "On your first visit, a banner offers you the choice to accept, refuse or customise your preferences. You can change your choice at any time by clearing the consent cookie (key",
      p3b: ") or by contacting us at {email}.",
      h4: "4. Retention period",
      p4: "Cookies are kept for a maximum of 13 months. Consent is also remembered for 6 months before being requested again.",
      h5: "5. Third-party cookies",
      p5: "Some integrated services (Stripe for payment, Twilio for telephony) may set their own cookies, subject to their respective policies. More information is available from these providers.",
      h6: "6. Your rights",
      p6a: "Beyond managing consent via the banner, you can configure your browser to accept or refuse cookies (see",
      p6b: "). Refusing certain cookies may impair the operation of the Platform.",
      p6link: "the CNIL fact sheets",
    },
  },
  publicLegal: {
    docTerms: "Terms",
    docPrivacy: "Privacy Policy",
    docLegalNotice: "Legal Notice",
    docCookies: "Cookie Policy",
    back: "Back",
    loading: "Loading…",
  },
  adminVerticalDetail: {
    loading: "Loading…",
    notFound: "Vertical not found",
    allVerticals: "All verticals",
    medicalMode: "Medical mode",
    defaultModules: "Default modules ({n})",
    defaultRules: "Default business rules",
    noRules: "No rules defined.",
    ivrTemplate: "IVR template",
    sensitiveKeywords: "Sensitive keywords (AI alerts)",
    adoption: "Adoption",
    tenantsInVertical: "Tenants using this vertical",
    viewTenants: "View tenants →",
  },
  adminAnalytics: {
    overline: "Analytics · AI costs",
    title: "Cumulative AI cost / tenant / month",
    subtitle: "STT + LLM + TTS + Realtime (OpenAI) + Twilio (number rental 1.50€/mo + carrier minutes) costs — cached phrases aren't re-billed. Hover a \"Cost\" cell for the breakdown.",
    month: "Month",
    reload: "Reload",
    exportCsv: "Export CSV",
    exportToast: "CSV export downloaded (acos-costs-{month}.csv)",
    kpiPlatformCost: "Platform AI cost",
    kpiPlatformCostSub: "{n} active tenants this month",
    kpiPlatformRevenue: "Platform revenue",
    kpiPlatformRevenueSub: "{n} tenants · module prices ⨯ subscriptions",
    kpiMargin: "Gross margin",
    kpiTenants: "Tenants",
    kpiTenantsSub: "{n} with cost > 0",
    voiceStackOverline: "Profitability per voice plan",
    voiceStackTitle: "Which plan should we push?",
    voiceStackSub: "Real provider cost, retail price, and margin per plan (last 30 days) — cross-reference with latency to pick the most profitable and efficient plan(s).",
    voiceStackSeeLatency: "See the latency page",
    loadingStacks: "Loading…",
    colTier: "Plan",
    colProviderCost: "Provider cost",
    colRetailPrice: "Retail price",
    colLatency: "Latency",
    voiceStackHint: "\"Measured\" = computed from real calls in the window; \"Estimate\" = no real calls, fallback figure shown instead.",
    moduleProjectionOverline: "Projection — Margin by module",
    moduleProjectionTitle: "Revenue vs. AI cost / module",
    moduleProjectionSub: "AI cost is attributed to modules M2 and M3 (which generate it). Other modules do not consume AI.",
    colModule: "Module",
    colPricePerMonth: "Price / month",
    colTenants: "Tenants",
    colRevenue: "Revenue",
    colAiCost: "AI cost",
    colMargin: "Margin",
    colMarginPct: "Margin %",
    tenantsDetailOverline: "Tenant detail",
    tenantsCount: "{n} tenants",
    colTenant: "Tenant",
    colModules: "Modules",
    colStatus: "Status",
    colTurnsConv: "Turns / Conv.",
    noData: "No data",
  },
  checkYourEmail: {
    missingEmail: "Missing email address.",
    linkResent: "Link resent.",
    home: "Home",
    overline: "Account created",
    title: "Check your inbox",
    body1: "A confirmation link was just sent to {email}. Click the button in that email to activate your 7-day free trial.",
    yourAddress: "your address",
    body2: "The link is valid for 48 hours. Remember to check your spam folder and \"Promotions\" / \"Notifications\" tabs.",
    resent: "Link resent",
    resend: "Resend the link",
    goToLogin: "Go to login",
    nothingReceived: "Didn't receive anything?",
    tip1: "Check your spam / junk folder.",
    tip2: "Is the address correct? If not, create a new account.",
    tip3: "Click \"Resend the link\" above.",
    tip4: "Still nothing after 5 min?",
  },
  publicBooking: {
    tenantNotFound: "Business not found",
    bookingError: "Error while booking",
    confirmationOverline: "Confirmation",
    confirmedTitle: "Booking confirmed",
    pendingTitle: "Request received",
    confirmedBody: "You will receive a confirmation email.",
    pendingBody: "Your request is awaiting approval from the business.",
    date: "Date:",
    time: "Time:",
    venue: "Business:",
    manageBooking: "Manage my booking",
    step: "Step {n} / {total}",
    bookTitle: "Book",
    chooseWord: "Choose",
    chooseService: "Choose a service",
    noServiceAvailable: "No service available.",
    choosePractitioner: "a practitioner",
    chooseRoom: "a room",
    chooseResource: "a resource",
    optionalSuffix: " (optional)",
    noPreference: "No preference",
    dateLabel: "Date",
    partySize: "Party size",
    partySizeHint: "For more than 12 guests, please contact us directly.",
    desiredDate: "Preferred date",
    availableSlots: "Available slots on {date}",
    searching: "Searching…",
    noSlots: "No slot available on this day. Try another date.",
    firstName: "First name *",
    lastName: "Last name *",
    email: "Email *",
    phone: "Phone",
    birthDate: "Date of birth",
    birthDateRequired: "*",
    birthDateOptional: "(optional)",
    notes: "Notes / reason (optional)",
    summary: "Summary",
    when: "When:",
    service: "Service:",
    resource: "Resource:",
    partySizeSummary: "Guests:",
    client: "Client:",
    emailSummary: "Email:",
    previous: "Previous",
    next: "Next",
    confirmBooking: "Confirm booking",
  },
  adminPricingPlans: {
    title: "Pricing & visibility",
    intro: "By default, all new customers only see the {premium} and {premiumPlus} plans. Internal tiers (Pro / Standard) are reserved for test tenants used for data collection and model training.",
    premium: "Premium",
    premiumPlus: "Premium+",
    globalCatalog: "Global catalog",
    defaultVisibleTo: "Default visible to new signups:",
    perMonthExclTax: "/month excl. tax",
    public: "Public",
    internal: "Internal",
    setup: "Setup:",
    included: "Included:",
    overage: "Overage:",
    stack: "Stack:",
    tenantOverride: "Per-tenant override",
    tenantOverrideDesc: "Select a tenant and enable the internal plans (Pro / Standard) to expose.",
    searchPlaceholder: "Search (name / slug / email)",
    pickTenant: "Pick a tenant on the left to manage its visible plans.",
    loading: "Loading…",
    activateTestMode: "Enable TEST MODE (all plans)",
    resetDefault: "Reset (Premium default)",
    visiblePlansUpdated: "Visible plans updated for {name}",
    overrideCleared: "Override cleared — back to defaults (Premium only)",
    testModeGranted: "Tenant upgraded to TEST MODE — all plans (Pro + Standard) visible",
  },
  adminCommerceConfig: {
    title: "Commerce & pricing",
    subtitle: "Configure your subscription plans, voice tiers and document templates — then control what's publicly visible.",
    tabConfig: "Product configuration",
    tabPlans: "Plans & visibility",
  },
  publicOrderReceipt: {
    loadError: "Unable to load the order.",
    notFound: "Order not found",
    orderNumber: "Order #{number}",
    statusPaidTitle: "Payment confirmed",
    statusPaidSub: "Your order is confirmed and sent to the kitchen.",
    statusPendingTitle: "Payment being validated",
    statusPendingSub: "We're waiting for Stripe confirmation. This should only take a few seconds…",
    statusCancelledTitle: "Payment cancelled",
    statusCancelledSub: "Your order was not confirmed. You can place it again at any time.",
    statusUnknownTitle: "Unknown status",
    statusUnknownSub: "We couldn't find the details for this order.",
    pickupAt: "Pickup at",
    summary: "Summary",
    menu: "Menu:",
    total: "Total",
    paid: "Paid",
    checkPayment: "Check payment",
    downloadReceipt: "Download receipt",
    footer: "Keep this page: it's your order confirmation.",
  },
  adminFlowLatencyDashboard: {
    phaseCatalogLookup: "Catalog lookup (expected_values)",
    phaseRunTurn: "run_turn (full turn, excluding catalog)",
    phaseExtraction: "Extraction (Level 0/0.5/1, all paths combined)",
    phaseExtractionLlm: "…of which actual LLM call (Level 1 only)",
    phaseCartOps: "Cart operations (add/remove)",
    phaseAction: "Node action (branch/recap/end call)",
    phaseDynamicValues: "Dynamic values (catalog/recap/item name)",
    phasePhraseRender: "Rendering the next phrase",
    title: "Per-turn latency — Scripted flow",
    subtitle: "Breakdown of the flow_v1 engine (Sprint 14/15) — fed by voice.brain.finished events (engine=flow_v1). Distinct from the \"M3 AI Latency\" dashboard, which covers the legacy Realtime/M3 orchestrator.",
    lastHour: "Last hour",
    last6h: "Last 6 hours",
    last24h: "24h",
    last3d: "3 days",
    last7d: "7 days",
    kpiBrainP50: "Full turn (brain_ms) P50",
    p90Label: "P90:",
    asrTtsExcluded: "(ASR/TTS excluded)",
    kpiSamples: "Turns analysed",
    over: "over {hours}h",
    kpiLlmShare: "Turns handled at Level 1 (LLM)",
    llmShareHint: "the only case where the filler phrase triggers",
    engineComparisonTitle: "Premium vs. scripted Realtime comparison",
    colTier: "Tier",
    colTurns: "Turns",
    colBrainP50: "brain_ms P50",
    colBrainP90: "brain_ms P90",
    colBrainMean: "brain_ms Avg.",
    colLevel1Pct: "% Level 1 (LLM)",
    tierRealtimeScripted: "Scripted Realtime",
    tierPremium: "Premium",
    engineComparisonHint: "brain_ms = decision only (extraction + catalog + phrase rendering), excluding ASR/TTS — same convention on both sides since both tiers call the same run_flow_turn_for_call function. TTS cost/latency (ElevenLabs/Aura, OpenAI on the realtime side) is on the separate \"Voice cost\" screen.",
    phaseBreakdownTitle: "Breakdown by phase (ms)",
    loading: "Loading…",
    noData: "No data for this range — make a few calls through the scripted flow engine to generate events.",
    phaseDetailTitle: "Detail by phase",
    colPhase: "Phase",
    colSamples: "Samples",
    colP50: "P50 (ms)",
    colP90: "P90 (ms)",
    colP99: "P99 (ms)",
    colMean: "Avg.",
    fullTurn: "brain_ms (full turn)",
    levelBreakdownTitle: "Level 0 / 0.5 / 1 breakdown",
    level: "Level",
    levelBreakdownHint: "The lower the Level 1 share, the fewer latency fillers (see Audio tab) trigger — this is expected.",
    statusBreakdownTitle: "Turn statuses",
  },
  adminUnderstandingQuality: {
    title: "Comprehension quality",
    subtitle: "Messages/calls that fell through all deterministic/targeted-LLM handling and were escalated (general orchestrator for WhatsApp, human transfer for voice) — a prioritization signal, not an outage metric. The \"all channels\" column and the expandable phrases (2026-08-24) are fed by core.understanding_log, which logs the actual text — the \"WhatsApp\" counter is the older day/tenant signal, kept for historical comparison.",
    last7d: "Last 7 days",
    last30d: "Last 30 days",
    last90d: "Last 90 days",
    kpiTotal: "Total WhatsApp escalations",
    over: "over {days}d",
    kpiTenantsAffected: "Tenants affected",
    tenantsAffectedHint: "at least one escalation in the window",
    kpiWorstTenant: "Worst-affected tenant",
    escalationsSuffix: "escalations",
    noneYet: "No escalations in this window",
    trendTitle: "Daily WhatsApp trend (all tenants)",
    loading: "Loading…",
    noData: "No data for this range.",
    byTenantTitle: "Detail by tenant",
    colTenant: "Tenant",
    colTotalAllChannels: "All channels",
    colTotalAllChannelsHint: "WhatsApp + voice, since 2026-08-24 (core.understanding_log)",
    colTotal: "WhatsApp (legacy counter)",
    colDaysActive: "Active days",
    colAvgPerDay: "Avg./active day",
    worstBadge: "WORST",
    recentPhrasesTitle: "Recently misunderstood phrases/words — click to collapse",
  },
  adminVoiceObservability: {
    title: "Voice call reliability",
    subtitle: "Reask rate, human-transfer rate, abandonment rate before finalization, and STT→LLM→TTS latency — per tenant and overall. Without this dashboard, a production voice issue only surfaces by manually replaying a test call.",
    lastHour: "Last hour",
    last6h: "Last 6 hours",
    last24h: "Last 24 hours",
    last3d: "Last 3 days",
    last7d: "Last 7 days",
    loading: "Loading…",
    noData: "No data for this range.",
    kpiTotalCalls: "Calls",
    over: "over {hours}h",
    kpiReaskRate: "Reask rate",
    reaskRateHint: "share of turns where the question had to be asked again",
    kpiFinalizedRate: "Finalization rate",
    finalizedRateHint: "share of calls that ended in an order",
    kpiTransferRate: "Human transfer rate",
    kpiAbandonedRate: "Abandonment rate",
    abandonedRateHint: "call ended with no order and no human transfer",
    latencyTitle: "End-to-end latency (per turn)",
    latencyHint: "Time between the customer's speech end (VAD) and the end of the response — broken down by phase to see where the time actually goes.",
    phaseVad: "Speech-end detection",
    phaseBackend: "Backend receipt",
    phaseTtft: "1st LLM token (TTFT)",
    phaseTtfa: "1st TTS audio (TTFA)",
    phaseTail: "Audio playback tail",
    phaseTotal: "Full turn",
    colPhase: "Phase",
    colSamples: "Samples",
    colP50: "P50",
    colP90: "P90",
    colP99: "P99",
    colMean: "Avg.",
    byTenantTitle: "Detail by tenant",
    colTenant: "Tenant",
    colCalls: "Calls",
    colTurns: "Turns",
    colReaskRate: "Reask",
    colFinalizedRate: "Finalized",
    colTransferRate: "Transfer",
    colAbandonedRate: "Abandoned",
    worstBadge: "WATCH",
    unknownTenantHint: "Events with no identified tenant (calls made before the 2026-09-28 fix) — grouped here until history rebuilds.",
    statusBreakdownTitle: "Turn status breakdown",
    coverageTitle: "Level 0 (learned) vs Level 1 (LLM) coverage, per step",
    coverageHint: "For each graph step, share of turns resolved without an LLM call (deterministic or learned via the knowledge base) vs resolved by a real LLM call. Only calls made after 2026-10-06 are counted here — most LLM-dependent step first.",
    coverageEmpty: "No coverage data for this range (calls too old, or no turn went through the engine's main path).",
    colStep: "Step",
    colNodeKind: "Type",
    colTurnsShort: "Turns",
    colLevel0Rate: "Level 0",
    colLevel1Rate: "Level 1 (LLM)",
    colLlmGate: "LLM",
    llmGateTenantLabel: "Target tenant",
    llmGateTenantPlaceholder: "Tenant ID",
    llmGateTenantRequired: "Enter the target tenant ID first.",
    llmGateActiveCount: "{count} step(s) with LLM disabled for this tenant",
    llmGateNoneActive: "No active switch — the LLM is still used everywhere, same as before this chantier.",
    llmGateDisable: "Disable LLM",
    llmGateReenable: "Re-enable LLM",
    llmGateDisabledToast: "LLM disabled for this step — automatic fallback to reask/human transfer.",
    llmGateEnabledToast: "LLM re-enabled for this step.",
    kbTitle: "Learning suggestions to review",
    kbSubtitle: "Recurring customer phrasings the LLM had to resolve every single time — the assistant suggests remembering them. No-risk cases (order type, menu vs à la carte...) are already applied automatically and never show up here; anything touching the order or payment waits for your approval.",
    kbLearnedTitle: "Already learned",
    kbLearnedSubtitle: "{count} currently active phrasing(s) — consulted by the assistant on every call/message, before the LLM is even called.",
    kbLearnedSearchPlaceholder: "Search a phrasing or a value…",
    kbLearnedEmpty: "Nothing active yet — anything saved from Real failures or approved below will show up here.",
    kbLearnedSince: "Active since {date}",
    kbLearnedRemove: "Remove",
    kbLearnedEdit: "Edit",
    kbLearnedSaved: "Entry updated.",
    kbLearnedFieldPhrase: "Phrase that should be understood",
    kbLearnedFieldPhraseHint: "The exact (or close) customer wording that should trigger this response.",
    kbLearnedFieldValue: "Retained value",
    kbLearnedFieldValueHint: "What the assistant should understand or say for this phrase.",
    kbLearnedFieldIntent: "What the assistant should understand",
    kbLearnedFieldIntentHint: "The recognized intent — pick from the intents the assistant already knows how to handle.",
    kbLearnedEditedAt: "Edited on {date} by {by}",
    kbHitCount: "seen {count} times, always resolved the same way",
    kbApprove: "Approve",
    kbReject: "Reject",
    kbApproved: "Added to the knowledge base",
    kbRejected: "Suggestion rejected",
    simTitle: "Tester — what would the AI understand/answer?",
    simSubtitle: "Manual tool, for a hand-typed hypothesis (real failures above already have their own built-in test, no retyping needed). Replays the real extraction engine — read-only, no production impact.",
    simStepKind: "Step type",
    simSlot: "Expected slot (optional)",
    simExpectedValues: "Possible values/options",
    simExpectedValuesPlaceholder: "takeaway, dine in, delivery",
    simQuestionAsked: "Question the assistant asked",
    simQuestionAskedPlaceholder: "Will that be takeaway or dine in?",
    simCustomerText: "Customer message to test",
    simCustomerTextPlaceholder: "Actually I'll take it with me",
    simRun: "Test",
    simRunning: "Testing…",
    simMatchedChoice: "Recognized value",
    simConfirmed: "Confirmed",
    simItemsMentioned: "Items mentioned",
    simEscalation: "Escalation",
    simErrors: "Errors",
    phraseTitle: "New wording draft",
    phraseSubtitle: "Manual tool, to rework a phrase WITHOUT starting from a real failure (failures above already have their own built-in draft). The AI drafts text from the described problem — you review it, edit if needed, then save; audio generation and going live in the voice graph are then automatic.",
    phraseTenantId: "Tenant ID",
    phraseKey: "Phrase key (phrase_key)",
    phraseLanguage: "Language",
    phraseContext: "What went wrong",
    phraseContextPlaceholder: "The customer didn't understand the question, too ambiguous on menu vs à la carte...",
    phraseSuggest: "Suggest a draft",
    phraseSuggesting: "Drafting…",
    phraseDraftLabel: "Draft (editable before saving)",
    phraseDraftHint: "Check that {{variables}} are kept if the original phrase had any.",
    phraseSave: "Save and publish",
    phraseSaving: "Saving…",
    phraseSaved: "Variant saved — audio generated and live",
    failTitle: "Real comprehension failures",
    failSubtitle: "Each row starts from a real call the bot got wrong. Full context is given to the AI (more than it had live) to reconstruct intent and suggest a better wording — which you can correct before saving.",
    failLast30d: "Last 30 days",
    failKindAll: "All ({count})",
    failKindFailure: "Real failures ({count})",
    failKindLlmResolved: "AI-resolved — needs review ({count})",
    failKindFailureBadge: "Real failure",
    failKindLlmResolvedBadge: "AI-resolved",
    failLlmResolvedHint: "The AI understood: {value} — not escalated, but not confirmed by the customer either.",
    failWhatsappNoTestHint: "WhatsApp failure (M3 orchestrator): this channel has no node/closed question to replay here — only the reformulation below applies.",
    failWhatsappRuleHint: "This reformulation will be saved as a Learning Lab rule (trigger = this message) — it will apply starting with the next similar WhatsApp message, before the AI (LLM) is even called.",
    failChannelAll: "All channels ({count})",
    failChannelVoice: "Voice ({count})",
    failChannelWhatsapp: "WhatsApp ({count})",
    goToKnowledgeBase: "Open the knowledge base",
    kbPageTitle: "Knowledge base",
    kbPageSubtitle: "Real comprehension failures (voice and WhatsApp), learned suggestions, extraction tester and phrase draft tool — everything used to correct and enrich the assistant.",
    failEmpty: "No comprehension failures in this window.",
    failContext: "Conversation context",
    failNoContext: "No context available.",
    failRoleClient: "Customer",
    failRoleAssistant: "Assistant",
    failAnalyze: "Analyze with AI",
    failAnalyzing: "Analyzing…",
    failIntention: "Intent understood by the AI",
    failSuggestedValue: "Recognized value",
    failDraftLabel: "Suggested response/wording (editable)",
    failDraftPlaceholder: "No suggested rewording — you can write your own",
    failDraftHint: "Unchanged = the generated version is used as-is. Edited = your version takes priority.",
    failDraftGenerated: "AI-generated",
    failDraftEdited: "Edited by you",
    failSave: "Save and publish",
    failSaving: "Saving…",
    failSaved: "Fix saved",
    failNoAction: "Nothing to save — write a wording or leave the generated suggestion",
    failStepContext: "1. Context",
    failStepTest: "2. Live test",
    failStepAnalyze: "3. AI analysis",
    failStepDraft: "4. New wording",
    failTestRun: "Test now",
    failTestRetry: "Retest",
    failTestRunning: "Testing…",
    failTestHint: "Replays the real engine on this exact phrase, with the same expected values it had live — to see whether the problem is the extraction itself.",
    failTestLevel0: "Level 0 — rule/synonym",
    failTestLevel1: "Level 1 — LLM call",
    failTestLevelFail: "Complete failure",
    failTestMatchedChoice: "Detected value",
    failTestConfirmed: "Confirmed",
    failTestEscalation: "Still escapes",
    failTestErrors: "Errors",
    failTestOk: "Correctly understood by the engine",
    failTestStillFails: "Still not understood — confirms the diagnosis",
    failRevalidate: "Recheck after the fix",
    failRevalidating: "Checking…",
    failRevalidateFixed: "Fixed — the AI now understands",
    failRevalidateStill: "Still not recognized — the fix isn't enough yet",
    failRevalidateHint: "The knowledge base can take a few seconds to refresh.",
    failValueNotApplicableComposition: "This question is about a composition choice (meat, sauce, topping...) — this type of answer is now understood automatically LIVE by the AI last-resort on every call, not through a synonym base saved here. Nothing to do for it to work on the next call. You can still reword the question below if the wording itself was the problem.",
    failValuePlaceholder: "Value to remember (must exactly match a possible choice)",
    failValueHint: "Will be understood automatically from the next call on, for this slot ({slot}) — unchanged = the generated suggestion is used as-is.",
    failValueNoSlot: "This question has no identifiable slot — no value can be saved here yet.",
    failNoPhraseKey: "This question has no identifiable wording — no rewording can be saved here.",
    failNothingToSaveHint: "Nothing to save yet: edit the recognized value and/or the wording above.",
  },
  flowScriptTabs: {
    keyLangRequired: "phrase_key and language are required",
    phraseSaved: "Phrase saved",
    saveError: "Save error",
    previewError: "Preview unavailable",
    vertical: "Vertical",
    noPhrase: "No phrase for this vertical.",
    phraseKeyLabel: "phrase_key",
    languageLabel: "language",
    templateLabel: "Text (template {{variable}})",
    variablesLabel: "Variables (comma-separated)",
    saving: "Saving…",
    save: "Save",
    previewLabel: "Render preview (JSON values, e.g. {\"item_name\": \"Crousty\"})",
    preview: "Preview",
    voiceIdLabel: "voice_id",
    tierLabel: "tier",
    tierPro: "pro (Deepgram Aura)",
    tierPremium: "premium (ElevenLabs)",
    voicesLoading: "Loading voices…",
    voicesChoose: "Choose an ElevenLabs voice…",
    audioTabHint: "Each phrase is split into FIXED fragments (cached individually, exactly what a real call would replay) and VARIABLE fragments (highlighted — their value comes from the customer's live choice, so never cached here: they will always be synthesised on the fly during the call).",
    loading: "Loading…",
    variableTitle: "Variable — value from the customer's live choice, not cached here, always synthesised on the fly.",
    notSpeakable: "(not speakable)",
    cached: "Cached",
    notCached: "Not yet",
    mainWording: "Main wording",
    variantWording: "Variant",
    generating: "Generating…",
    generate: "Generate",
    audioGeneratedToast: "Audio generated for \"{key}\" (fragment {n})",
    audioGenError: "Audio generation error",
    fillerSaved: "Filler phrase saved",
    noFiller: "No filler phrase for this vertical — create one on the right.",
    fillerHint: "These phrases are played WHILE a node's LLM call (Level 1) runs to mask latency, before the real response is ready — see the filler_phrase_key field in the node inspector on the Graph tab (ask_open_item / ask_closed_choice / confirm_yes_no nodes).",
    staticTextLabel: "Text (100% static — no {{variable}})",
    variableWarning: "A filler phrase must be spoken immediately, before the engine knows the turn's context — a {{variable}} can never be resolved here and would be spoken literally to the customer.",
    newPhrase: "New phrase",
    nothingToGenerate: "Nothing to generate right now.",
    fillerVariableTitle: "A filler phrase should never have a variable.",
    variantsLabel: "Variants (alternate wordings)",
    variantsHint: "Every time this phrase needs to be spoken, the assistant randomly picks one among the main text above and these variants — useful to avoid always repeating the exact same wording. Leave empty if you only want one.",
    variantPlaceholder: "Alternate wording…",
    addVariant: "Add a variant",
    removeVariant: "Remove this variant",
  },
  adminLatencyDashboard: {
    phaseHistoryLoad: "Mongo history",
    phaseGuardrailsIntent: "Guardrails + Intent (LLM)",
    phaseRag: "RAG / Inventory / Dispatch / Playbook",
    phaseLlmReply: "Haiku 4.5 reply (LLM)",
    phaseTotal: "Total backend",
    measured: "Measured",
    estimated: "Estimate",
    measuredOn: "Measured on",
    samples: "samples",
    estimatedHint: "No real calls in the window — estimated figure, not measured.",
    tierStandard: "Standard voice",
    tierPro: "Pro voice",
    tierPremium: "Premium voice",
    tierRealtime: "Realtime voice",
    tierRealtimePro: "Realtime Pro voice",
    title: "M3 AI Latency",
    subtitle: "End-to-end backend measurement (excluding ASR / TTS) — fed by m3.latency events.",
    lastHour: "Last hour",
    last6h: "Last 6 hours",
    last24h: "24h",
    last3d: "3 days",
    last7d: "7 days",
    kpiTotalP50: "Total P50",
    p90Label: "P90:",
    kpiSamples: "Turns analysed",
    over: "over {hours}h",
    kpiSticky: "Intent sticky-reuse",
    stickyHint: "turns that skipped classification",
    phaseBreakdownTitle: "Breakdown by phase (ms)",
    loading: "Loading…",
    noData: "No data for this range. Run a few turns via /api/m3/simulator/turn to generate events.",
    phaseDetailTitle: "Detail by phase",
    colPhase: "Phase",
    colSamples: "Samples",
    colP50: "P50 (ms)",
    colP90: "P90 (ms)",
    colP99: "P99 (ms)",
    colMean: "Avg.",
    intentBreakdownTitle: "Intent breakdown",
    costMatrixTitle: "Provider cost × Retail price × Latency — by voice tier",
    colTier: "Tier",
    colProviderCost: "Provider cost",
    colRetailPrice: "Retail price",
    colMarginPerMin: "Margin / min",
    colMarginPct: "Margin %",
    colTargetLatency: "Target latency",
    colLatency: "Latency",
    colTenants: "Tenants",
    marginHint: "💡 A margin ≥ 60% covers cost spikes (uncached prompt, quota overages).",
    costHint: "⚠️ Provider cost based on public OpenAI pricing Feb 2026 with prompt cache. Without cache, multiply ×3.",
    measuredCostTitle: "Scripted Realtime — actual measured cost (last 7 days)",
    unconfirmedEstimate: "~ unconfirmed OpenAI estimate",
    avgMeasured: "measured average",
    minMaxPerCall: "min–max per call",
    callsMeasured: "calls measured",
    noMeasuredCalls: "No scripted realtime calls measured in the last 7 days — the \"realtime\" row above remains a stale static estimate (legacy architecture) until a recent call has been made.",
  },
  adminSettings: {
    groqIntro: "Groq offers noticeably faster inference than Anthropic/OpenAI (dedicated LPU hardware) — configuring a key here makes it take priority over all scripted-engine extraction LLM calls (see core/llm_compat.py). No encryption at rest is applied (like the rest of this collection): the key is never displayed in clear text again, only masked.",
    groqEnvOverrideNotice: "A GROQ_API_KEY environment variable is already set on the server — it always takes precedence over the value saved here as long as it remains present.",
    loading: "Loading…",
    currentKey: "Current key",
    noKeyConfigured: "No key configured",
    modelOptional: "Model (optional)",
    newKeyLabel: "New key (leave blank to keep unchanged, or to clear it if you save without entering a new one after clearing this field)",
    saving: "Saving…",
    save: "Save",
    groqKeySaved: "Groq key saved",
    overline: "Platform",
    title: "Settings",
    subtitle: "Identity, platform branding and modular pricing.",
    groqSection: "Groq integration (fast inference)",
    cceGlobalSection: "CCE — Global content (Closures & TwiML)",
    cceRulesSection: "CCE — RULE reconciliation (Realtime/M3)",
    identitySection: "Platform identity",
    name: "Name",
    supportEmail: "Support email",
    termsUrl: "Terms (URL)",
    privacyUrl: "Privacy (URL)",
    settingsSaved: "Settings saved",
    pricingSection: "Module pricing",
    colKey: "Key",
    colName: "Name",
    colPriceMonth: "Price (€/month)",
    priceUpdatedToast: "Price {key} updated",
    seatsSection: "Seat pricing (per role)",
    seatsHint: "The tenant pays this amount for each additional user according to their role. The first OWNER is included in the base pack.",
    colRole: "Role",
    colPricePerSeat: "Price / seat / month",
    permissions: "permissions",
    perMonth: "€/month",
    noTenantRole: "No tenant role",
  },
  adminLatencyDashboards: {
    title: "AI Latency",
    subtitle: "Two distinct call engines, two measurement pipelines — pick the one used by the calls you're inspecting.",
    tabM3: "Realtime / M3 voice (legacy)",
    tabFlow: "Scripted flow (Sprint 14)",
  },
  adminTrialSettings: {
    loadError: "Load error: {err}",
    saveError: "Failed: {err}",
    settingsSaved: "Onboarding settings saved",
    settingsReset: "Settings reset",
    invalidEmail: "Invalid email address",
    alreadyInList: "Already in the list",
    loading: "Loading…",
    overline: "Platform",
    title: "Free trial & signup",
    subtitle: "Control the signup funnel: trial duration, verification link validity, notification recipients, etc.",
    reset: "Reset",
    saving: "Saving…",
    save: "Save",
    upToDate: "Up to date",
    dirtyBanner: "Unpublished changes. Click",
    dirtyBannerSave: "Save",
    trialDurationTitle: "Free trial duration",
    trialDaysLabel: "Trial duration (in days)",
    trialDaysHint: "0 = no trial, immediate subscription required. Recommended: 7 days.",
    lockLabel: "Strict lock at end of trial",
    lockHint: "If enabled: at expiry, billable modules are blocked until subscription. Otherwise, just a warning banner.",
    verificationTitle: "Email verification link",
    verificationTtlLabel: "Link validity (in hours)",
    verificationTtlHint: "Default: 48h. Beyond that, the user must request a new link.",
    autoBookingsTitle: "Automatic booking confirmation",
    autoBookingsLabel: "Enable 100% automatic booking",
    autoBookingsDesc: "When the AI detects a booking (date, slot, party size) AND the customer confirms, the booking is created directly, a recap SMS is sent, and the call ends politely. Without this option: the request goes into the \"Awaiting validation\" queue in the pro's dashboard.",
    autoOrderModeLabel: "Automatic order mode (RESTAURANT + M5)",
    autoOrderModeDesc: ": always active when the tenant has an M5 catalog. To disable it, remove the catalog or disable M5.",
    emailsTitle: "Transactional emails",
    welcomeEmailLabel: "Send welcome email to the OWNER",
    welcomeEmailDesc: "Email sent right after address confirmation, with the next 3 steps.",
    notifyAdminLabel: "Notify the team on every verified signup",
    notifyAdminDesc: "Internal email with the new pro's profile (slug, vertical, contact).",
    recipientEmailsLabel: "Recipient email addresses",
    noEmails: "No address — notifications will not be sent.",
    addEmail: "Add",
    resetConfirmTitle: "Reset to default values?",
    resetConfirmItem: "All the settings above (trial duration, verification TTL, notification emails…) revert to their original value.",
    grantTrialTitle: "Grant a free trial to an establishment",
    grantTrialDesc: "Does not change the global setting above. Use case-by-case to convince a hesitant prospect — the trial isn't granted by default.",
    grantTrialSearchLabel: "Search for an establishment",
    grantTrialSearchPlaceholder: "Name, slug, or email…",
    grantTrialSearching: "Searching…",
    grantTrialNoResults: "No establishment found.",
    grantTrialDaysLabel: "Trial length to grant (days)",
    grantTrialButton: "Grant trial",
    grantTrialGranting: "Granting…",
    grantTrialSuccess: "{days}-day trial granted to {tenant} (until {date})",
    grantTrialError: "Failed: {err}",
    grantTrialAlreadyPaying: "This tenant already has an active paid subscription.",
    grantTrialSelected: "Selected establishment",
    grantTrialChangeSelection: "Change",
    grantTrialCurrentStatus: "Current status: {status}{trial}",
    grantTrialCurrentTrialSuffix: " (trial until {date})",
  },
  adminVerticalConfig: {
    title: "Verticals & AI",
    subtitle: "Business registry, assistant tone and conversation flow — the three settings configured together for a given business type.",
    tabVerticals: "Verticals",
    tabPersonas: "AI personas",
    tabPlaybooks: "AI playbooks",
  },
  adminLegal: {
    docTerms: "Terms",
    docPrivacy: "Privacy Policy",
    docLegalNotice: "Legal Notice",
    docCookies: "Cookie Policy",
    noChanges: "No changes to save",
    templatesUpdated: "Templates updated",
    configUpdated: "GDPR configuration updated",
    templatesReset: "Templates reset",
    overline: "Platform",
    title: "GDPR compliance & legal documents",
    subtitle: "Templates and retention periods per vertical. Tenants view; only the Super Admin edits.",
    loading: "Loading…",
    gdprConfig: "GDPR configuration",
    medicalVertical: "Medical vertical",
    retentionYears: "Retention period (years)",
    pseudonymizeTitle: "Pseudonymisation by default",
    pseudonymizeDesc: "AI conversations don't send names to processors.",
    consentTitle: "Explicit consent logged",
    consentDesc: "Every customer consent is logged (recommended for healthcare).",
    autoAnonTitle: "Automatic anonymisation after expiry",
    autoAnonDesc: "Periodic purge of expired data.",
    saveConfig: "Save configuration",
    variablesAvailable: "Available variables:",
    resetFactory: "Factory reset",
    saveTemplates: "Save templates",
    resetConfirmTitle: "Reset all templates to factory defaults?",
    resetConfirmItem: "Any customisation made to this vertical's templates will be lost.",
    reset: "Reset",
  },
  adminVerticalPersonas: {
    fieldRoleIntro: "Role & posture",
    fieldRoleIntroHint: "Description of the agent's role and tone. 2-3 sentences.",
    fieldVocabulary: "Business vocabulary",
    fieldVocabularyHint: "Terms specific to the vertical (e.g. order/appointment/session).",
    fieldWorkflow: "Workflow",
    fieldWorkflowHint: "Numbered flow steps (taking an order, booking an appointment…).",
    fieldDomainRules: "Business rules",
    fieldDomainRulesHint: "Vertical-specific rules (domain anti-hallucination, duration, format…).",
    fieldRecapFormat: "Recap format",
    fieldRecapFormatHint: "How the agent should recap before confirmation.",
    fieldForbidden: "Prohibitions",
    fieldForbiddenHint: "Behaviours strictly forbidden for this vertical.",
    loadError: "Load error",
    genericError: "Error",
    saveError: "Save error",
    personaSaved: "Persona saved — active for all tenants of the vertical",
    defaultsRestored: "Defaults restored",
    overline: "Super Admin",
    title: "AI personas — verticals",
    subtitle: "Layer 1 of the Dual-Level AI Specialization system. Each persona defines the base behaviour of the AI agent for ALL tenants of a vertical. Your overrides apply immediately, no deployment needed.",
    custom: "Custom",
    pickVertical: "Select a vertical on the left to edit its persona.",
    loading: "Loading…",
    hasOverride: "This vertical has an active override in the database.",
    noOverride: "No customisation — the agent follows the code's default values.",
    hideDefaults: "Hide defaults",
    showDefaults: "Show defaults",
    restoreDefaults: "Restore defaults",
    saving: "Saving…",
    save: "Save",
    warningBanner: "Any change applies {rt} to all tenants of this vertical. No deployment is required.",
    realTime: "in real time",
    modified: "modified",
    restoreField: "Restore this field",
    defaultValueCode: "Default value (code)",
    cceCardTitle: "CCE (content measured in parallel — shadow only)",
    resetConfirmTitle: "Restore default values for {label}?",
    resetConfirmItem: "Any customisation made to this persona will be deleted.",
    restore: "Restore",
  },
  pricing: {
    loadError: "Unable to load pricing",
    stripeUnavailable: "Stripe link unavailable",
    stripeError: "Stripe error",
    back: "← Back",
    heroOverline: "Transparent pricing · no surprises",
    heroTitleStart: "A plan for every",
    heroTitleEm: "need",
    heroSubtitle: "All plans include 24/7 phone AI, your dedicated French Twilio number, the real-time dashboard and GDPR-compliant European hosting. No commitment, cancel anytime.",
    roiCta: "Calculate my ROI in 30 seconds",
    subscriptionOverline: "Subscription",
    subscriptionTitle: "Choose your plan.",
    subscriptionSubtitle: "No commitment. Start within 48h. Change or cancel whenever you want.",
    legacyOverline: "Legacy plans (internal)",
    voiceTiersOverline: "AI voice tiers",
    voiceTiersTitle: "Choose your assistant's voice.",
    voiceTiersSubtitle: "Automatic fallback: if the Premium voice becomes unavailable, the call falls back to Pro then Standard. Your customers will never hit silence.",
    included: "Included",
    perMonth: "/month",
    perMinute: "/min",
    usageBilledSeparately: "usage (debited from prepaid balance)",
    setupFee: "setup fee",
    optionsOverline: "À la carte options",
    optionsTitle: "Add what you need, when you need it.",
    footerTitle: "Not sure which plan to choose?",
    footerSubtitle: "Describe your business in two sentences — we'll recommend the best-fit plan and a personalised quote within 24h.",
    requestQuote: "Request a quote",
    recommended: "Recommended",
    htPerMonth: "excl. tax / month",
    choose: "Choose",
    invalidEmail: "Invalid email",
    genericError: "Error",
    quoteSent: "Request sent ✓ We'll get back to you within 24h.",
    sendError: "Error while sending",
    requestQuoteFor: "Request a quote — {name}",
    htPerMonthShort: "€ excl. tax / month · reply within 24h",
    personalizedResponse: "Personalised reply within 24h.",
    nameOptional: "Name (optional)",
    email: "Email *",
    activityType: "Business type",
    selectPlaceholder: "— Select —",
    vRestaurant: "Restaurant",
    vHairdresser: "Hairdresser / Barber",
    vDoctor: "Doctor / Practice",
    vEsthetics: "Beautician",
    vPhysio: "Physiotherapist",
    vVet: "Veterinarian",
    vOther: "Other",
    describeNeed: "Describe your need (optional)",
    describeNeedPlaceholder: "How many calls per day, team size…",
    sendRequest: "Send my request",
    setupFeeOneShot: "setup fee (one-time)",
    subscribe: "Subscribe —",
    perMonthShort: "€/month",
    noCommitment: "No commitment · Cancel anytime",
  },
  verifyEmail: {
    invalidLink: "Invalid link: missing token.",
    alreadyVerified: "Address already confirmed. Welcome back!",
    confirmed: "Address confirmed. Your trial is open.",
    validating: "Validating link…",
    successOverline: "Welcome",
    successTitle: "Your account is ready",
    redirecting: "Automatically redirecting to your dashboard…",
    checklistVerified: "Account and email verified",
    checklistSetup: "Setting up your AI assistant…",
    checklistNumber: "Dedicated phone number",
    errorOverline: "Invalid link",
    expiredHint: "The link may have expired (48h) or already been used.",
    login: "Log in",
    recreateAccount: "Create a new account",
  },
  adminVerticals: {
    overline: "Platform",
    title: "Verticals",
    subtitle: "Each vertical defines the default modules and business rules applied to new establishments.",
    newVertical: "New vertical",
    colKey: "Key",
    colNameFr: "FR name",
    colNameEn: "EN name",
    colDefaultModules: "Default modules",
    colMedical: "Medical",
    colActions: "Actions",
    yes: "Yes",
    detail: "Detail",
    edit: "Edit",
    delete: "Delete",
    emptyTitle: "No verticals",
    emptyDescription: "Create the first business vertical (restaurant, hairdresser, doctor…) to categorize your establishments.",
    editTitle: "Edit {key}",
    keyLabel: "Key",
    medicalMode: "Medical mode (enhanced GDPR)",
    nameFrLabel: "FR name",
    nameEnLabel: "EN name",
    activeModules: "Active default modules",
    cancel: "Cancel",
    save: "Save",
    create: "Create",
    deleteConfirmTitle: "Delete vertical {key}?",
    deleteConfirmItem: "Existing tenants using this vertical will not be deleted, but their reference business will disappear.",
    deleteConfirmLabel: "Delete",
    toastUpdated: "Vertical updated",
    toastCreated: "Vertical created",
    toastDeleted: "Vertical deleted",
    placeholderKey: "E.G.: NOTARY",
  },
  adminTenants: {
    toastStatusUpdated: "Status updated",
    toastDeletedPrefix: "Establishment deleted. Stripe: ",
    toastDeletedCanceled: "canceled",
    toastDeletedNA: "n/a",
    toastDeletedSuffix: " · {count} invoice(s) anonymized.",
    toastImpersonate: "Logged in as {name}",
    toastCreated: "Establishment created",
    overline: "Platform",
    title: "Establishments",
    filteredBy: "Filtered by status: ",
    remove: "remove",
    searchPlaceholder: "Search…",
    statusPlaceholder: "Status",
    statusAll: "All",
    statusPending: "Pending",
    statusActive: "Active",
    statusSuspended: "Suspended",
    newTenant: "New establishment",
    reload: "Reload",
    colTenant: "Establishment",
    colSlug: "Slug",
    colVertical: "Vertical",
    colStatus: "Status",
    colModules: "Modules",
    colActions: "Actions",
    emptyTitle: "No establishments",
    emptyDescription: "Create your first establishment to get started, or wait for a self-service signup.",
    deletedName: "DELETED",
    deletedOn: "Deleted on {date} by {role}",
    badgeDeleted: "Deleted",
    badgeActive: "Active",
    badgePending: "Pending",
    badgeSuspended: "Suspended",
    detail: "Detail",
    impersonateAction: "Log in as",
    activate: "Activate",
    suspend: "Suspend",
    delete: "Delete",
    createTitle: "New establishment",
    formName: "Name",
    formSlug: "Slug",
    formVertical: "Vertical",
    formChoose: "Choose",
    formOwnerEmail: "Owner e-mail",
    formPhone: "Phone",
    formOwnerName: "Owner name",
    formPassword: "Password",
    cancel: "Cancel",
    create: "Create",
    impersonateTitle: "Log in as {name}",
    impersonateDescLine1: "You are about to take control of this tenant with",
    impersonateDescStrong: "read + write",
    impersonateDescLine2: "access. Any action you take will be logged and attributed to your SUPER_ADMIN account.",
    impersonateDescLine3: "Exit impersonation at any time from the orange banner at the top of the screen.",
    confirm: "Confirm",
    deleteTitle: "Permanently delete “{slug}”?",
    deleteItem1: "Cancels the Stripe subscription (only the current month is charged).",
    deleteItem2: "Deletes all users, orders, calls, catalog, appointments.",
    deleteItem3: "Anonymizes invoices (kept for 10 years by legal obligation).",
    deleteItem4: "Releases the Twilio number.",
    deleteItem5: "Sends a confirmation e-mail to the owner.",
    typeToConfirm: "Type {slug} to confirm",
    deleteReasonLabel: "Reason for deletion (GDPR audit, required)",
    deleteReasonPlaceholder: "Choose a reason…",
    reasonFraud: "Fraud",
    reasonTos: "Terms of service violation",
    reasonGdpr: "GDPR request (right to erasure)",
    reasonOther: "Other",
    deleting: "Deleting…",
    deletePermanently: "Delete permanently",
    voiceDistTitle: "AI Voice Distribution",
    loading: "Loading…",
    voiceDistSubtitle: "Breakdown of tenants by TTS stack and estimated MRR",
    voiceMrr: "Voice MRR",
    tenantsTotal: "{count} tenant{s} total",
    noTenant: "No tenants",
    tenantWord: "tenant",
    perMonth: "/month",
    mrrLabel: "MRR: ",
  },
  adminFlowEditorV2: {
    toastGraphValid: "Graph valid",
    toastValidationError: "Validation error",
    toastGraphSaved: "Graph saved",
    toastErrorsDetail: "{count} error(s) — see details",
    toastSaveError: "Save error",
    toastGraphDeleted: "Graph deleted",
    toastGenericError: "Error",
    toastVersionRestored: "Version {version} restored",
    toastRestoreError: "Restore error",
    toastInvalidFacts: "Invalid JSON facts: {error}",
    toastJsonApplied: "JSON applied to diagram",
    invalidJson: "Invalid JSON: {error}",
    backHome: "Back to admin home",
    home: "Home",
    choosePlaceholder: "Choose a vertical",
    newBadge: "new",
    entryLabel: "Entry",
    history: "History",
    simulate: "Simulate",
    json: "JSON",
    validating: "Validating…",
    validate: "Validate",
    deleteGraphAria: "Delete scripted graph",
    saving: "Saving…",
    save: "Save",
    tabGraph: "Graph",
    tabPhrases: "Phrases",
    tabAudio: "Audio",
    tabFiller: "Filler",
    validationErrorsCount: "{count} validation error(s)",
    chooseVerticalHint: "Choose a vertical at the top left to open its conversation graph.",
    loading: "Loading…",
    graphJsonLabel: "Graph (JSON)",
    applyToDiagram: "Apply to diagram",
    versionHistoryLabel: "Version history",
    noArchivedVersion: "No archived version yet.",
    historyMeta: "{count} node(s) · {by} · {date}",
    restore: "Restore",
    simulateBranchLabel: "Simulate a branch",
    fromOption: "from…",
    noEdgeFromNode: "No edge leaves this node.",
    triggered: "✓ triggered",
    deleteGraphTitle: "Delete the scripted graph for {vertical}?",
    deleteGraphItem: "The tenant will fall back to Realtime alone (no more guided script for this vertical).",
    delete: "Delete",
    restoreVersionTitle: "Restore version {version}?",
    restoreVersionItem: "This creates a NEW version reusing this old content — the current history is not lost.",
    reloadDefaults: "Reload defaults",
    reloadingDefaults: "Reloading…",
    reloadDefaultsAria: "Reload this vertical's default graph and phrases",
    reloadDefaultsTitle: "Reload defaults for {vertical}?",
    reloadDefaultsItem: "This vertical's graph and phrases will be replaced by the latest default version shipped by the tech team. Any customization made from the editor for this vertical will be overwritten — a new version is created (nothing is lost, you can restore the previous one from History).",
    toastDefaultsReloaded: "Defaults reloaded",
    toastReloadDefaultsError: "Error reloading defaults",
    toastReloadDefaultsUnavailable: "No default template is available for this vertical.",
  },
  adminTenantDetail: {
    sectionInfo: "Info",
    sectionModules: "Modules",
    sectionTelephony: "Telephony",
    sectionUsers: "Users",
    sectionOrders: "Orders",
    sectionBookings: "Bookings",
    sectionConversations: "Conversations",
    sectionCrte: "CRTE",
    sectionCce: "CCE",
    sectionAudit: "Audit",
    allEstablishments: "All establishments",
    overline: "Establishment · {vertical}",
    badgeActive: "Active",
    badgePending: "Pending",
    badgeSuspended: "Suspended",
    activate: "Activate",
    suspend: "Suspend",
    printOnboarding: "🖨️ Print onboarding pack",
    printContract: "📄 Print contract",
    billingDetail: "Detailed billing",
    viewAudit: "View audit",
    publicPage: "Public page",
    delete: "Delete",
    infoTitle: "Information",
    fieldVertical: "Vertical",
    fieldEmail: "E-mail",
    fieldPhone: "Phone",
    fieldCountry: "Country",
    fieldTimezone: "Timezone",
    fieldLanguage: "Default language",
    fieldCurrency: "Currency",
    fieldCreatedAt: "Created on",
    fieldAddress: "Address",
    modulesActive: "Active modules ({count}/9)",
    telephonySms: "Telephony & SMS (M2)",
    usersCount: "Users ({count})",
    addUser: "Add a user",
    colName: "Name",
    colEmail: "E-mail",
    colRole: "Role",
    colStatus: "Status",
    colPassword: "Password",
    badgeTemporary: "Temporary",
    ok: "OK",
    noUser: "No users",
    crteTitle: "CRTE — Conversational guardrails (shadow mode)",
    cceTitle: "CCE — Conversational content (Greeting)",
    greetingLabel: "Greeting phrase",
    auditRecent: "Recent audit ({count})",
    colDate: "Date",
    colAction: "Action",
    colResource: "Resource",
    noEvent: "No events",
    deleteTenantTitle: "Permanently delete this tenant?",
    deleteTenantItem1: "All tenant data (orders, bookings, conversations, config) will be lost.",
    deleteTenantItem2: "This action is irreversible.",
    toastStatusChanged: "Status → {status}",
    toastDeleted: "Deleted",
    loading: "Loading…",
    tenantNotFound: "Tenant not found",
    slugUrlPublic: "Slug (public URL)",
    editSlugAria: "Edit the slug",
    saveSlugAria: "Save the slug",
    cancelSlugAria: "Cancel slug edit",
    checking: "Checking…",
    available: "✓ Available",
    slugTaken: "✗ Slug already taken",
    typeToCheck: "Type ≥ 3 characters to check",
    formerSlugs: "· Former: ",
    toastSlugRenamed: "Slug renamed → /p/{slug}",
    toastPlaybookReset: "AI Playbook reset — tenant reverts to vertical default",
    toastNoOverrides: "The tenant had no customization — nothing to remove",
    playbookResetTitle: "AI Playbook — Reset to vertical default",
    playbookResetDescription: "Removes all overrides (added steps, disabled steps) this tenant applied to its AI Playbook. The tenant reverts to its vertical's standard playbook. Action logged in the audit log.",
    overridesDeleted: "Overrides removed ({count} document)",
    noOverridesToDelete: "No overrides to remove",
    reset: "Reset",
    resetPlaybookTitle: "Reset this tenant's AI Playbook?",
    resetPlaybookItem1: "All customized steps and exclusions will be lost.",
    resetPlaybookItem2: "The tenant reverts to its vertical's standard playbook.",
    resetPlaybookItem3: "This action is logged in the audit.",
  },
};

export const translations = { fr, en };

